
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire78e9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire78e9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("guAL2", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $c01bf5ff95f0f4d3$export$e926676385687eaf);

var $9zTQv = parcelRequire("9zTQv");
var $6Mb9x = parcelRequire("6Mb9x");

var $aieBB = parcelRequire("aieBB");

var $1v5pe = parcelRequire("1v5pe");

var $kQvwI = parcelRequire("kQvwI");

var $d1Mmt = parcelRequire("d1Mmt");

var $dbp1a = parcelRequire("dbp1a");
const $c01bf5ff95f0f4d3$export$6ef4c0367e27f2d5 = 'unknown';
const $c01bf5ff95f0f4d3$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
/**
 * A ErrorBoundary component that logs errors to Sentry.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $c01bf5ff95f0f4d3$export$e926676385687eaf extends $1v5pe.Component {
    constructor(props){
        super(props);
        this.state = $c01bf5ff95f0f4d3$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $9zTQv.getClient)();
        if (client && props.showDialog) {
            this._openFallbackReportDialog = false;
            this._cleanupHook = client.on('afterSendEvent', (event)=>{
                if (!event.type && this._lastEventId && event.event_id === this._lastEventId) (0, $6Mb9x.showReportDialog)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, errorInfo) {
        const { componentStack: componentStack } = errorInfo;
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $9zTQv.withScope)((scope)=>{
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const handled = this.props.handled != null ? this.props.handled : !!this.props.fallback;
            const eventId = (0, $d1Mmt.captureReactException)(error, errorInfo, {
                mechanism: {
                    handled: handled
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $6Mb9x.showReportDialog)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) {
            if (this.state === $c01bf5ff95f0f4d3$var$INITIAL_STATE) // If the error boundary never encountered an error, call onUnmount with null values
            onUnmount(null, null, null);
            else // `componentStack` and `eventId` are guaranteed to be non-null here because `onUnmount` is only called
            // when the error boundary has already encountered an error.
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onUnmount(error, componentStack, eventId);
        }
        if (this._cleanupHook) {
            this._cleanupHook();
            this._cleanupHook = undefined;
        }
    }
    resetErrorBoundary() {
        const { onReset: onReset } = this.props;
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        if (onReset) // `componentStack` and `eventId` are guaranteed to be non-null here because `onReset` is only called
        // when the error boundary has already encountered an error.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        onReset(error, componentStack, eventId);
        this.setState($c01bf5ff95f0f4d3$var$INITIAL_STATE);
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        // `componentStack` is only null in the initial state, when no error has been captured.
        // If an error has been captured, `componentStack` will be a string.
        // We cannot check `state.error` because null can be thrown as an error.
        if (state.componentStack === null) return typeof children === 'function' ? children() : children;
        const element = typeof fallback === 'function' ? $1v5pe.createElement(fallback, {
            error: state.error,
            componentStack: state.componentStack,
            resetError: ()=>this.resetErrorBoundary(),
            eventId: state.eventId
        }) : fallback;
        if ($1v5pe.isValidElement(element)) return element;
        if (fallback) (0, $kQvwI.DEBUG_BUILD) && (0, $aieBB.logger).warn('fallback did not produce a valid ReactElement');
        // Fail gracefully if no fallback provided or is not valid
        return null;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c01bf5ff95f0f4d3$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $c01bf5ff95f0f4d3$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$1v5pe.createElement($c01bf5ff95f0f4d3$export$e926676385687eaf, {
            ...errorBoundaryOptions
        }, $1v5pe.createElement(WrappedComponent, {
            ...props
        }));
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, $dbp1a.hoistNonReactStatics)(Wrapped, WrappedComponent);
    return Wrapped;
}

});
parcelRegister("9zTQv", function(module, exports) {
$parcel$export(module.exports, "getCurrentScope", () => $6f92b3c75c686afd$export$c7be4b0125a10cba);
$parcel$export(module.exports, "getIsolationScope", () => $6f92b3c75c686afd$export$68f3af03034c9e90);
$parcel$export(module.exports, "getGlobalScope", () => $6f92b3c75c686afd$export$aa55d5ab8e05984f);
$parcel$export(module.exports, "withScope", () => $6f92b3c75c686afd$export$ec58d9285c204497);
$parcel$export(module.exports, "withIsolationScope", () => $6f92b3c75c686afd$export$9a4fed82c350c2bd);
$parcel$export(module.exports, "getClient", () => $6f92b3c75c686afd$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "getTraceContextFromScope", () => $6f92b3c75c686afd$export$1e83db7ee4876dc4);

var $3fv0k = parcelRequire("3fv0k");

var $k8rSc = parcelRequire("k8rSc");

var $40qI7 = parcelRequire("40qI7");

var $gaILw = parcelRequire("gaILw");
/**
 * Get the currently active scope.
 */ function $6f92b3c75c686afd$export$c7be4b0125a10cba() {
    const carrier = (0, $k8rSc.getMainCarrier)();
    const acs = (0, $3fv0k.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $6f92b3c75c686afd$export$68f3af03034c9e90() {
    const carrier = (0, $k8rSc.getMainCarrier)();
    const acs = (0, $3fv0k.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $6f92b3c75c686afd$export$aa55d5ab8e05984f() {
    return (0, $k8rSc.getGlobalSingleton)('globalScope', ()=>new (0, $40qI7.Scope)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $6f92b3c75c686afd$export$ec58d9285c204497(...rest) {
    const carrier = (0, $k8rSc.getMainCarrier)();
    const acs = (0, $3fv0k.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $6f92b3c75c686afd$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $k8rSc.getMainCarrier)();
    const acs = (0, $3fv0k.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $6f92b3c75c686afd$export$6bb76d6eba7e258c() {
    return $6f92b3c75c686afd$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $6f92b3c75c686afd$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $gaILw.generateSpanId)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}

});
parcelRegister("3fv0k", function(module, exports) {
$parcel$export(module.exports, "getAsyncContextStrategy", () => $25dad29df72147c0$export$f639b0c2752203be);

var $k8rSc = parcelRequire("k8rSc");

var $fRtAI = parcelRequire("fRtAI");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $25dad29df72147c0$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $k8rSc.getMainCarrier)();
    const sentry = (0, $k8rSc.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $25dad29df72147c0$export$f639b0c2752203be(carrier) {
    const sentry = (0, $k8rSc.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $fRtAI.getStackAsyncContextStrategy)();
}

});
parcelRegister("k8rSc", function(module, exports) {
$parcel$export(module.exports, "getMainCarrier", () => $ea8a2d08ec7a42cc$export$19eade501500c6c1);
$parcel$export(module.exports, "getSentryCarrier", () => $ea8a2d08ec7a42cc$export$c8bfa33e4e8ae492);
$parcel$export(module.exports, "getGlobalSingleton", () => $ea8a2d08ec7a42cc$export$7e223ec222791509);

var $gQ8Cj = parcelRequire("gQ8Cj");

var $gflYe = parcelRequire("gflYe");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $ea8a2d08ec7a42cc$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $ea8a2d08ec7a42cc$export$c8bfa33e4e8ae492((0, $gflYe.GLOBAL_OBJ));
    return 0, $gflYe.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $ea8a2d08ec7a42cc$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $gQ8Cj.SDK_VERSION);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $gQ8Cj.SDK_VERSION] = __SENTRY__[0, $gQ8Cj.SDK_VERSION] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $ea8a2d08ec7a42cc$export$7e223ec222791509(name, creator, obj = (0, $gflYe.GLOBAL_OBJ)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $gQ8Cj.SDK_VERSION] = __SENTRY__[0, $gQ8Cj.SDK_VERSION] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}

});
parcelRegister("gQ8Cj", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", () => $c4282fd2521dafb5$export$31499a9cd224b78c);
// This is a magic string replaced by rollup
const $c4282fd2521dafb5$export$31499a9cd224b78c = "9.25.1";

});

parcelRegister("gflYe", function(module, exports) {
$parcel$export(module.exports, "GLOBAL_OBJ", () => $bd3f16edbdbb8ca3$export$f1a6cdb1459e81d1);
/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $bd3f16edbdbb8ca3$export$f1a6cdb1459e81d1 = globalThis;

});


parcelRegister("fRtAI", function(module, exports) {
$parcel$export(module.exports, "getStackAsyncContextStrategy", () => $b8c2c2762a8e4348$export$329d4d4d54e42710);

var $aXQDJ = parcelRequire("aXQDJ");

var $40qI7 = parcelRequire("40qI7");

var $5hnoa = parcelRequire("5hnoa");

var $k8rSc = parcelRequire("k8rSc");
/**
 * This is an object that holds a stack of scopes.
 */ class $b8c2c2762a8e4348$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $40qI7.Scope)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $40qI7.Scope)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $5hnoa.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $b8c2c2762a8e4348$var$getAsyncContextStack() {
    const registry = (0, $k8rSc.getMainCarrier)();
    const sentry = (0, $k8rSc.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new $b8c2c2762a8e4348$export$d36ec451f120cfba((0, $aXQDJ.getDefaultCurrentScope)(), (0, $aXQDJ.getDefaultIsolationScope)());
}
function $b8c2c2762a8e4348$var$withScope(callback) {
    return $b8c2c2762a8e4348$var$getAsyncContextStack().withScope(callback);
}
function $b8c2c2762a8e4348$var$withSetScope(scope, callback) {
    const stack = $b8c2c2762a8e4348$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $b8c2c2762a8e4348$var$withIsolationScope(callback) {
    return $b8c2c2762a8e4348$var$getAsyncContextStack().withScope(()=>{
        return callback($b8c2c2762a8e4348$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $b8c2c2762a8e4348$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $b8c2c2762a8e4348$var$withIsolationScope,
        withScope: $b8c2c2762a8e4348$var$withScope,
        withSetScope: $b8c2c2762a8e4348$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $b8c2c2762a8e4348$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$b8c2c2762a8e4348$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$b8c2c2762a8e4348$var$getAsyncContextStack().getIsolationScope()
    };
}

});
parcelRegister("aXQDJ", function(module, exports) {
$parcel$export(module.exports, "getDefaultCurrentScope", () => $7fb83f3bb272f362$export$6f1b9191db9c4d5);
$parcel$export(module.exports, "getDefaultIsolationScope", () => $7fb83f3bb272f362$export$de9862929b76bf57);

var $k8rSc = parcelRequire("k8rSc");

var $40qI7 = parcelRequire("40qI7");
/** Get the default current scope. */ function $7fb83f3bb272f362$export$6f1b9191db9c4d5() {
    return (0, $k8rSc.getGlobalSingleton)('defaultCurrentScope', ()=>new (0, $40qI7.Scope)());
}
/** Get the default isolation scope. */ function $7fb83f3bb272f362$export$de9862929b76bf57() {
    return (0, $k8rSc.getGlobalSingleton)('defaultIsolationScope', ()=>new (0, $40qI7.Scope)());
}

});
parcelRegister("40qI7", function(module, exports) {
$parcel$export(module.exports, "Scope", () => $2eabe1b0eaa434f0$export$775b6bb06e53a214);

var $4fgW6 = parcelRequire("4fgW6");

var $7t9x6 = parcelRequire("7t9x6");

var $kh78x = parcelRequire("kh78x");

var $5hnoa = parcelRequire("5hnoa");

var $aieBB = parcelRequire("aieBB");

var $84KxT = parcelRequire("84KxT");

var $gaILw = parcelRequire("gaILw");

var $j5FsG = parcelRequire("j5FsG");

var $a2WQ6 = parcelRequire("a2WQ6");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $2eabe1b0eaa434f0$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $2eabe1b0eaa434f0$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $gaILw.generateTraceId)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $2eabe1b0eaa434f0$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $kh78x._setSpanForScope)(newScope, (0, $kh78x._getSpanForScope)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $4fgW6.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $2eabe1b0eaa434f0$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $5hnoa.isPlainObject)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $kh78x._setSpanForScope)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $gaILw.generateTraceId)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $2eabe1b0eaa434f0$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $a2WQ6.dateTimestampInSeconds)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $j5FsG.truncate)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $kh78x._getSpanForScope)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $7t9x6.merge)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $84KxT.uuid4)();
        if (!this._client) {
            (0, $aieBB.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $84KxT.uuid4)();
        if (!this._client) {
            (0, $aieBB.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $84KxT.uuid4)();
        if (!this._client) {
            (0, $aieBB.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}

});
parcelRegister("4fgW6", function(module, exports) {
$parcel$export(module.exports, "makeSession", () => $3175b3511145fe6a$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $3175b3511145fe6a$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $3175b3511145fe6a$export$56521d9ba90f62ee);

var $84KxT = parcelRequire("84KxT");

var $a2WQ6 = parcelRequire("a2WQ6");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $3175b3511145fe6a$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $a2WQ6.timestampInSeconds)();
    const session = {
        sid: (0, $84KxT.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$3175b3511145fe6a$var$sessionToJSON(session)
    };
    if (context) $3175b3511145fe6a$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $3175b3511145fe6a$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $a2WQ6.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $84KxT.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $3175b3511145fe6a$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $3175b3511145fe6a$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $3175b3511145fe6a$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}

});
parcelRegister("84KxT", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $5e12cd74f0be5e24$export$19f53698e68b2496);
$parcel$export(module.exports, "getEventDescription", () => $5e12cd74f0be5e24$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $5e12cd74f0be5e24$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $5e12cd74f0be5e24$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $5e12cd74f0be5e24$export$6de4ffac6a2f1098);

var $2bu2L = parcelRequire("2bu2L");

var $j5FsG = parcelRequire("j5FsG");

var $gflYe = parcelRequire("gflYe");
function $5e12cd74f0be5e24$var$getCrypto() {
    const gbl = (0, $gflYe.GLOBAL_OBJ);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $5e12cd74f0be5e24$export$19f53698e68b2496(crypto = $5e12cd74f0be5e24$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $5e12cd74f0be5e24$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $5e12cd74f0be5e24$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $5e12cd74f0be5e24$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $5e12cd74f0be5e24$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $5e12cd74f0be5e24$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $5e12cd74f0be5e24$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $5e12cd74f0be5e24$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $5e12cd74f0be5e24$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $5e12cd74f0be5e24$export$d364f2020ab30578(input) {
    const match = input.match($5e12cd74f0be5e24$var$SEMVER_REGEXP) || [];
    const major = $5e12cd74f0be5e24$var$_parseInt(match[1]);
    const minor = $5e12cd74f0be5e24$var$_parseInt(match[2]);
    const patch = $5e12cd74f0be5e24$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $5e12cd74f0be5e24$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $j5FsG.snipLine)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $j5FsG.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $j5FsG.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $5e12cd74f0be5e24$export$6de4ffac6a2f1098(exception) {
    if ($5e12cd74f0be5e24$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $2bu2L.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $5e12cd74f0be5e24$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}

});
parcelRegister("2bu2L", function(module, exports) {
$parcel$export(module.exports, "fill", () => $1973e9dfa96db044$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $1973e9dfa96db044$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $1973e9dfa96db044$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $1973e9dfa96db044$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "convertToPlainObject", () => $1973e9dfa96db044$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $1973e9dfa96db044$export$b0244d5063c0b61b);

var $dYTLo = parcelRequire("dYTLo");

var $68KEs = parcelRequire("68KEs");

var $5hnoa = parcelRequire("5hnoa");

var $aieBB = parcelRequire("aieBB");

var $j5FsG = parcelRequire("j5FsG");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $1973e9dfa96db044$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $1973e9dfa96db044$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $1973e9dfa96db044$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $1973e9dfa96db044$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $1973e9dfa96db044$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $1973e9dfa96db044$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $1973e9dfa96db044$export$62ff257738bf57f5(value) {
    if ((0, $5hnoa.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$1973e9dfa96db044$var$getOwnProperties(value)
    };
    else if ((0, $5hnoa.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $1973e9dfa96db044$var$serializeEventTarget(value.target),
            currentTarget: $1973e9dfa96db044$var$serializeEventTarget(value.currentTarget),
            ...$1973e9dfa96db044$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $5hnoa.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $1973e9dfa96db044$var$serializeEventTarget(target) {
    try {
        return (0, $5hnoa.isElement)(target) ? (0, $68KEs.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $1973e9dfa96db044$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $1973e9dfa96db044$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($1973e9dfa96db044$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $j5FsG.truncate)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $j5FsG.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $1973e9dfa96db044$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $1973e9dfa96db044$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $1973e9dfa96db044$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($1973e9dfa96db044$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($1973e9dfa96db044$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $1973e9dfa96db044$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $1973e9dfa96db044$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $1973e9dfa96db044$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $5hnoa.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("dYTLo", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $a2dc2263758ce837$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $a2dc2263758ce837$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("68KEs", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $4787ad7b5923a030$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $4787ad7b5923a030$export$1cfafeee2987818b);
$parcel$export(module.exports, "getComponentName", () => $4787ad7b5923a030$export$26727cfcc4d7e0fc);

var $5hnoa = parcelRequire("5hnoa");

var $gflYe = parcelRequire("gflYe");
const $4787ad7b5923a030$var$WINDOW = (0, $gflYe.GLOBAL_OBJ);
const $4787ad7b5923a030$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $4787ad7b5923a030$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $4787ad7b5923a030$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $4787ad7b5923a030$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $4787ad7b5923a030$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($4787ad7b5923a030$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $5hnoa.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $4787ad7b5923a030$export$1cfafeee2987818b() {
    try {
        return $4787ad7b5923a030$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $4787ad7b5923a030$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$4787ad7b5923a030$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

});
parcelRegister("5hnoa", function(module, exports) {
$parcel$export(module.exports, "isError", () => $3d80aed17df483fd$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $3d80aed17df483fd$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $3d80aed17df483fd$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $3d80aed17df483fd$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $3d80aed17df483fd$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $3d80aed17df483fd$export$844ec244b1367d54);
$parcel$export(module.exports, "isParameterizedString", () => $3d80aed17df483fd$export$dbcbffa59149b824);
$parcel$export(module.exports, "isPrimitive", () => $3d80aed17df483fd$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $3d80aed17df483fd$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $3d80aed17df483fd$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $3d80aed17df483fd$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $3d80aed17df483fd$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $3d80aed17df483fd$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $3d80aed17df483fd$export$bc2894c7158efbac);
$parcel$export(module.exports, "isVueViewModel", () => $3d80aed17df483fd$export$7916fad0ebc23f48);
$parcel$export(module.exports, "isRequest", () => $3d80aed17df483fd$export$6d3d1f317d7cda57);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $3d80aed17df483fd$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3d80aed17df483fd$export$e6127cc7fe7395c3(wat) {
    switch($3d80aed17df483fd$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $3d80aed17df483fd$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $3d80aed17df483fd$var$isBuiltin(wat, className) {
    return $3d80aed17df483fd$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3d80aed17df483fd$export$9f9636d330b71954(wat) {
    return $3d80aed17df483fd$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3d80aed17df483fd$export$ef9e2056653f0c8e(wat) {
    return $3d80aed17df483fd$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3d80aed17df483fd$export$12e869b2a583f783(wat) {
    return $3d80aed17df483fd$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3d80aed17df483fd$export$844ec244b1367d54(wat) {
    return $3d80aed17df483fd$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3d80aed17df483fd$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3d80aed17df483fd$export$c3825b437cbdea5c(wat) {
    return wat === null || $3d80aed17df483fd$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3d80aed17df483fd$export$53b83ca8eaab0383(wat) {
    return $3d80aed17df483fd$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3d80aed17df483fd$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $3d80aed17df483fd$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3d80aed17df483fd$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $3d80aed17df483fd$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3d80aed17df483fd$export$49841c62b9eff15(wat) {
    return $3d80aed17df483fd$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $3d80aed17df483fd$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3d80aed17df483fd$export$bc2894c7158efbac(wat) {
    return $3d80aed17df483fd$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $3d80aed17df483fd$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3d80aed17df483fd$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $3d80aed17df483fd$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $3d80aed17df483fd$export$49034edbe6b62415(request, Request);
}

});


parcelRegister("aieBB", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $77e6ea2e79b97634$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $77e6ea2e79b97634$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $77e6ea2e79b97634$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $77e6ea2e79b97634$export$af88d00dbe7f521);

var $k8rSc = parcelRequire("k8rSc");

var $dYTLo = parcelRequire("dYTLo");

var $gflYe = parcelRequire("gflYe");
/** Prefix for logging strings */ const $77e6ea2e79b97634$var$PREFIX = 'Sentry Logger ';
const $77e6ea2e79b97634$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $77e6ea2e79b97634$export$77c4ce905194557b = {};
/** A Sentry Logger instance. */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $77e6ea2e79b97634$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $gflYe.GLOBAL_OBJ))) return callback();
    const console = (0, $gflYe.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($77e6ea2e79b97634$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $77e6ea2e79b97634$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $77e6ea2e79b97634$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $dYTLo.DEBUG_BUILD) $77e6ea2e79b97634$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $77e6ea2e79b97634$export$cda52e2a8927a2ca(()=>{
                (0, $gflYe.GLOBAL_OBJ).console[name](`${$77e6ea2e79b97634$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $77e6ea2e79b97634$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $77e6ea2e79b97634$export$af88d00dbe7f521 = (0, $k8rSc.getGlobalSingleton)('logger', $77e6ea2e79b97634$var$makeLogger);

});

parcelRegister("j5FsG", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $de5ea55e9818a485$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $de5ea55e9818a485$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $de5ea55e9818a485$export$465e9d514283d4fd);
$parcel$export(module.exports, "stringMatchesSomePattern", () => $de5ea55e9818a485$export$a7a5ec66062ea5d);

var $5hnoa = parcelRequire("5hnoa");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $de5ea55e9818a485$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $de5ea55e9818a485$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $de5ea55e9818a485$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $5hnoa.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $de5ea55e9818a485$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $5hnoa.isString)(value)) return false;
    if ((0, $5hnoa.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $5hnoa.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $de5ea55e9818a485$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$de5ea55e9818a485$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("a2WQ6", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => $7507bb91bdd0e614$export$7740643b9eeaf0c4);
$parcel$export(module.exports, "timestampInSeconds", () => $7507bb91bdd0e614$export$ee52dced521e3e18);

var $gflYe = parcelRequire("gflYe");
const $7507bb91bdd0e614$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $7507bb91bdd0e614$export$7740643b9eeaf0c4() {
    return Date.now() / $7507bb91bdd0e614$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $7507bb91bdd0e614$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $gflYe.GLOBAL_OBJ);
    if (!performance?.now) return $7507bb91bdd0e614$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $7507bb91bdd0e614$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $7507bb91bdd0e614$export$ee52dced521e3e18 = $7507bb91bdd0e614$var$createUnixTimestampInSecondsFunc();
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $7507bb91bdd0e614$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $7507bb91bdd0e614$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $gflYe.GLOBAL_OBJ);
    if (!performance?.now) return [
        undefined,
        'none'
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            'timeOrigin'
        ];
        else return [
            navigationStart,
            'navigationStart'
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        'dateNow'
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $7507bb91bdd0e614$export$baf075a948ffc0bf() {
    if (!$7507bb91bdd0e614$var$cachedTimeOrigin) $7507bb91bdd0e614$var$cachedTimeOrigin = $7507bb91bdd0e614$var$getBrowserTimeOrigin();
    return $7507bb91bdd0e614$var$cachedTimeOrigin[0];
}

});


parcelRegister("7t9x6", function(module, exports) {
$parcel$export(module.exports, "merge", () => $5702a2d973e1f995$export$4950aa0f605343fb);
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $5702a2d973e1f995$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $5702a2d973e1f995$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}

});

parcelRegister("kh78x", function(module, exports) {
$parcel$export(module.exports, "_setSpanForScope", () => $ec2aee5f00541f72$export$3f25fa50c18e20ca);
$parcel$export(module.exports, "_getSpanForScope", () => $ec2aee5f00541f72$export$91f063ebb8eff307);

var $2bu2L = parcelRequire("2bu2L");
const $ec2aee5f00541f72$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $ec2aee5f00541f72$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $2bu2L.addNonEnumerableProperty)(scope, $ec2aee5f00541f72$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$ec2aee5f00541f72$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $ec2aee5f00541f72$export$91f063ebb8eff307(scope) {
    return scope[$ec2aee5f00541f72$var$SCOPE_SPAN_FIELD];
}

});

parcelRegister("gaILw", function(module, exports) {
$parcel$export(module.exports, "generateTraceId", () => $bc604e0816958f41$export$dc6d7ea554bcce10);
$parcel$export(module.exports, "generateSpanId", () => $bc604e0816958f41$export$295213bc4d0c54ad);

var $84KxT = parcelRequire("84KxT");
/**
 * Generate a random, valid trace ID.
 */ function $bc604e0816958f41$export$dc6d7ea554bcce10() {
    return (0, $84KxT.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */ function $bc604e0816958f41$export$295213bc4d0c54ad() {
    return (0, $84KxT.uuid4)().substring(16);
}

});






parcelRegister("6Mb9x", function(module, exports) {
$parcel$export(module.exports, "showReportDialog", () => $4eefe0834c4e19a8$export$3a8fd680da42627b);

var $9zTQv = parcelRequire("9zTQv");
var $fJ5mt = parcelRequire("fJ5mt");
var $i38Fr = parcelRequire("i38Fr");
var $aieBB = parcelRequire("aieBB");

var $d70tI = parcelRequire("d70tI");

var $2NPnx = parcelRequire("2NPnx");
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the current scope.
 */ function $4eefe0834c4e19a8$export$3a8fd680da42627b(options = {}) {
    const optionalDocument = (0, $2NPnx.WINDOW).document;
    const injectionPoint = optionalDocument?.head || optionalDocument?.body;
    // doesn't work without a document (React Native)
    if (!injectionPoint) {
        (0, $d70tI.DEBUG_BUILD) && (0, $aieBB.logger).error('[showReportDialog] Global document not defined');
        return;
    }
    const scope = (0, $9zTQv.getCurrentScope)();
    const client = (0, $9zTQv.getClient)();
    const dsn = client?.getDsn();
    if (!dsn) {
        (0, $d70tI.DEBUG_BUILD) && (0, $aieBB.logger).error('[showReportDialog] DSN not configured');
        return;
    }
    const mergedOptions = {
        ...options,
        user: {
            ...scope.getUser(),
            ...options.user
        },
        eventId: options.eventId || (0, $i38Fr.lastEventId)()
    };
    const script = (0, $2NPnx.WINDOW).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $fJ5mt.getReportDialogEndpoint)(dsn, mergedOptions);
    const { onLoad: onLoad, onClose: onClose } = mergedOptions;
    if (onLoad) script.onload = onLoad;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $2NPnx.WINDOW).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $2NPnx.WINDOW).addEventListener('message', reportDialogClosedMessageHandler);
    }
    injectionPoint.appendChild(script);
}

});
parcelRegister("fJ5mt", function(module, exports) {
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $b72f37a9622ae1c0$export$9964600bfe84e6a3);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $b72f37a9622ae1c0$export$671c7ed8e40a7a57);

var $4jD1U = parcelRequire("4jD1U");
const $b72f37a9622ae1c0$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $b72f37a9622ae1c0$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $b72f37a9622ae1c0$var$_getIngestEndpoint(dsn) {
    return `${$b72f37a9622ae1c0$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $b72f37a9622ae1c0$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $b72f37a9622ae1c0$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $b72f37a9622ae1c0$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$b72f37a9622ae1c0$var$_getIngestEndpoint(dsn)}?${$b72f37a9622ae1c0$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $b72f37a9622ae1c0$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $4jD1U.makeDsn)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$b72f37a9622ae1c0$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $4jD1U.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});
parcelRegister("4jD1U", function(module, exports) {
$parcel$export(module.exports, "dsnToString", () => $3247364763f80f21$export$44d472fbb931a776);
$parcel$export(module.exports, "extractOrgIdFromDsnHost", () => $3247364763f80f21$export$5914f4e7748c29c9);
$parcel$export(module.exports, "makeDsn", () => $3247364763f80f21$export$128827c3562ec0cb);

var $dYTLo = parcelRequire("dYTLo");

var $aieBB = parcelRequire("aieBB");
/** Regular expression used to extract org ID from a DSN host. */ const $3247364763f80f21$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $3247364763f80f21$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $3247364763f80f21$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $3247364763f80f21$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $3247364763f80f21$export$b892860177f70a30(str) {
    const match = $3247364763f80f21$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $aieBB.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $3247364763f80f21$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $3247364763f80f21$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $3247364763f80f21$var$validateDsn(dsn) {
    if (!(0, $dYTLo.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $aieBB.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $aieBB.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$3247364763f80f21$var$isValidProtocol(protocol)) {
        (0, $aieBB.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $aieBB.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $3247364763f80f21$export$5914f4e7748c29c9(host) {
    const match = host.match($3247364763f80f21$var$ORG_ID_REGEX);
    return match?.[1];
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $3247364763f80f21$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $3247364763f80f21$export$b892860177f70a30(from) : $3247364763f80f21$var$dsnFromComponents(from);
    if (!components || !$3247364763f80f21$var$validateDsn(components)) return undefined;
    return components;
}

});


parcelRegister("i38Fr", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $d23f3af792a08db7$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $d23f3af792a08db7$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $d23f3af792a08db7$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "setContext", () => $d23f3af792a08db7$export$2f04de43fe27971a);
$parcel$export(module.exports, "setTag", () => $d23f3af792a08db7$export$a37d07ee78eb4569);
$parcel$export(module.exports, "setUser", () => $d23f3af792a08db7$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "lastEventId", () => $d23f3af792a08db7$export$5d4e9fd7fac8e617);
$parcel$export(module.exports, "startSession", () => $d23f3af792a08db7$export$c0d84948cecf78d8);
$parcel$export(module.exports, "captureSession", () => $d23f3af792a08db7$export$667e7b4d445d566b);

var $9zTQv = parcelRequire("9zTQv");

var $dYTLo = parcelRequire("dYTLo");

var $4fgW6 = parcelRequire("4fgW6");

var $bxlWC = parcelRequire("bxlWC");

var $5hnoa = parcelRequire("5hnoa");

var $aieBB = parcelRequire("aieBB");

var $84KxT = parcelRequire("84KxT");

var $a2WQ6 = parcelRequire("a2WQ6");

var $gflYe = parcelRequire("gflYe");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $d23f3af792a08db7$export$f5282963edea4a68(exception, hint) {
    return (0, $9zTQv.getCurrentScope)().captureException(exception, (0, $bxlWC.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $d23f3af792a08db7$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $9zTQv.getCurrentScope)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $d23f3af792a08db7$export$1462b974fdcf6ba2(event, hint) {
    return (0, $9zTQv.getCurrentScope)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $d23f3af792a08db7$export$2f04de43fe27971a(name, context) {
    (0, $9zTQv.getIsolationScope)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $d23f3af792a08db7$export$bb4922da0dd51b92(extras) {
    (0, $9zTQv.getIsolationScope)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $d23f3af792a08db7$export$8e8e7789d42ed61d(key, extra) {
    (0, $9zTQv.getIsolationScope)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $d23f3af792a08db7$export$74a8fb34822092e6(tags) {
    (0, $9zTQv.getIsolationScope)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $d23f3af792a08db7$export$a37d07ee78eb4569(key, value) {
    (0, $9zTQv.getIsolationScope)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $d23f3af792a08db7$export$8b6bb3dd62a01be2(user) {
    (0, $9zTQv.getIsolationScope)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $d23f3af792a08db7$export$5d4e9fd7fac8e617() {
    return (0, $9zTQv.getIsolationScope)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $d23f3af792a08db7$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $9zTQv.getCurrentScope)();
    const client = (0, $9zTQv.getClient)();
    if (!client) (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $84KxT.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $d23f3af792a08db7$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $d23f3af792a08db7$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $a2WQ6.timestampInSeconds)();
    function finishCheckIn(status) {
        $d23f3af792a08db7$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $a2WQ6.timestampInSeconds)() - now
        });
    }
    return (0, $9zTQv.withIsolationScope)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $5hnoa.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn('ok');
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        else finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $d23f3af792a08db7$export$4909b86c8034bf73(timeout) {
    const client = (0, $9zTQv.getClient)();
    if (client) return client.flush(timeout);
    (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $d23f3af792a08db7$export$8360e631d277ea4d(timeout) {
    const client = (0, $9zTQv.getClient)();
    if (client) return client.close(timeout);
    (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $d23f3af792a08db7$export$3f95c6f800b78024() {
    return !!(0, $9zTQv.getClient)();
}
/** If the SDK is initialized & enabled. */ function $d23f3af792a08db7$export$3b029eb57ac4d562() {
    const client = (0, $9zTQv.getClient)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $d23f3af792a08db7$export$9aac0b9f77928fbf(callback) {
    (0, $9zTQv.getIsolationScope)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $d23f3af792a08db7$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $9zTQv.getIsolationScope)();
    const currentScope = (0, $9zTQv.getCurrentScope)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $gflYe.GLOBAL_OBJ).navigator || {};
    const session = (0, $4fgW6.makeSession)({
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === 'ok') (0, $4fgW6.updateSession)(currentSession, {
        status: 'exited'
    });
    $d23f3af792a08db7$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $d23f3af792a08db7$export$17a5be43989a0bc1() {
    const isolationScope = (0, $9zTQv.getIsolationScope)();
    const currentScope = (0, $9zTQv.getCurrentScope)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $4fgW6.closeSession)(session);
    $d23f3af792a08db7$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $d23f3af792a08db7$var$_sendSessionUpdate() {
    const isolationScope = (0, $9zTQv.getIsolationScope)();
    const client = (0, $9zTQv.getClient)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $d23f3af792a08db7$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $d23f3af792a08db7$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $d23f3af792a08db7$var$_sendSessionUpdate();
}

});
parcelRegister("bxlWC", function(module, exports) {
$parcel$export(module.exports, "prepareEvent", () => $8663cc775c15c79e$export$2d67fb380bd11267);
$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $8663cc775c15c79e$export$76b5f966996d1653);

var $6dn1i = parcelRequire("6dn1i");

var $9zTQv = parcelRequire("9zTQv");

var $18YWD = parcelRequire("18YWD");

var $40qI7 = parcelRequire("40qI7");

var $jIIna = parcelRequire("jIIna");

var $84KxT = parcelRequire("84KxT");

var $366rg = parcelRequire("366rg");

var $j5FsG = parcelRequire("j5FsG");

var $a2WQ6 = parcelRequire("a2WQ6");

var $hvPI9 = parcelRequire("hvPI9");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $8663cc775c15c79e$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $84KxT.uuid4)(),
        timestamp: event.timestamp || (0, $a2WQ6.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $8663cc775c15c79e$export$d7e04067a6fbc882(prepared, options);
    $8663cc775c15c79e$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $8663cc775c15c79e$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $8663cc775c15c79e$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $84KxT.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $9zTQv.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $hvPI9.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $hvPI9.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $hvPI9.applyScopeDataToEvent)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $18YWD.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $8663cc775c15c79e$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $8663cc775c15c79e$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $8663cc775c15c79e$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $6dn1i.DEFAULT_ENVIRONMENT);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url) request.url = (0, $j5FsG.truncate)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $8663cc775c15c79e$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $jIIna.getFilenameToDebugIdMap)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $8663cc775c15c79e$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $8663cc775c15c79e$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $8663cc775c15c79e$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $366rg.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $366rg.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $366rg.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $366rg.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $366rg.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $366rg.normalize)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $366rg.normalize)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $8663cc775c15c79e$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $40qI7.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $8663cc775c15c79e$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($8663cc775c15c79e$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($8663cc775c15c79e$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $8663cc775c15c79e$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $40qI7.Scope) || typeof hint === 'function';
}
const $8663cc775c15c79e$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $8663cc775c15c79e$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$8663cc775c15c79e$var$captureContextKeys.includes(key));
}

});
parcelRegister("6dn1i", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $4865d0431b6e90cc$export$849dbeeeda01ae98);
const $4865d0431b6e90cc$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("18YWD", function(module, exports) {
$parcel$export(module.exports, "notifyEventProcessors", () => $0d55d02b52648025$export$bf2a096c3e883e79);

var $dYTLo = parcelRequire("dYTLo");

var $5hnoa = parcelRequire("5hnoa");

var $aieBB = parcelRequire("aieBB");

var $lHcvp = parcelRequire("lHcvp");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $0d55d02b52648025$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $lHcvp.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $dYTLo.DEBUG_BUILD) && processor.id && result === null && (0, $aieBB.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $5hnoa.isThenable)(result)) result.then((final)=>$0d55d02b52648025$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $0d55d02b52648025$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("lHcvp", function(module, exports) {
$parcel$export(module.exports, "resolvedSyncPromise", () => $fcb750782a60d5dc$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $fcb750782a60d5dc$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $fcb750782a60d5dc$export$78e43115b553f358);

var $5hnoa = parcelRequire("5hnoa");
/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $fcb750782a60d5dc$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($fcb750782a60d5dc$var$States || ($fcb750782a60d5dc$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $fcb750782a60d5dc$export$1fda8aa4d135f8aa(value) {
    return new $fcb750782a60d5dc$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $fcb750782a60d5dc$export$78e43115b553f358(reason) {
    return new $fcb750782a60d5dc$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $fcb750782a60d5dc$export$6f292d4960313241 {
    constructor(executor){
        this._state = $fcb750782a60d5dc$var$States.PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $fcb750782a60d5dc$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $fcb750782a60d5dc$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $fcb750782a60d5dc$var$States.PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $fcb750782a60d5dc$var$States.RESOLVED) handler[1](this._value);
            if (this._state === $fcb750782a60d5dc$var$States.REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $fcb750782a60d5dc$var$States.PENDING) return;
            if ((0, $5hnoa.isThenable)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($fcb750782a60d5dc$var$States.RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($fcb750782a60d5dc$var$States.REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}

});


parcelRegister("jIIna", function(module, exports) {
$parcel$export(module.exports, "getFilenameToDebugIdMap", () => $e5b48bd90f5510e2$export$e069fee9c632ed00);

var $gflYe = parcelRequire("gflYe");
let $e5b48bd90f5510e2$var$parsedStackResults;
let $e5b48bd90f5510e2$var$lastKeysCount;
let $e5b48bd90f5510e2$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $e5b48bd90f5510e2$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $gflYe.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($e5b48bd90f5510e2$var$cachedFilenameDebugIds && debugIdKeys.length === $e5b48bd90f5510e2$var$lastKeysCount) return $e5b48bd90f5510e2$var$cachedFilenameDebugIds;
    $e5b48bd90f5510e2$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $e5b48bd90f5510e2$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$e5b48bd90f5510e2$var$parsedStackResults) $e5b48bd90f5510e2$var$parsedStackResults = {};
        const result = $e5b48bd90f5510e2$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame?.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $e5b48bd90f5510e2$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $e5b48bd90f5510e2$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $e5b48bd90f5510e2$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $e5b48bd90f5510e2$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}

});

parcelRegister("366rg", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $2416ed3f15646226$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $2416ed3f15646226$export$23fbbb20bed71033);

var $5hnoa = parcelRequire("5hnoa");

var $2bu2L = parcelRequire("2bu2L");

var $9QP64 = parcelRequire("9QP64");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2416ed3f15646226$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $2416ed3f15646226$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $2416ed3f15646226$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $2416ed3f15646226$export$a3295358bff77e(object, depth);
    if ($2416ed3f15646226$var$jsonSize(normalized) > maxSize) return $2416ed3f15646226$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $2416ed3f15646226$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $2416ed3f15646226$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $2416ed3f15646226$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $2416ed3f15646226$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $2bu2L.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $2416ed3f15646226$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $2416ed3f15646226$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $5hnoa.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $5hnoa.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $9QP64.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $2416ed3f15646226$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $2416ed3f15646226$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $2416ed3f15646226$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2416ed3f15646226$var$jsonSize(value) {
    return $2416ed3f15646226$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $2416ed3f15646226$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $2416ed3f15646226$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}

});
parcelRegister("9QP64", function(module, exports) {
$parcel$export(module.exports, "UNKNOWN_FUNCTION", () => $72c09b3146426422$export$27c7e15d453fc0ac);
$parcel$export(module.exports, "createStackParser", () => $72c09b3146426422$export$a5739666fb2d03d4);
$parcel$export(module.exports, "stackParserFromStackParserOptions", () => $72c09b3146426422$export$1d5cf88b347146d4);
$parcel$export(module.exports, "getFunctionName", () => $72c09b3146426422$export$aad197c7121a6651);
$parcel$export(module.exports, "getFramesFromEvent", () => $72c09b3146426422$export$91d8ca51bd9f6a47);
const $72c09b3146426422$var$STACKTRACE_FRAME_LIMIT = 50;
const $72c09b3146426422$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $72c09b3146426422$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $72c09b3146426422$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $72c09b3146426422$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $72c09b3146426422$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($72c09b3146426422$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $72c09b3146426422$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $72c09b3146426422$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $72c09b3146426422$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $72c09b3146426422$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $72c09b3146426422$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($72c09b3146426422$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($72c09b3146426422$var$STRIP_FRAME_REGEXP.test($72c09b3146426422$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($72c09b3146426422$var$STRIP_FRAME_REGEXP.test($72c09b3146426422$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $72c09b3146426422$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $72c09b3146426422$var$getLastStackFrame(localStack).filename,
            function: frame.function || $72c09b3146426422$export$27c7e15d453fc0ac
        }));
}
function $72c09b3146426422$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $72c09b3146426422$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $72c09b3146426422$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $72c09b3146426422$var$defaultFunctionName;
        return fn.name || $72c09b3146426422$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $72c09b3146426422$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $72c09b3146426422$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}

});


parcelRegister("hvPI9", function(module, exports) {
$parcel$export(module.exports, "applyScopeDataToEvent", () => $cbfd71b0e2ddfbb1$export$43988bc651a80216);
$parcel$export(module.exports, "mergeScopeData", () => $cbfd71b0e2ddfbb1$export$25ac7e259a513db4);

var $9r8JS = parcelRequire("9r8JS");

var $7t9x6 = parcelRequire("7t9x6");

var $4LMHq = parcelRequire("4LMHq");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $cbfd71b0e2ddfbb1$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $cbfd71b0e2ddfbb1$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $cbfd71b0e2ddfbb1$var$applySpanToEvent(event, span);
    $cbfd71b0e2ddfbb1$var$applyFingerprintToEvent(event, fingerprint);
    $cbfd71b0e2ddfbb1$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $cbfd71b0e2ddfbb1$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $cbfd71b0e2ddfbb1$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $cbfd71b0e2ddfbb1$export$b1a120a2871faa46(data, 'extra', extra);
    $cbfd71b0e2ddfbb1$export$b1a120a2871faa46(data, 'tags', tags);
    $cbfd71b0e2ddfbb1$export$b1a120a2871faa46(data, 'user', user);
    $cbfd71b0e2ddfbb1$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $7t9x6.merge)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $cbfd71b0e2ddfbb1$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $7t9x6.merge)(data[prop], mergeVal, 1);
}
function $cbfd71b0e2ddfbb1$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $cbfd71b0e2ddfbb1$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $cbfd71b0e2ddfbb1$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $cbfd71b0e2ddfbb1$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $4LMHq.spanToTraceContext)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $9r8JS.getDynamicSamplingContextFromSpan)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $4LMHq.getRootSpan)(span);
    const transactionName = (0, $4LMHq.spanToJSON)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $cbfd71b0e2ddfbb1$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("9r8JS", function(module, exports) {
$parcel$export(module.exports, "getDynamicSamplingContextFromScope", () => $6ded6a0bee8bf5d7$export$89ef1736f08c6b2b);
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", () => $6ded6a0bee8bf5d7$export$a117f995597e25df);

var $6dn1i = parcelRequire("6dn1i");

var $9zTQv = parcelRequire("9zTQv");

var $gJuxI = parcelRequire("gJuxI");

var $cfNVi = parcelRequire("cfNVi");

var $4LMHq = parcelRequire("4LMHq");

var $3VZ8g = parcelRequire("3VZ8g");

var $4jD1U = parcelRequire("4jD1U");

var $2bu2L = parcelRequire("2bu2L");

var $lrqxn = parcelRequire("lrqxn");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $6ded6a0bee8bf5d7$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $6ded6a0bee8bf5d7$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $2bu2L.addNonEnumerableProperty)(spanWithMaybeDsc, $6ded6a0bee8bf5d7$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $6ded6a0bee8bf5d7$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key, host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = (0, $4jD1U.extractOrgIdFromDsnHost)(host);
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $6dn1i.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: org_id
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $6ded6a0bee8bf5d7$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $6ded6a0bee8bf5d7$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $6ded6a0bee8bf5d7$export$a117f995597e25df(span) {
    const client = (0, $9zTQv.getClient)();
    if (!client) return {};
    const rootSpan = (0, $4LMHq.getRootSpan)(span);
    const rootSpanJson = (0, $4LMHq.spanToJSON)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[0, $gJuxI.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[0, $gJuxI.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$6ded6a0bee8bf5d7$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $3VZ8g.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $6ded6a0bee8bf5d7$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $gJuxI.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $cfNVi.hasSpansEnabled)()) {
        dsc.sampled = String((0, $4LMHq.spanIsSampled)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $lrqxn.getCapturedScopesOnSpan)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $6ded6a0bee8bf5d7$export$95cf936fdacaff7b(span) {
    const dsc = $6ded6a0bee8bf5d7$export$a117f995597e25df(span);
    return (0, $3VZ8g.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}

});
parcelRegister("gJuxI", function(module, exports) {
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", () => $c2e88a7b01c7ee21$export$d7a7d984b0791405);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", () => $c2e88a7b01c7ee21$export$ccfe0a40627cc34b);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE", () => $c2e88a7b01c7ee21$export$889fb736668e1ecc);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", () => $c2e88a7b01c7ee21$export$1a413bd9a88fdb09);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", () => $c2e88a7b01c7ee21$export$cca8dd30f57f805e);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", () => $c2e88a7b01c7ee21$export$165ce9a229f6f050);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", () => $c2e88a7b01c7ee21$export$1efec95406bbe327);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", () => $c2e88a7b01c7ee21$export$fea48ba9f4550879);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD", () => $c2e88a7b01c7ee21$export$be7a251980e7e946);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_URL_FULL", () => $c2e88a7b01c7ee21$export$25dfd73e0e32c6e1);
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $c2e88a7b01c7ee21$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $c2e88a7b01c7ee21$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $c2e88a7b01c7ee21$export$889fb736668e1ecc = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $c2e88a7b01c7ee21$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $c2e88a7b01c7ee21$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $c2e88a7b01c7ee21$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $c2e88a7b01c7ee21$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $c2e88a7b01c7ee21$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $c2e88a7b01c7ee21$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $c2e88a7b01c7ee21$export$1efec95406bbe327 = 'sentry.profile_id';
const $c2e88a7b01c7ee21$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $c2e88a7b01c7ee21$export$b016f89ac1066ec = 'cache.hit';
const $c2e88a7b01c7ee21$export$3110e4c3f4386399 = 'cache.key';
const $c2e88a7b01c7ee21$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $c2e88a7b01c7ee21$export$be7a251980e7e946 = 'http.request.method';
const $c2e88a7b01c7ee21$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $c2e88a7b01c7ee21$export$ff77b5fd5b2d627b = 'sentry.link.type';

});

parcelRegister("cfNVi", function(module, exports) {
$parcel$export(module.exports, "hasSpansEnabled", () => $8ebd9c76ef3eb074$export$1f70765132c3c225);

var $9zTQv = parcelRequire("9zTQv");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $8ebd9c76ef3eb074$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $9zTQv.getClient)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $8ebd9c76ef3eb074$export$5008da00b1b6dee6 = $8ebd9c76ef3eb074$export$1f70765132c3c225;

});

parcelRegister("4LMHq", function(module, exports) {
$parcel$export(module.exports, "spanToJSON", () => $379153e2b57935b7$export$92d8c23565496537);
$parcel$export(module.exports, "spanToTraceContext", () => $379153e2b57935b7$export$46c6fbd1d265ebf0);
$parcel$export(module.exports, "spanIsSampled", () => $379153e2b57935b7$export$5caecac1caaf3a71);
$parcel$export(module.exports, "getRootSpan", () => $379153e2b57935b7$export$c4c6a79b1260ca1b);
$parcel$export(module.exports, "getActiveSpan", () => $379153e2b57935b7$export$1be426a8e585c83e);
$parcel$export(module.exports, "showSpanDropWarning", () => $379153e2b57935b7$export$d11691ff45a3e535);

var $3fv0k = parcelRequire("3fv0k");

var $k8rSc = parcelRequire("k8rSc");

var $9zTQv = parcelRequire("9zTQv");

var $gJuxI = parcelRequire("gJuxI");

var $9NZyY = parcelRequire("9NZyY");

var $lrqxn = parcelRequire("lrqxn");

var $aieBB = parcelRequire("aieBB");

var $2bu2L = parcelRequire("2bu2L");

var $gaILw = parcelRequire("gaILw");

var $a2WQ6 = parcelRequire("a2WQ6");

var $dK1iO = parcelRequire("dK1iO");

var $kh78x = parcelRequire("kh78x");
// These are aligned with OpenTelemetry trace flags
const $379153e2b57935b7$export$208d5b368507fb8b = 0x0;
const $379153e2b57935b7$export$eb571cd9b5d98de8 = 0x1;
let $379153e2b57935b7$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $379153e2b57935b7$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $379153e2b57935b7$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $379153e2b57935b7$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $379153e2b57935b7$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $lrqxn.getCapturedScopesOnSpan)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $gaILw.generateSpanId)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $379153e2b57935b7$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $379153e2b57935b7$export$5caecac1caaf3a71(span);
    return (0, $dK1iO.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $379153e2b57935b7$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $379153e2b57935b7$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $379153e2b57935b7$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $379153e2b57935b7$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $379153e2b57935b7$var$ensureTimestampInSeconds(input.getTime());
    return (0, $a2WQ6.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $379153e2b57935b7$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $379153e2b57935b7$export$92d8c23565496537(span) {
    if ($379153e2b57935b7$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($379153e2b57935b7$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        // In preparation for the next major of OpenTelemetry, we want to support
        // looking up the parent span id according to the new API
        // In OTel v1, the parent span id is accessed as `parentSpanId`
        // In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
        const parentSpanId = 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? span.parentSpanContext?.spanId : undefined;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $379153e2b57935b7$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $379153e2b57935b7$export$3f7581298f56c6d7(endTime) || undefined,
            status: $379153e2b57935b7$export$e238a77ea3a8cd66(status),
            op: attributes[0, $gJuxI.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[0, $gJuxI.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $379153e2b57935b7$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $379153e2b57935b7$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $379153e2b57935b7$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $379153e2b57935b7$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $379153e2b57935b7$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $379153e2b57935b7$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $9NZyY.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, $9NZyY.SPAN_STATUS_OK)) return 'ok';
    return status.message || 'unknown_error';
}
const $379153e2b57935b7$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $379153e2b57935b7$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $379153e2b57935b7$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$379153e2b57935b7$var$ROOT_SPAN_FIELD] || span;
    (0, $2bu2L.addNonEnumerableProperty)(childSpan, $379153e2b57935b7$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$379153e2b57935b7$var$CHILD_SPANS_FIELD]) span[$379153e2b57935b7$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $2bu2L.addNonEnumerableProperty)(span, $379153e2b57935b7$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $379153e2b57935b7$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$379153e2b57935b7$var$CHILD_SPANS_FIELD]) span[$379153e2b57935b7$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $379153e2b57935b7$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($379153e2b57935b7$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$379153e2b57935b7$var$CHILD_SPANS_FIELD] ? Array.from(span[$379153e2b57935b7$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $379153e2b57935b7$export$c4c6a79b1260ca1b(span) {
    return span[$379153e2b57935b7$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $379153e2b57935b7$export$1be426a8e585c83e() {
    const carrier = (0, $k8rSc.getMainCarrier)();
    const acs = (0, $3fv0k.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $kh78x._getSpanForScope)((0, $9zTQv.getCurrentScope)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $379153e2b57935b7$export$d11691ff45a3e535() {
    if (!$379153e2b57935b7$var$hasShownSpanDropWarning) {
        (0, $aieBB.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.');
        });
        $379153e2b57935b7$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $379153e2b57935b7$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $gJuxI.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'custom',
        [(0, $gJuxI.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME)]: name
    });
}

});
parcelRegister("9NZyY", function(module, exports) {
$parcel$export(module.exports, "SPAN_STATUS_UNSET", () => $01d79ebd338758d8$export$136e25984ba4a383);
$parcel$export(module.exports, "SPAN_STATUS_OK", () => $01d79ebd338758d8$export$58f7963109c806fc);
const $01d79ebd338758d8$export$136e25984ba4a383 = 0;
const $01d79ebd338758d8$export$58f7963109c806fc = 1;
const $01d79ebd338758d8$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $01d79ebd338758d8$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $01d79ebd338758d8$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $01d79ebd338758d8$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $01d79ebd338758d8$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $01d79ebd338758d8$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $01d79ebd338758d8$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $01d79ebd338758d8$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $01d79ebd338758d8$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $01d79ebd338758d8$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $01d79ebd338758d8$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $01d79ebd338758d8$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $01d79ebd338758d8$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $01d79ebd338758d8$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $01d79ebd338758d8$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $01d79ebd338758d8$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $01d79ebd338758d8$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $01d79ebd338758d8$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}

});

parcelRegister("lrqxn", function(module, exports) {
$parcel$export(module.exports, "getCapturedScopesOnSpan", () => $f9c0b45b59c06ab7$export$c08fbc656a245d03);

var $2bu2L = parcelRequire("2bu2L");
const $f9c0b45b59c06ab7$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $f9c0b45b59c06ab7$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $f9c0b45b59c06ab7$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $2bu2L.addNonEnumerableProperty)(span, $f9c0b45b59c06ab7$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $2bu2L.addNonEnumerableProperty)(span, $f9c0b45b59c06ab7$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $f9c0b45b59c06ab7$export$c08fbc656a245d03(span) {
    return {
        scope: span[$f9c0b45b59c06ab7$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$f9c0b45b59c06ab7$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});

parcelRegister("dK1iO", function(module, exports) {
$parcel$export(module.exports, "generateSentryTraceHeader", () => $a01094e645364206$export$f35d907436da45cf);

var $fSgUh = parcelRequire("fSgUh");

var $3VZ8g = parcelRequire("3VZ8g");

var $gaILw = parcelRequire("gaILw");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $a01094e645364206$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $a01094e645364206$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($a01094e645364206$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $a01094e645364206$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $a01094e645364206$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $3VZ8g.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $gaILw.generateTraceId)(),
        sampleRand: Math.random()
    };
    const sampleRand = $a01094e645364206$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $a01094e645364206$export$f35d907436da45cf(traceId = (0, $gaILw.generateTraceId)(), spanId = (0, $gaILw.generateSpanId)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $a01094e645364206$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $fSgUh.parseSampleRate)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $fSgUh.parseSampleRate)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}

});
parcelRegister("fSgUh", function(module, exports) {
$parcel$export(module.exports, "parseSampleRate", () => $b8e903831a538b3a$export$a5bd2d81656d9546);
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $b8e903831a538b3a$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}

});

parcelRegister("3VZ8g", function(module, exports) {
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $2dd61d904918b282$export$5b96ee2c8421f107);
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", () => $2dd61d904918b282$export$56766feef403f365);

var $dYTLo = parcelRequire("dYTLo");

var $5hnoa = parcelRequire("5hnoa");

var $aieBB = parcelRequire("aieBB");
const $2dd61d904918b282$export$6e69537d67fa20f = 'sentry-';
const $2dd61d904918b282$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $2dd61d904918b282$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $2dd61d904918b282$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $2dd61d904918b282$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($2dd61d904918b282$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($2dd61d904918b282$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $2dd61d904918b282$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$2dd61d904918b282$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $2dd61d904918b282$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $2dd61d904918b282$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $5hnoa.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $2dd61d904918b282$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $2dd61d904918b282$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $2dd61d904918b282$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        })).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $2dd61d904918b282$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $2dd61d904918b282$export$bdd844ddb2def819) {
            (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});







parcelRegister("d70tI", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $98bc4ccda606ab6e$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $98bc4ccda606ab6e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("2NPnx", function(module, exports) {
$parcel$export(module.exports, "WINDOW", () => $20a8031a4929a9ba$export$56d8a8a25bd48b81);
$parcel$export(module.exports, "shouldIgnoreOnError", () => $20a8031a4929a9ba$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $20a8031a4929a9ba$export$4997ffc0176396a6);
$parcel$export(module.exports, "getHttpRequestData", () => $20a8031a4929a9ba$export$a3c4a8453e8936f0);

var $84KxT = parcelRequire("84KxT");
var $2bu2L = parcelRequire("2bu2L");
var $i38Fr = parcelRequire("i38Fr");
var $68KEs = parcelRequire("68KEs");
var $gflYe = parcelRequire("gflYe");
var $9zTQv = parcelRequire("9zTQv");
const $20a8031a4929a9ba$export$56d8a8a25bd48b81 = (0, $gflYe.GLOBAL_OBJ);
let $20a8031a4929a9ba$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $20a8031a4929a9ba$export$b79738ab10c590b2() {
    return $20a8031a4929a9ba$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $20a8031a4929a9ba$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $20a8031a4929a9ba$var$ignoreOnError++;
    setTimeout(()=>{
        $20a8031a4929a9ba$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $20a8031a4929a9ba$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $2bu2L.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$20a8031a4929a9ba$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $20a8031a4929a9ba$export$1265a142ff5ba165();
            (0, $9zTQv.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $84KxT.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $84KxT.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $i38Fr.captureException)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $2bu2L.markFunctionWrapped)(sentryWrapped, fn);
    (0, $2bu2L.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
/**
 * Get HTTP request data from the current page.
 */ function $20a8031a4929a9ba$export$a3c4a8453e8936f0() {
    // grab as much info as exists and add it to the event
    const url = (0, $68KEs.getLocationHref)();
    const { referrer: referrer } = $20a8031a4929a9ba$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $20a8031a4929a9ba$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            'User-Agent': userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}

});


parcelRegister("kQvwI", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $f2d11e7deaae0997$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $f2d11e7deaae0997$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("d1Mmt", function(module, exports) {
$parcel$export(module.exports, "captureReactException", () => $97c0e1eda1858550$export$270be4195468cda9);

var $i38Fr = parcelRequire("i38Fr");
var $9zTQv = parcelRequire("9zTQv");

var $5hnoa = parcelRequire("5hnoa");

var $1v5pe = parcelRequire("1v5pe");
/**
 * See if React major version is 17+ by parsing version string.
 */ function $97c0e1eda1858550$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
/**
 * Recurse through `error.cause` chain to set cause on an error.
 */ function $97c0e1eda1858550$export$bc95048bc211a673(error, cause) {
    const seenErrors = new WeakSet();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.add(error);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * Captures an error that was thrown by a React ErrorBoundary or React root.
 *
 * @param error The error to capture.
 * @param errorInfo The errorInfo provided by React.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $97c0e1eda1858550$export$270be4195468cda9(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, { componentStack: componentStack }, hint) {
    // If on React version >= 17, create stack trace from componentStack param and links
    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
    // Linking errors requires the `LinkedErrors` integration be enabled.
    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
    //
    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
    // with non-error objects. This is why we need to check if the error is an error-like object.
    // See: https://github.com/getsentry/sentry-javascript/issues/6167
    if ($97c0e1eda1858550$export$a87138b73900f5b((0, $1v5pe.version)) && (0, $5hnoa.isError)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        // Using the `LinkedErrors` integration to link the errors together.
        $97c0e1eda1858550$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $9zTQv.withScope)((scope)=>{
        scope.setContext('react', {
            componentStack: componentStack
        });
        return (0, $i38Fr.captureException)(error, hint);
    });
}
/**
 * Creates an error handler that can be used with the `onCaughtError`, `onUncaughtError`,
 * and `onRecoverableError` options in `createRoot` and `hydrateRoot` React DOM methods.
 *
 * @param callback An optional callback that will be called after the error is captured.
 * Use this to add custom handling for errors.
 *
 * @example
 *
 * ```JavaScript
 * const root = createRoot(container, {
 *  onCaughtError: Sentry.reactErrorHandler(),
 *  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
 *    console.warn('Caught error', error, errorInfo.componentStack);
 *  });
 * });
 * ```
 */ function $97c0e1eda1858550$export$1e6f045b27b3cfb1(// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error, errorInfo)=>{
        const eventId = $97c0e1eda1858550$export$270be4195468cda9(error, errorInfo);
        if (callback) callback(error, errorInfo, eventId);
    };
}

});

parcelRegister("dbp1a", function(module, exports) {
$parcel$export(module.exports, "hoistNonReactStatics", () => $998fb570ef7f876c$export$6c1f0397687d8b2);

var $35aua = parcelRequire("35aua");
// Ensure we use the default export from hoist-non-react-statics if available,
// falling back to the module itself. This handles both ESM and CJS usage.
const $998fb570ef7f876c$export$6c1f0397687d8b2 = $35aua.default || $35aua;

});


parcelRegister("keFM9", function(module, exports) {
$parcel$export(module.exports, "context", () => (parcelRequire("i6wLE")).context);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

var $dCCNu = parcelRequire("dCCNu");















var $i6wLE = parcelRequire("i6wLE");

var $aaHZo = parcelRequire("aaHZo");

var $kZ8AQ = parcelRequire("kZ8AQ");

var $gwbQ0 = parcelRequire("gwbQ0");

var $2cvl5 = parcelRequire("2cvl5");
var // Default export.
$ebb5853f1afcb1db$export$2e2bcd8739ae039 = {
    context: (0, $i6wLE.context),
    diag: (0, $aaHZo.diag),
    metrics: (0, $kZ8AQ.metrics),
    propagation: (0, $gwbQ0.propagation),
    trace: (0, $2cvl5.trace)
};

});
parcelRegister("dCCNu", function(module, exports) {
$parcel$export(module.exports, "createContextKey", () => $9eaceb50b9d4a7b6$export$b8c322c5a7cfce78);
$parcel$export(module.exports, "ROOT_CONTEXT", () => $9eaceb50b9d4a7b6$export$78df28f9b2f9a7dc);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Get a key to uniquely identify a context value */ function $9eaceb50b9d4a7b6$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var $9eaceb50b9d4a7b6$var$BaseContext = /** @class */ function() {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function(key) {
            return self._currentContext.get(key);
        };
        self.setValue = function(key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function(key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}();
var $9eaceb50b9d4a7b6$export$78df28f9b2f9a7dc = new $9eaceb50b9d4a7b6$var$BaseContext();

});

parcelRegister("i6wLE", function(module, exports) {
$parcel$export(module.exports, "context", () => $d2e2347fabe4ed66$export$a078c61943f9dbbe);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $e5aXd = parcelRequire("e5aXd");
var $d2e2347fabe4ed66$export$a078c61943f9dbbe = (0, $e5aXd.ContextAPI).getInstance();

});
parcelRegister("e5aXd", function(module, exports) {
$parcel$export(module.exports, "ContextAPI", () => $a40a078d0b176e64$export$4148866f0a453927);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $1f7Oj = parcelRequire("1f7Oj");

var $jTV6N = parcelRequire("jTV6N");

var $TiYt8 = parcelRequire("TiYt8");
var $a40a078d0b176e64$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $a40a078d0b176e64$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $a40a078d0b176e64$var$API_NAME = 'context';
var $a40a078d0b176e64$var$NOOP_CONTEXT_MANAGER = new (0, $1f7Oj.NoopContextManager)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */ var $a40a078d0b176e64$export$4148866f0a453927 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function ContextAPI() {}
    /** Get the singleton instance of the Context API */ ContextAPI.getInstance = function() {
        if (!this._instance) this._instance = new ContextAPI();
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
        return (0, $jTV6N.registerGlobal)($a40a078d0b176e64$var$API_NAME, contextManager, (0, $TiYt8.DiagAPI).instance());
    };
    /**
     * Get the currently active context
     */ ContextAPI.prototype.active = function() {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ ContextAPI.prototype.with = function(context, fn, thisArg) {
        var _a;
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return (_a = this._getContextManager()).with.apply(_a, $a40a078d0b176e64$var$__spreadArray([
            context,
            fn,
            thisArg
        ], $a40a078d0b176e64$var$__read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ ContextAPI.prototype.bind = function(context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function() {
        return (0, $jTV6N.getGlobal)($a40a078d0b176e64$var$API_NAME) || $a40a078d0b176e64$var$NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */ ContextAPI.prototype.disable = function() {
        this._getContextManager().disable();
        (0, $jTV6N.unregisterGlobal)($a40a078d0b176e64$var$API_NAME, (0, $TiYt8.DiagAPI).instance());
    };
    return ContextAPI;
}();

});
parcelRegister("1f7Oj", function(module, exports) {
$parcel$export(module.exports, "NoopContextManager", () => $0e7d4023cc4c29c1$export$a27e5df35d1539a6);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $dCCNu = parcelRequire("dCCNu");
var $0e7d4023cc4c29c1$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $0e7d4023cc4c29c1$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $0e7d4023cc4c29c1$export$a27e5df35d1539a6 = /** @class */ function() {
    function NoopContextManager() {}
    NoopContextManager.prototype.active = function() {
        return 0, $dCCNu.ROOT_CONTEXT;
    };
    NoopContextManager.prototype.with = function(_context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return fn.call.apply(fn, $0e7d4023cc4c29c1$var$__spreadArray([
            thisArg
        ], $0e7d4023cc4c29c1$var$__read(args), false));
    };
    NoopContextManager.prototype.bind = function(_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function() {
        return this;
    };
    NoopContextManager.prototype.disable = function() {
        return this;
    };
    return NoopContextManager;
}();

});

parcelRegister("jTV6N", function(module, exports) {
$parcel$export(module.exports, "registerGlobal", () => $e7cf73f90e6f5b08$export$d586ae880b433238);
$parcel$export(module.exports, "getGlobal", () => $e7cf73f90e6f5b08$export$a4e55266d2135a7f);
$parcel$export(module.exports, "unregisterGlobal", () => $e7cf73f90e6f5b08$export$d42ac835f38d1fb2);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $6HJLu = parcelRequire("6HJLu");

var $4lGN2 = parcelRequire("4lGN2");

var $cVruD = parcelRequire("cVruD");
var $e7cf73f90e6f5b08$var$major = (0, $4lGN2.VERSION).split('.')[0];
var $e7cf73f90e6f5b08$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + $e7cf73f90e6f5b08$var$major);
var $e7cf73f90e6f5b08$var$_global = (0, $6HJLu._globalThis);
function $e7cf73f90e6f5b08$export$d586ae880b433238(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) allowOverride = false;
    var api = $e7cf73f90e6f5b08$var$_global[$e7cf73f90e6f5b08$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $e7cf73f90e6f5b08$var$_global[$e7cf73f90e6f5b08$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $4lGN2.VERSION)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $4lGN2.VERSION)) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + (0, $4lGN2.VERSION));
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + (0, $4lGN2.VERSION) + ".");
    return true;
}
function $e7cf73f90e6f5b08$export$a4e55266d2135a7f(type) {
    var _a, _b;
    var globalVersion = (_a = $e7cf73f90e6f5b08$var$_global[$e7cf73f90e6f5b08$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $cVruD.isCompatible)(globalVersion)) return;
    return (_b = $e7cf73f90e6f5b08$var$_global[$e7cf73f90e6f5b08$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $e7cf73f90e6f5b08$export$d42ac835f38d1fb2(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + (0, $4lGN2.VERSION) + ".");
    var api = $e7cf73f90e6f5b08$var$_global[$e7cf73f90e6f5b08$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}

});
parcelRegister("6HJLu", function(module, exports) {
$parcel$export(module.exports, "_globalThis", () => $4e1a42340ca3038c$export$5c524ddf7208c00c);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var $4e1a42340ca3038c$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};

});

parcelRegister("4lGN2", function(module, exports) {
$parcel$export(module.exports, "VERSION", () => $32aa50c22b669e86$export$a4ad2735b021c132);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var $32aa50c22b669e86$export$a4ad2735b021c132 = '1.9.0';

});

parcelRegister("cVruD", function(module, exports) {
$parcel$export(module.exports, "isCompatible", () => $969022765c4a38e7$export$7fc0d8c3ab188c4c);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $4lGN2 = parcelRequire("4lGN2");
var $969022765c4a38e7$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $969022765c4a38e7$export$a5733a4d26a1ec61(ownVersion) {
    var acceptedVersions = new Set([
        ownVersion
    ]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match($969022765c4a38e7$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return function() {
        return false;
    };
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        var globalVersionMatch = globalVersion.match($969022765c4a38e7$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var $969022765c4a38e7$export$7fc0d8c3ab188c4c = $969022765c4a38e7$export$a5733a4d26a1ec61((0, $4lGN2.VERSION));

});


parcelRegister("TiYt8", function(module, exports) {
$parcel$export(module.exports, "DiagAPI", () => $0a63db1223de8fcd$export$5c8937ffc688cfd3);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $i0wyM = parcelRequire("i0wyM");

var $7Fo2w = parcelRequire("7Fo2w");

var $2vjrO = parcelRequire("2vjrO");

var $jTV6N = parcelRequire("jTV6N");
var $0a63db1223de8fcd$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $0a63db1223de8fcd$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $0a63db1223de8fcd$var$API_NAME = 'diag';
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */ var $0a63db1223de8fcd$export$5c8937ffc688cfd3 = /** @class */ function() {
    /**
     * Private internal constructor
     * @private
     */ function DiagAPI() {
        function _logProxy(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var logger = (0, $jTV6N.getGlobal)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName].apply(logger, $0a63db1223de8fcd$var$__spreadArray([], $0a63db1223de8fcd$var$__read(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function(logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) optionsOrLogLevel = {
                logLevel: (0, $2vjrO.DiagLogLevel).INFO
            };
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            var oldLogger = (0, $jTV6N.getGlobal)('diag');
            var newLogger = (0, $7Fo2w.createLogLevelDiagLogger)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $2vjrO.DiagLogLevel).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return (0, $jTV6N.registerGlobal)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function() {
            (0, $jTV6N.unregisterGlobal)($0a63db1223de8fcd$var$API_NAME, self);
        };
        self.createComponentLogger = function(options) {
            return new (0, $i0wyM.DiagComponentLogger)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
    /** Get the singleton instance of the DiagAPI API */ DiagAPI.instance = function() {
        if (!this._instance) this._instance = new DiagAPI();
        return this._instance;
    };
    return DiagAPI;
}();

});
parcelRegister("i0wyM", function(module, exports) {
$parcel$export(module.exports, "DiagComponentLogger", () => $d1c17bcff23d940a$export$b4bccc12f5b13129);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $jTV6N = parcelRequire("jTV6N");
var $d1c17bcff23d940a$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $d1c17bcff23d940a$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */ var $d1c17bcff23d940a$export$b4bccc12f5b13129 = /** @class */ function() {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    DiagComponentLogger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $d1c17bcff23d940a$var$logProxy('debug', this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $d1c17bcff23d940a$var$logProxy('error', this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $d1c17bcff23d940a$var$logProxy('info', this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $d1c17bcff23d940a$var$logProxy('warn', this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $d1c17bcff23d940a$var$logProxy('verbose', this._namespace, args);
    };
    return DiagComponentLogger;
}();
function $d1c17bcff23d940a$var$logProxy(funcName, namespace, args) {
    var logger = (0, $jTV6N.getGlobal)('diag');
    // shortcut if logger not set
    if (!logger) return;
    args.unshift(namespace);
    return logger[funcName].apply(logger, $d1c17bcff23d940a$var$__spreadArray([], $d1c17bcff23d940a$var$__read(args), false));
}

});

parcelRegister("7Fo2w", function(module, exports) {
$parcel$export(module.exports, "createLogLevelDiagLogger", () => $594f0286f9a51a3d$export$9a9cc475abb19689);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $2vjrO = parcelRequire("2vjrO");
function $594f0286f9a51a3d$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $2vjrO.DiagLogLevel).NONE) maxLevel = (0, $2vjrO.DiagLogLevel).NONE;
    else if (maxLevel > (0, $2vjrO.DiagLogLevel).ALL) maxLevel = (0, $2vjrO.DiagLogLevel).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, $2vjrO.DiagLogLevel).ERROR),
        warn: _filterFunc('warn', (0, $2vjrO.DiagLogLevel).WARN),
        info: _filterFunc('info', (0, $2vjrO.DiagLogLevel).INFO),
        debug: _filterFunc('debug', (0, $2vjrO.DiagLogLevel).DEBUG),
        verbose: _filterFunc('verbose', (0, $2vjrO.DiagLogLevel).VERBOSE)
    };
}

});
parcelRegister("2vjrO", function(module, exports) {
$parcel$export(module.exports, "DiagLogLevel", () => $1d2d8fe4e44dc42b$export$b7d7b4c0f3c95263);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $1d2d8fe4e44dc42b$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($1d2d8fe4e44dc42b$export$b7d7b4c0f3c95263 || ($1d2d8fe4e44dc42b$export$b7d7b4c0f3c95263 = {}));

});





parcelRegister("aaHZo", function(module, exports) {
$parcel$export(module.exports, "diag", () => $767cf5e2b843cc4f$export$c042e7c2f59bc046);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $TiYt8 = parcelRequire("TiYt8");
var $767cf5e2b843cc4f$export$c042e7c2f59bc046 = (0, $TiYt8.DiagAPI).instance();

});

parcelRegister("kZ8AQ", function(module, exports) {
$parcel$export(module.exports, "metrics", () => $f4702b93e495ea46$export$b0c5c2fac8144e54);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $8pIjC = parcelRequire("8pIjC");
var $f4702b93e495ea46$export$b0c5c2fac8144e54 = (0, $8pIjC.MetricsAPI).getInstance();

});
parcelRegister("8pIjC", function(module, exports) {
$parcel$export(module.exports, "MetricsAPI", () => $620308a7a02e7c9e$export$1339f6eb6111c638);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $hjCih = parcelRequire("hjCih");

var $jTV6N = parcelRequire("jTV6N");

var $TiYt8 = parcelRequire("TiYt8");
var $620308a7a02e7c9e$var$API_NAME = 'metrics';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */ var $620308a7a02e7c9e$export$1339f6eb6111c638 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function MetricsAPI() {}
    /** Get the singleton instance of the Metrics API */ MetricsAPI.getInstance = function() {
        if (!this._instance) this._instance = new MetricsAPI();
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ MetricsAPI.prototype.setGlobalMeterProvider = function(provider) {
        return (0, $jTV6N.registerGlobal)($620308a7a02e7c9e$var$API_NAME, provider, (0, $TiYt8.DiagAPI).instance());
    };
    /**
     * Returns the global meter provider.
     */ MetricsAPI.prototype.getMeterProvider = function() {
        return (0, $jTV6N.getGlobal)($620308a7a02e7c9e$var$API_NAME) || (0, $hjCih.NOOP_METER_PROVIDER);
    };
    /**
     * Returns a meter from the global meter provider.
     */ MetricsAPI.prototype.getMeter = function(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */ MetricsAPI.prototype.disable = function() {
        (0, $jTV6N.unregisterGlobal)($620308a7a02e7c9e$var$API_NAME, (0, $TiYt8.DiagAPI).instance());
    };
    return MetricsAPI;
}();

});
parcelRegister("hjCih", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER_PROVIDER", () => $c9b1ea5f475cdcb4$export$d21fe83355c56e18);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $e2uEZ = parcelRequire("e2uEZ");
/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */ var $c9b1ea5f475cdcb4$export$51c513ea08316108 = /** @class */ function() {
    function NoopMeterProvider() {}
    NoopMeterProvider.prototype.getMeter = function(_name, _version, _options) {
        return 0, $e2uEZ.NOOP_METER;
    };
    return NoopMeterProvider;
}();
var $c9b1ea5f475cdcb4$export$d21fe83355c56e18 = new $c9b1ea5f475cdcb4$export$51c513ea08316108();

});
parcelRegister("e2uEZ", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER", () => $a389090a076a5add$export$65e277d35235a01f);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $a389090a076a5add$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ var $a389090a076a5add$export$c23c6f85dd4fc1e9 = /** @class */ function() {
    function NoopMeter() {}
    /**
     * @see {@link Meter.createGauge}
     */ NoopMeter.prototype.createGauge = function(_name, _options) {
        return $a389090a076a5add$export$dd01300aacbcec1c;
    };
    /**
     * @see {@link Meter.createHistogram}
     */ NoopMeter.prototype.createHistogram = function(_name, _options) {
        return $a389090a076a5add$export$689c32a6a552e1a6;
    };
    /**
     * @see {@link Meter.createCounter}
     */ NoopMeter.prototype.createCounter = function(_name, _options) {
        return $a389090a076a5add$export$e6d19fe5233efc54;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */ NoopMeter.prototype.createUpDownCounter = function(_name, _options) {
        return $a389090a076a5add$export$2f189cd99d2b7429;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */ NoopMeter.prototype.createObservableGauge = function(_name, _options) {
        return $a389090a076a5add$export$ea67e3c6ff624776;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */ NoopMeter.prototype.createObservableCounter = function(_name, _options) {
        return $a389090a076a5add$export$163422b94c3edbcb;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ NoopMeter.prototype.createObservableUpDownCounter = function(_name, _options) {
        return $a389090a076a5add$export$5b8be9ab17b673b3;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ NoopMeter.prototype.addBatchObservableCallback = function(_callback, _observables) {};
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ NoopMeter.prototype.removeBatchObservableCallback = function(_callback) {};
    return NoopMeter;
}();
var $a389090a076a5add$export$834a616d1cf278b = /** @class */ function() {
    function NoopMetric() {}
    return NoopMetric;
}();
var $a389090a076a5add$export$b556ba0f560c45b = /** @class */ function(_super) {
    $a389090a076a5add$var$__extends(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopCounterMetric;
}($a389090a076a5add$export$834a616d1cf278b);
var $a389090a076a5add$export$df09a35db160df98 = /** @class */ function(_super) {
    $a389090a076a5add$var$__extends(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopUpDownCounterMetric;
}($a389090a076a5add$export$834a616d1cf278b);
var $a389090a076a5add$export$b7f4a3c7ea16c24 = /** @class */ function(_super) {
    $a389090a076a5add$var$__extends(NoopGaugeMetric, _super);
    function NoopGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopGaugeMetric.prototype.record = function(_value, _attributes) {};
    return NoopGaugeMetric;
}($a389090a076a5add$export$834a616d1cf278b);
var $a389090a076a5add$export$ef064c3e0426c607 = /** @class */ function(_super) {
    $a389090a076a5add$var$__extends(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function(_value, _attributes) {};
    return NoopHistogramMetric;
}($a389090a076a5add$export$834a616d1cf278b);
var $a389090a076a5add$export$a5a3e7829c289482 = /** @class */ function() {
    function NoopObservableMetric() {}
    NoopObservableMetric.prototype.addCallback = function(_callback) {};
    NoopObservableMetric.prototype.removeCallback = function(_callback) {};
    return NoopObservableMetric;
}();
var $a389090a076a5add$export$7a7e4b169d5c93a8 = /** @class */ function(_super) {
    $a389090a076a5add$var$__extends(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}($a389090a076a5add$export$a5a3e7829c289482);
var $a389090a076a5add$export$6990a2f90809ffc1 = /** @class */ function(_super) {
    $a389090a076a5add$var$__extends(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}($a389090a076a5add$export$a5a3e7829c289482);
var $a389090a076a5add$export$3ec3555bc6f693a4 = /** @class */ function(_super) {
    $a389090a076a5add$var$__extends(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}($a389090a076a5add$export$a5a3e7829c289482);
var $a389090a076a5add$export$65e277d35235a01f = new $a389090a076a5add$export$c23c6f85dd4fc1e9();
var $a389090a076a5add$export$e6d19fe5233efc54 = new $a389090a076a5add$export$b556ba0f560c45b();
var $a389090a076a5add$export$dd01300aacbcec1c = new $a389090a076a5add$export$b7f4a3c7ea16c24();
var $a389090a076a5add$export$689c32a6a552e1a6 = new $a389090a076a5add$export$ef064c3e0426c607();
var $a389090a076a5add$export$2f189cd99d2b7429 = new $a389090a076a5add$export$df09a35db160df98();
var $a389090a076a5add$export$163422b94c3edbcb = new $a389090a076a5add$export$7a7e4b169d5c93a8();
var $a389090a076a5add$export$ea67e3c6ff624776 = new $a389090a076a5add$export$6990a2f90809ffc1();
var $a389090a076a5add$export$5b8be9ab17b673b3 = new $a389090a076a5add$export$3ec3555bc6f693a4();
function $a389090a076a5add$export$bc3a498ccbb5c2b5() {
    return $a389090a076a5add$export$65e277d35235a01f;
}

});




parcelRegister("gwbQ0", function(module, exports) {
$parcel$export(module.exports, "propagation", () => $c068d140f08cb467$export$3e49040daa9dba20);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $bCjzO = parcelRequire("bCjzO");
var $c068d140f08cb467$export$3e49040daa9dba20 = (0, $bCjzO.PropagationAPI).getInstance();

});
parcelRegister("bCjzO", function(module, exports) {
$parcel$export(module.exports, "PropagationAPI", () => $87526dd3fca0eac7$export$471eda0a6213cac9);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $jTV6N = parcelRequire("jTV6N");

var $a6A3m = parcelRequire("a6A3m");

var $60mVP = parcelRequire("60mVP");

var $dNPuZ = parcelRequire("dNPuZ");

var $bwzCI = parcelRequire("bwzCI");

var $TiYt8 = parcelRequire("TiYt8");
var $87526dd3fca0eac7$var$API_NAME = 'propagation';
var $87526dd3fca0eac7$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $a6A3m.NoopTextMapPropagator)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */ var $87526dd3fca0eac7$export$471eda0a6213cac9 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function PropagationAPI() {
        this.createBaggage = (0, $bwzCI.createBaggage);
        this.getBaggage = (0, $dNPuZ.getBaggage);
        this.getActiveBaggage = (0, $dNPuZ.getActiveBaggage);
        this.setBaggage = (0, $dNPuZ.setBaggage);
        this.deleteBaggage = (0, $dNPuZ.deleteBaggage);
    }
    /** Get the singleton instance of the Propagator API */ PropagationAPI.getInstance = function() {
        if (!this._instance) this._instance = new PropagationAPI();
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ PropagationAPI.prototype.setGlobalPropagator = function(propagator) {
        return (0, $jTV6N.registerGlobal)($87526dd3fca0eac7$var$API_NAME, propagator, (0, $TiYt8.DiagAPI).instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ PropagationAPI.prototype.inject = function(context, carrier, setter) {
        if (setter === void 0) setter = (0, $60mVP.defaultTextMapSetter);
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ PropagationAPI.prototype.extract = function(context, carrier, getter) {
        if (getter === void 0) getter = (0, $60mVP.defaultTextMapGetter);
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */ PropagationAPI.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */ PropagationAPI.prototype.disable = function() {
        (0, $jTV6N.unregisterGlobal)($87526dd3fca0eac7$var$API_NAME, (0, $TiYt8.DiagAPI).instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function() {
        return (0, $jTV6N.getGlobal)($87526dd3fca0eac7$var$API_NAME) || $87526dd3fca0eac7$var$NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}();

});
parcelRegister("a6A3m", function(module, exports) {
$parcel$export(module.exports, "NoopTextMapPropagator", () => $75b66e5b01f4c83c$export$8356c7eb3af7963b);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ var $75b66e5b01f4c83c$export$8356c7eb3af7963b = /** @class */ function() {
    function NoopTextMapPropagator() {}
    /** Noop inject function does nothing */ NoopTextMapPropagator.prototype.inject = function(_context, _carrier) {};
    /** Noop extract function does nothing and returns the input context */ NoopTextMapPropagator.prototype.extract = function(context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function() {
        return [];
    };
    return NoopTextMapPropagator;
}();

});

parcelRegister("60mVP", function(module, exports) {
$parcel$export(module.exports, "defaultTextMapGetter", () => $45f487e9285d4927$export$a0f575f55f38720a);
$parcel$export(module.exports, "defaultTextMapSetter", () => $45f487e9285d4927$export$f70f1d111fccf1c1);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $45f487e9285d4927$export$a0f575f55f38720a = {
    get: function(carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys: function(carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
var $45f487e9285d4927$export$f70f1d111fccf1c1 = {
    set: function(carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};

});

parcelRegister("dNPuZ", function(module, exports) {
$parcel$export(module.exports, "getBaggage", () => $a0c7cc91a89fce25$export$f3bffa0b5dd10d1e);
$parcel$export(module.exports, "getActiveBaggage", () => $a0c7cc91a89fce25$export$120a1756099436ee);
$parcel$export(module.exports, "setBaggage", () => $a0c7cc91a89fce25$export$adc9ca19eab3f500);
$parcel$export(module.exports, "deleteBaggage", () => $a0c7cc91a89fce25$export$4ca3a8a743c9f633);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $e5aXd = parcelRequire("e5aXd");

var $dCCNu = parcelRequire("dCCNu");
/**
 * Baggage key
 */ var $a0c7cc91a89fce25$var$BAGGAGE_KEY = (0, $dCCNu.createContextKey)('OpenTelemetry Baggage Key');
function $a0c7cc91a89fce25$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($a0c7cc91a89fce25$var$BAGGAGE_KEY) || undefined;
}
function $a0c7cc91a89fce25$export$120a1756099436ee() {
    return $a0c7cc91a89fce25$export$f3bffa0b5dd10d1e((0, $e5aXd.ContextAPI).getInstance().active());
}
function $a0c7cc91a89fce25$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($a0c7cc91a89fce25$var$BAGGAGE_KEY, baggage);
}
function $a0c7cc91a89fce25$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($a0c7cc91a89fce25$var$BAGGAGE_KEY);
}

});

parcelRegister("bwzCI", function(module, exports) {
$parcel$export(module.exports, "createBaggage", () => $863e50f0b81e71c4$export$1034a425c7384452);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $TiYt8 = parcelRequire("TiYt8");

var $fBmzt = parcelRequire("fBmzt");

var $55eBc = parcelRequire("55eBc");
var $863e50f0b81e71c4$var$diag = (0, $TiYt8.DiagAPI).instance();
function $863e50f0b81e71c4$export$1034a425c7384452(entries) {
    if (entries === void 0) entries = {};
    return new (0, $fBmzt.BaggageImpl)(new Map(Object.entries(entries)));
}
function $863e50f0b81e71c4$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== 'string') {
        $863e50f0b81e71c4$var$diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = '';
    }
    return {
        __TYPE__: (0, $55eBc.baggageEntryMetadataSymbol),
        toString: function() {
            return str;
        }
    };
}

});
parcelRegister("fBmzt", function(module, exports) {
$parcel$export(module.exports, "BaggageImpl", () => $b5bbd1e251e6b158$export$b8c511fa1a5f4987);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b5bbd1e251e6b158$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $b5bbd1e251e6b158$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $b5bbd1e251e6b158$export$b8c511fa1a5f4987 = /** @class */ function() {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function(key) {
        var entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(_a) {
            var _b = $b5bbd1e251e6b158$var$__read(_a, 2), k = _b[0], v = _b[1];
            return [
                k,
                v
            ];
        });
    };
    BaggageImpl.prototype.setEntry = function(key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function(key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function() {
        var e_1, _a;
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for(var keys_1 = $b5bbd1e251e6b158$var$__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function() {
        return new BaggageImpl();
    };
    return BaggageImpl;
}();

});

parcelRegister("55eBc", function(module, exports) {
$parcel$export(module.exports, "baggageEntryMetadataSymbol", () => $3b38be7506de47a0$export$92dd2fe8ddb5cb7);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ var $3b38be7506de47a0$export$92dd2fe8ddb5cb7 = Symbol('BaggageEntryMetadata');

});




parcelRegister("2cvl5", function(module, exports) {
$parcel$export(module.exports, "trace", () => $19a5031239cd3f24$export$357889f174732d38);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $3q1UK = parcelRequire("3q1UK");
var $19a5031239cd3f24$export$357889f174732d38 = (0, $3q1UK.TraceAPI).getInstance();

});
parcelRegister("3q1UK", function(module, exports) {
$parcel$export(module.exports, "TraceAPI", () => $27d548ec858449c5$export$2cccde6fcc7b568a);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $jTV6N = parcelRequire("jTV6N");

var $1ocWv = parcelRequire("1ocWv");

var $idFOa = parcelRequire("idFOa");

var $7SVLL = parcelRequire("7SVLL");

var $TiYt8 = parcelRequire("TiYt8");
var $27d548ec858449c5$var$API_NAME = 'trace';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */ var $27d548ec858449c5$export$2cccde6fcc7b568a = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function TraceAPI() {
        this._proxyTracerProvider = new (0, $1ocWv.ProxyTracerProvider)();
        this.wrapSpanContext = (0, $idFOa.wrapSpanContext);
        this.isSpanContextValid = (0, $idFOa.isSpanContextValid);
        this.deleteSpan = (0, $7SVLL.deleteSpan);
        this.getSpan = (0, $7SVLL.getSpan);
        this.getActiveSpan = (0, $7SVLL.getActiveSpan);
        this.getSpanContext = (0, $7SVLL.getSpanContext);
        this.setSpan = (0, $7SVLL.setSpan);
        this.setSpanContext = (0, $7SVLL.setSpanContext);
    }
    /** Get the singleton instance of the Trace API */ TraceAPI.getInstance = function() {
        if (!this._instance) this._instance = new TraceAPI();
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
        var success = (0, $jTV6N.registerGlobal)($27d548ec858449c5$var$API_NAME, this._proxyTracerProvider, (0, $TiYt8.DiagAPI).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    };
    /**
     * Returns the global tracer provider.
     */ TraceAPI.prototype.getTracerProvider = function() {
        return (0, $jTV6N.getGlobal)($27d548ec858449c5$var$API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */ TraceAPI.prototype.getTracer = function(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */ TraceAPI.prototype.disable = function() {
        (0, $jTV6N.unregisterGlobal)($27d548ec858449c5$var$API_NAME, (0, $TiYt8.DiagAPI).instance());
        this._proxyTracerProvider = new (0, $1ocWv.ProxyTracerProvider)();
    };
    return TraceAPI;
}();

});
parcelRegister("1ocWv", function(module, exports) {
$parcel$export(module.exports, "ProxyTracerProvider", () => $103212778747070d$export$4137aabcb4254962);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $23nnY = parcelRequire("23nnY");

var $46FqL = parcelRequire("46FqL");
var $103212778747070d$var$NOOP_TRACER_PROVIDER = new (0, $46FqL.NoopTracerProvider)();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */ var $103212778747070d$export$4137aabcb4254962 = /** @class */ function() {
    function ProxyTracerProvider() {}
    /**
     * Get a {@link ProxyTracer}
     */ ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $23nnY.ProxyTracer)(this, name, version, options);
    };
    ProxyTracerProvider.prototype.getDelegate = function() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $103212778747070d$var$NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */ ProxyTracerProvider.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}();

});
parcelRegister("23nnY", function(module, exports) {
$parcel$export(module.exports, "ProxyTracer", () => $17ee0083e1967f32$export$df2c38268c6bb6b3);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $12tBY = parcelRequire("12tBY");
var $17ee0083e1967f32$var$NOOP_TRACER = new (0, $12tBY.NoopTracer)();
/**
 * Proxy tracer provided by the proxy tracer provider
 */ var $17ee0083e1967f32$export$df2c38268c6bb6b3 = /** @class */ function() {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ ProxyTracer.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $17ee0083e1967f32$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}();

});
parcelRegister("12tBY", function(module, exports) {
$parcel$export(module.exports, "NoopTracer", () => $0c1cf28c1847f958$export$714c1036cabcd223);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $e5aXd = parcelRequire("e5aXd");

var $7SVLL = parcelRequire("7SVLL");

var $i8tx3 = parcelRequire("i8tx3");

var $idFOa = parcelRequire("idFOa");
var $0c1cf28c1847f958$var$contextApi = (0, $e5aXd.ContextAPI).getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */ var $0c1cf28c1847f958$export$714c1036cabcd223 = /** @class */ function() {
    function NoopTracer() {}
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function(name, options, context) {
        if (context === void 0) context = $0c1cf28c1847f958$var$contextApi.active();
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $i8tx3.NonRecordingSpan)();
        var parentFromContext = context && (0, $7SVLL.getSpanContext)(context);
        if ($0c1cf28c1847f958$var$isSpanContext(parentFromContext) && (0, $idFOa.isSpanContextValid)(parentFromContext)) return new (0, $i8tx3.NonRecordingSpan)(parentFromContext);
        else return new (0, $i8tx3.NonRecordingSpan)();
    };
    NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : $0c1cf28c1847f958$var$contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = (0, $7SVLL.setSpan)(parentContext, span);
        return $0c1cf28c1847f958$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}();
function $0c1cf28c1847f958$var$isSpanContext(spanContext) {
    return typeof spanContext === 'object' && typeof spanContext['spanId'] === 'string' && typeof spanContext['traceId'] === 'string' && typeof spanContext['traceFlags'] === 'number';
}

});
parcelRegister("7SVLL", function(module, exports) {
$parcel$export(module.exports, "getSpan", () => $5bda635535e8bad2$export$246e04ba06066af1);
$parcel$export(module.exports, "getActiveSpan", () => $5bda635535e8bad2$export$1be426a8e585c83e);
$parcel$export(module.exports, "setSpan", () => $5bda635535e8bad2$export$8ab2f2e6ee8ed0a8);
$parcel$export(module.exports, "deleteSpan", () => $5bda635535e8bad2$export$a6bbfe9a17f7941c);
$parcel$export(module.exports, "setSpanContext", () => $5bda635535e8bad2$export$c90bf5428c14cdb1);
$parcel$export(module.exports, "getSpanContext", () => $5bda635535e8bad2$export$1a635f8f0b912781);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $dCCNu = parcelRequire("dCCNu");

var $i8tx3 = parcelRequire("i8tx3");

var $e5aXd = parcelRequire("e5aXd");
/**
 * span key
 */ var $5bda635535e8bad2$var$SPAN_KEY = (0, $dCCNu.createContextKey)('OpenTelemetry Context Key SPAN');
function $5bda635535e8bad2$export$246e04ba06066af1(context) {
    return context.getValue($5bda635535e8bad2$var$SPAN_KEY) || undefined;
}
function $5bda635535e8bad2$export$1be426a8e585c83e() {
    return $5bda635535e8bad2$export$246e04ba06066af1((0, $e5aXd.ContextAPI).getInstance().active());
}
function $5bda635535e8bad2$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($5bda635535e8bad2$var$SPAN_KEY, span);
}
function $5bda635535e8bad2$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($5bda635535e8bad2$var$SPAN_KEY);
}
function $5bda635535e8bad2$export$c90bf5428c14cdb1(context, spanContext) {
    return $5bda635535e8bad2$export$8ab2f2e6ee8ed0a8(context, new (0, $i8tx3.NonRecordingSpan)(spanContext));
}
function $5bda635535e8bad2$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $5bda635535e8bad2$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}

});
parcelRegister("i8tx3", function(module, exports) {
$parcel$export(module.exports, "NonRecordingSpan", () => $d33fe1cbc1a96b7a$export$972d28f7c6a8c6c7);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $1L9tl = parcelRequire("1L9tl");
/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */ var $d33fe1cbc1a96b7a$export$972d28f7c6a8c6c7 = /** @class */ function() {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) _spanContext = (0, $1L9tl.INVALID_SPAN_CONTEXT);
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function() {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function(_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addLink = function(_link) {
        return this;
    };
    NonRecordingSpan.prototype.addLinks = function(_links) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function(_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function(_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function(_endTime) {};
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function() {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
    return NonRecordingSpan;
}();

});
parcelRegister("1L9tl", function(module, exports) {
$parcel$export(module.exports, "INVALID_SPANID", () => $1481873ac95b4715$export$55cc39fb0d4bb4c0);
$parcel$export(module.exports, "INVALID_TRACEID", () => $1481873ac95b4715$export$22be96e88d95e128);
$parcel$export(module.exports, "INVALID_SPAN_CONTEXT", () => $1481873ac95b4715$export$8591e4c852b66703);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $3IBE2 = parcelRequire("3IBE2");
var $1481873ac95b4715$export$55cc39fb0d4bb4c0 = '0000000000000000';
var $1481873ac95b4715$export$22be96e88d95e128 = '00000000000000000000000000000000';
var $1481873ac95b4715$export$8591e4c852b66703 = {
    traceId: $1481873ac95b4715$export$22be96e88d95e128,
    spanId: $1481873ac95b4715$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $3IBE2.TraceFlags).NONE
};

});
parcelRegister("3IBE2", function(module, exports) {
$parcel$export(module.exports, "TraceFlags", () => $2b52aea6ff5880a3$export$bf9049ad2b0883ff);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $2b52aea6ff5880a3$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($2b52aea6ff5880a3$export$bf9049ad2b0883ff || ($2b52aea6ff5880a3$export$bf9049ad2b0883ff = {}));

});




parcelRegister("idFOa", function(module, exports) {
$parcel$export(module.exports, "isSpanContextValid", () => $d439df1ba5a666a9$export$e4373b9a2c09216c);
$parcel$export(module.exports, "wrapSpanContext", () => $d439df1ba5a666a9$export$c19cc0f1911bdb85);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $1L9tl = parcelRequire("1L9tl");

var $i8tx3 = parcelRequire("i8tx3");
var $d439df1ba5a666a9$var$VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var $d439df1ba5a666a9$var$VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function $d439df1ba5a666a9$export$29dd34cf1269f6da(traceId) {
    return $d439df1ba5a666a9$var$VALID_TRACEID_REGEX.test(traceId) && traceId !== (0, $1L9tl.INVALID_TRACEID);
}
function $d439df1ba5a666a9$export$8e51c6d8f0586aff(spanId) {
    return $d439df1ba5a666a9$var$VALID_SPANID_REGEX.test(spanId) && spanId !== (0, $1L9tl.INVALID_SPANID);
}
function $d439df1ba5a666a9$export$e4373b9a2c09216c(spanContext) {
    return $d439df1ba5a666a9$export$29dd34cf1269f6da(spanContext.traceId) && $d439df1ba5a666a9$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $d439df1ba5a666a9$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $i8tx3.NonRecordingSpan)(spanContext);
}

});



parcelRegister("46FqL", function(module, exports) {
$parcel$export(module.exports, "NoopTracerProvider", () => $2fd7dc412726b7ed$export$87d8e93756f9e86e);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $12tBY = parcelRequire("12tBY");
/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */ var $2fd7dc412726b7ed$export$87d8e93756f9e86e = /** @class */ function() {
    function NoopTracerProvider() {}
    NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
        return new (0, $12tBY.NoopTracer)();
    };
    return NoopTracerProvider;
}();

});





parcelRegister("jcoDC", function(module, exports) {
$parcel$export(module.exports, "default", () => $54163c7a82e686f3$export$2e2bcd8739ae039);

var $40Sn3 = parcelRequire("40Sn3");

var $kHb6M = parcelRequire("kHb6M");

var $6yEEN = parcelRequire("6yEEN");

var $1ZJYO = parcelRequire("1ZJYO");

var $3iYgg = parcelRequire("3iYgg");

var $lN1hr = parcelRequire("lN1hr");

var $8pyDj = parcelRequire("8pyDj");

var $lbIUD = parcelRequire("lbIUD");

var $3CH4k = parcelRequire("3CH4k");

var $dK0yy = parcelRequire("dK0yy");

var $atzxl = parcelRequire("atzxl");

var $gAgTu = parcelRequire("gAgTu");

var $h6Sce = parcelRequire("h6Sce");

var $b4wuS = parcelRequire("b4wuS");

var $4YfNf = parcelRequire("4YfNf");

var $fsyj7 = parcelRequire("fsyj7");

var $7ruzK = parcelRequire("7ruzK");

var $7YjGB = parcelRequire("7YjGB");

var $gxsPs = parcelRequire("gxsPs");

var $ezsdd = parcelRequire("ezsdd");

var $3ykaG = parcelRequire("3ykaG");

var $4Pm5b = parcelRequire("4Pm5b");

var $9D95u = parcelRequire("9D95u");

var $8kCZu = parcelRequire("8kCZu");

var $79qz9 = parcelRequire("79qz9");

var $fMH0v = parcelRequire("fMH0v");

var $lches = parcelRequire("lches");

var $lqefr = parcelRequire("lqefr");

var $g34ub = parcelRequire("g34ub");

var $akdUN = parcelRequire("akdUN");

var $cof0D = parcelRequire("cof0D");

var $grc8S = parcelRequire("grc8S");

var $l0B9l = parcelRequire("l0B9l");

var $j8q2U = parcelRequire("j8q2U");

var $foSph = parcelRequire("foSph");

var $fSLua = parcelRequire("fSLua");

var $6RBzd = parcelRequire("6RBzd");

var $hNvco = parcelRequire("hNvco");

var $jIMQu = parcelRequire("jIMQu");
const $54163c7a82e686f3$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $54163c7a82e686f3$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        this._useStargate = (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        };
        this._changeInternalUserId = (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        };
        this._createSubproductGetter = (subproduct)=>(0, $3CH4k.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
        this._createEmbeddedProductGetter = (embeddedProduct)=>(0, $3CH4k.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
        this._getLastScreenEvent = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($54163c7a82e686f3$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch  {
                this._safeSessionStorage.removeItem($54163c7a82e686f3$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        };
        this._setLastScreenEvent = (event)=>{
            this._safeSessionStorage.setItem($54163c7a82e686f3$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        };
        this._shouldEventBeDelayed = (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        };
        this._fireEvent = (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $6yEEN.eventType).UI:
                case (0, $6yEEN.eventType).OPERATIONAL:
                case (0, $6yEEN.eventType).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $6yEEN.eventType).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $6yEEN.eventType).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        };
        this._fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        };
        this._delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        };
        this._processEvent = (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        };
        this.setEmbeddedProduct = (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        };
        this.clearEmbeddedProduct = ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        };
        this.setSubproduct = (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        };
        /**
    * Calling this function in the intialisation of the client in product
    * captures specified 'origin tracing' URL params and fires a single origin landed event
    * <p>
    * This function expects a mapping between the keys for any URL parameters
    *  that should be captured and removed for origin tracing
    * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
    * Each handler function should return an object with two items
    * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
    * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
    *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
    * </p>
    * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
    * e.g. from a share or email
    *
    * An example calling this function using an external decoding library, with taskSessionId specified to persist
    * analyticsWebClient.setOriginTracingHandlers({
         atlOrigin: encodedOrigin => {
             const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
             return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
         },
     });
    *
    * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
    * @this {AnalyticsWebClient}
    */ this.setOriginTracingHandlers = (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            const keys = Object.keys(capturedOriginTraces);
            keys.forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            keys.forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (keys.length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        };
        this.setTenantInfo = (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $6yEEN.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $7ruzK.isType)((0, $6yEEN.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $gxsPs.objectValues)((0, $6yEEN.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearTenantInfo = ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setOrgInfo = (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        };
        this.clearOrgInfo = ()=>{
            this._orgInfo = {};
        };
        this.setWorkspaceInfo = (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        };
        this.clearWorkspaceInfo = ()=>{
            this._workspaceInfo = {};
        };
        this.setCollaborationContextInfo = (collaborationContextAri)=>{
            if (!collaborationContextAri) throw new Error('Missing collaborationContextAri');
            this._collaborationContextInfo = {
                collaborationContextAri: collaborationContextAri
            };
        };
        this.clearCollaborationContextInfo = ()=>{
            this._collaborationContextInfo = {};
        };
        this.setUserInfo = (userIdType, userId)=>{
            (0, $grc8S.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearUserInfo = ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setAlias = (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $7ruzK.isType)((0, $6yEEN.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $gxsPs.objectValues)((0, $6yEEN.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        };
        this.clearAlias = ()=>{
            this._aliases = {};
        };
        this.setGroup = (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $7ruzK.isType)((0, $6yEEN.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $gxsPs.objectValues)((0, $6yEEN.groupType))}]`);
            this._groups[groupsKeyType] = group;
        };
        this.clearGroup = ()=>{
            this._groups = {};
        };
        this.getAnonymousId = ()=>this._userInfo.anonymousId;
        this.getCurrentSessionId = ()=>this._sessionTracking.getCurrentSessionId();
        this.setUIViewedAttributes = (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = {
                ...uiViewedAttributes
            };
        };
        this.getUIViewedAttributes = ()=>{
            return this._uiViewedAttributes;
        };
        this.clearUIViewedAttributes = ()=>{
            this._uiViewedAttributes = {};
        };
        this.appendUIViewedAttributes = (attributes)=>{
            if (!this._uiViewedAttributes) this._uiViewedAttributes = attributes;
            else this._uiViewedAttributes = {
                ...this._uiViewedAttributes,
                ...attributes
            };
        };
        this.sendIdentifyEvent = (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $6yEEN.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        };
        /**
   * @deprecated
   * please use {@link sendScreenEvent instead)
   */ this.sendPageEvent = (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        };
        /**
   * send screen event
   * @param event The event / For retrocompatibility event name is still supported here.
   * @param callback
   * @param attributes. Deprecated, will get ignored if using an event object as first param.
   */ this.sendScreenEvent = (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $foSph.validateScreenEvent)(screenName);
            (0, $cof0D.validateContainers)(screenContainers);
            const builtEvent = (0, $lbIUD.buildScreenEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = {
                name: screenName,
                ...builtEvent
            };
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $hNvco.default)(callback, builtEventWithName));
        };
        this.sendTrackEvent = (event, callback)=>{
            (0, $fSLua.validateTrackEvent)(event);
            const builtEvent = (0, $3iYgg.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $6yEEN.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $lN1hr.buildActionName)(event), builtEvent, this._context, (0, $hNvco.default)(callback, builtEvent));
        };
        this.sendUIEvent = (event, callback)=>{
            (0, $6RBzd.validateUIEvent)(event);
            const builtEvent = (0, $3iYgg.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $6yEEN.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $lN1hr.buildActionName)(event), builtEvent, this._context, (0, $hNvco.default)(callback, builtEvent));
        };
        this.sendOperationalEvent = (event, callback)=>{
            (0, $l0B9l.validateOperationalEvent)(event);
            const builtEvent = (0, $3iYgg.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $6yEEN.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $lN1hr.buildActionName)(event), builtEvent, this._context, (0, $hNvco.default)(callback, builtEvent));
        };
        this.startUIViewedEvent = (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = this.createUIViewedEvent(callback);
            this._uiViewedEvent.start();
        };
        this.stopUIViewedEvent = ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        };
        this.resetUIViewedTimers = ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        };
        this.signalUserActive = ()=>{
            let uiViewedEvent = this._uiViewedEvent || this.createUIViewedEvent(null);
            uiViewedEvent.signalUserActive();
        };
        this.createUIViewedEvent = (callback)=>{
            return new (0, $lqefr.default)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
        };
        this.startApdexEvent = (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        };
        this.getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
        this.stopApdexEvent = (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        };
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        this.startLowPriorityEventDelay = (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        };
        this.stopLowPriorityEventDelay = ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        };
        this.onEvent = (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $6yEEN.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $6yEEN.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $6yEEN.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $6yEEN.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $6yEEN.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $gxsPs.objectValues)((0, $6yEEN.eventType))}]`);
        };
        this.setResponseCallback = (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $7ruzK.isType)((0, $6yEEN.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $gxsPs.objectValues)((0, $6yEEN.envType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $6yEEN.originType).WEB;
        else if (!(0, $7ruzK.isType)((0, $6yEEN.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $gxsPs.objectValues)((0, $6yEEN.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $6yEEN.originType).WEB ? (0, $6yEEN.platformType).WEB : (0, $6yEEN.platformType).DESKTOP;
        else (0, $j8q2U.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        // Auto-detect Oasis perimeter (e.g. FedRAMP Moderate) when the consumer hasn't explicitly provided a perimeter.
        if (!productInfo.perimeter) try {
            if ((0, $40Sn3.isFedrampModerate)()) productInfo.perimeter = (0, $6yEEN.perimeterType).FEDRAMP_MODERATE;
        } catch (e) {
            this._logger.warn('Failed to auto-detect perimeter: %s', e instanceof Error ? e.message : String(e));
        }
        // Default to commercial perimeter if not explicitly provided and not auto-detected.
        if (!productInfo.perimeter) productInfo.perimeter = (0, $6yEEN.perimeterType).COMMERCIAL;
        if (!(0, $7ruzK.isType)((0, $6yEEN.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be a perimeterType: [${(0, $gxsPs.objectValues)((0, $6yEEN.perimeterType))}]`);
        // Auto-detect Oasis Isolated Cloud (IC) environment when the consumer hasn't explicitly provided an `ic` value.
        if (!productInfo.ic) try {
            const icId = (0, $kHb6M.isolationContextId)();
            if (icId && icId.length > 0) productInfo.ic = icId;
        } catch (e) {
            this._logger.warn('Failed to auto-detect isolation context: %s', e instanceof Error ? e.message : String(e));
        }
        this._internalProductInfo = {
            ...productInfo,
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        };
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo?.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $4YfNf.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $fsyj7.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $8pyDj.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $8kCZu.default)();
        const useStargate = this._useStargate(settings.useStargate);
        const apiHost = (0, $4Pm5b.selectHost)({
            useStargate: useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride,
            apiHost: settings.apiHost
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts,
            maxQueueSize: settings.maxQueueSize
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $jIMQu.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $b4wuS.MetadataClient).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $h6Sce.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: (0, $7YjGB.LoggingResponseCallback).getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings?.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $3ykaG.default)();
        this._tabTracking = new (0, $79qz9.default)();
        this._sessionTracking = new (0, $9D95u.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $fMH0v.default)();
        this._originTracing = new (0, $ezsdd.default)();
        this._eventProcessor.setOriginTracingClient(this._originTracing);
        // Init Apdex
        this._apdexEvent = new (0, $1ZJYO.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $atzxl.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, $gAgTu.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $lches.default)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = (0, $akdUN.default)();
        this._workspaceInfo = {};
        this._collaborationContextInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, $dK0yy.default)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, $g34ub.TestSupport).isGeminiVREnvironment() && !(0, $g34ub.TestSupport).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, $g34ub.TestSupport).isGeminiVREnvironment() && !(0, $g34ub.TestSupport).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties. They are not part of the public
   * API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get task() {
        return this._task;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties.
   * They are not part of the public API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get _productInfo() {
        return this._internalProductInfo;
    }
}

});
parcelRegister("6yEEN", function(module, exports) {
$parcel$export(module.exports, "envType", () => $a692e4b02a0c1cd3$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $a692e4b02a0c1cd3$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $a692e4b02a0c1cd3$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $a692e4b02a0c1cd3$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $a692e4b02a0c1cd3$export$496f06ac2a964da2);
$parcel$export(module.exports, "productEmbedType", () => $a692e4b02a0c1cd3$export$f49776dca27a2e7c);
$parcel$export(module.exports, "userType", () => $a692e4b02a0c1cd3$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $a692e4b02a0c1cd3$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $a692e4b02a0c1cd3$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $a692e4b02a0c1cd3$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $a692e4b02a0c1cd3$export$62a500c02dc63ee);
$parcel$export(module.exports, "perimeterType", () => $a692e4b02a0c1cd3$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $a692e4b02a0c1cd3$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $a692e4b02a0c1cd3$export$e73680b18d9b7c6e);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.


var $a692e4b02a0c1cd3$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $a692e4b02a0c1cd3$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $a692e4b02a0c1cd3$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
   *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
   */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $a692e4b02a0c1cd3$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $a692e4b02a0c1cd3$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $a692e4b02a0c1cd3$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
var $a692e4b02a0c1cd3$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $a692e4b02a0c1cd3$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $a692e4b02a0c1cd3$export$809831be6c4c6227 = Object.freeze([
    "desktop",
    "mac",
    "linux",
    "windows"
]);
const $a692e4b02a0c1cd3$export$19c579398ad213e7 = Object.freeze([
    "web",
    "mobileWeb"
]);
var $a692e4b02a0c1cd3$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
var $a692e4b02a0c1cd3$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var $a692e4b02a0c1cd3$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var $a692e4b02a0c1cd3$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var $a692e4b02a0c1cd3$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("1ZJYO", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb770e91d1096bd5$export$2e2bcd8739ae039);

var $6yEEN = parcelRequire("6yEEN");

var $7ruzK = parcelRequire("7ruzK");

var $3ykaG = parcelRequire("3ykaG");

var $9xHYC = parcelRequire("9xHYC");
class $bb770e91d1096bd5$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        this._getEventKey = ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task;
        this._getEventTimingByName = (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        };
        this._getApdexFields = (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return {
                ...apdexTimings,
                apdex: apdexScore
            };
        };
        this._getApdexTimings = (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        };
        this._getStartTime = (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $6yEEN.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        };
        this._getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
        this._cleanApdexState = (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        };
        this._getVisibilityFields = (event)=>{
            let isActiveTab;
            /**
     * For initialLoad type:
     * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
     *
     * For transition type:
     * 1. active status is tracked in active events map (_isActiveEvents)
     *
     * For any type, if startTime or stopTime is specified:
     * 1. If currently active (!_isHidden)
     */ if (event.type === (0, $6yEEN.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $6yEEN.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        };
        this._calculateApdex = ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        };
        this._validateStartEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        };
        this._validateStopEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $7ruzK.isType)((0, $6yEEN.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
     * For a transition, if the startTime was not specified,
     * the start event should have been present.
     */ if (!event.startTime && event.type === (0, $6yEEN.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        };
        this._shouldSendEvent = (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        };
        this._sendEvent = (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: {
                    ...event.additionalAttributes,
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                }
            }, callback);
        };
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $3ykaG.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $9xHYC.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent({
            ...event,
            ...apdexFields,
            ...visibilityFields
        }, callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}

});
parcelRegister("7ruzK", function(module, exports) {
$parcel$export(module.exports, "isType", () => $942ae326c64d4b3c$export$26b9f946b448f23e);
function $942ae326c64d4b3c$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}

});

parcelRegister("3ykaG", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e68099b8055df71$export$2e2bcd8739ae039);
class $1e68099b8055df71$export$2e2bcd8739ae039 {
    constructor(){
        this._bindEventListeners = ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        };
        this._handleVisibilityChange = ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        };
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}

});

parcelRegister("9xHYC", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8e99bdabf07b9b0$export$2e2bcd8739ae039);
class $e8e99bdabf07b9b0$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("3iYgg", function(module, exports) {
$parcel$export(module.exports, "buildActionEvent", () => $1b7f8c1def5a81fb$export$7bf451af4a8e3dd9);

var $ccwBB = parcelRequire("ccwBB");

var $9Fdu2 = parcelRequire("9Fdu2");

var $esDM1 = parcelRequire("esDM1");

var $5z1qe = parcelRequire("5z1qe");

var $1s0TO = parcelRequire("1s0TO");

var $2CsWn = parcelRequire("2CsWn");

var $9GsyC = parcelRequire("9GsyC");

var $4PRIc = parcelRequire("4PRIc");

var $9yHtD = parcelRequire("9yHtD");

var $6G0jx = parcelRequire("6G0jx");

var $7aK3r = parcelRequire("7aK3r");
function $1b7f8c1def5a81fb$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, aliases, groups) {
    const productFields = (0, $9GsyC.buildProductFields)(productInfo, (0, $7aK3r.extractProductOverrides)(event));
    const tenantFields = (0, $4PRIc.buildTenantFields)(tenantInfo);
    const orgFields = (0, $2CsWn.buildOrgFields)(orgInfo);
    const workspaceFields = (0, $6G0jx.buildWorkspaceFields)(workspaceInfo);
    const collaborationContextFields = (0, $esDM1.buildCollaborationContextFields)(collaborationContextInfo);
    const userFields = (0, $9yHtD.buildUserFields)(userInfo);
    const actionFields = (0, $ccwBB.buildActionFields)(event, actionEventType);
    return {
        ...productFields,
        ...tenantFields,
        ...orgFields,
        ...userFields,
        ...actionFields,
        ...(0, $5z1qe.buildEventOverrides)(event),
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...collaborationContextFields,
        ...(0, $9Fdu2.buildAliases)(aliases),
        ...(0, $1s0TO.buildGroups)(groups)
    };
}

});
parcelRegister("ccwBB", function(module, exports) {
$parcel$export(module.exports, "buildActionFields", () => $aef1fe9e0da53e0a$export$655ecf7241feac42);

var $4sYlB = parcelRequire("4sYlB");
function $aef1fe9e0da53e0a$export$655ecf7241feac42(event, actionEventType) {
    return {
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType,
        ...(0, $4sYlB.buildContainersWithName)(event.containers)
    };
}

});
parcelRegister("4sYlB", function(module, exports) {
$parcel$export(module.exports, "buildContainersWithName", () => $7b54f3ab6b33c0aa$export$f045f238d77c002a);

var $4PVz9 = parcelRequire("4PVz9");

var $7G38G = parcelRequire("7G38G");

var $4DHf6 = parcelRequire("4DHf6");
function $7b54f3ab6b33c0aa$export$f045f238d77c002a(containers) {
    if ((0, $4DHf6.isNotEmptyObject)(containers)) {
        const validContainers = (0, $7G38G.filterAndBuildContainers)(containers);
        return (0, $4PVz9.buildAttributesWithName)('containers', validContainers);
    }
    return undefined;
}

});
parcelRegister("4PVz9", function(module, exports) {
$parcel$export(module.exports, "buildAttributesWithName", () => $0b0f0453a35bd567$export$55b70947967d0b50);

var $4DHf6 = parcelRequire("4DHf6");
function $0b0f0453a35bd567$export$55b70947967d0b50(name, attrObject) {
    return (0, $4DHf6.isNotEmptyObject)(attrObject) ? {
        [name]: attrObject
    } : undefined;
}

});
parcelRegister("4DHf6", function(module, exports) {
$parcel$export(module.exports, "isNotEmptyObject", () => $3e002eff01f90b9a$export$e0287cc73292b477);

var $gmwxH = parcelRequire("gmwxH");
function $3e002eff01f90b9a$export$e0287cc73292b477(obj) {
    return (0, $gmwxH.isPlainObject)(obj) && Object.keys(obj).length > 0;
}

});
parcelRegister("gmwxH", function(module, exports) {
$parcel$export(module.exports, "isPlainObject", () => $abbe47506c4ffbc8$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $abbe47506c4ffbc8$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $abbe47506c4ffbc8$var$isObjectObject(o) {
    return $abbe47506c4ffbc8$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $abbe47506c4ffbc8$export$53b83ca8eaab0383(o) {
    if ($abbe47506c4ffbc8$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($abbe47506c4ffbc8$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});



parcelRegister("7G38G", function(module, exports) {
$parcel$export(module.exports, "filterAndBuildContainers", () => $0105553f665bac77$export$3f5115a568819c1a);
function $0105553f665bac77$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}

});



parcelRegister("9Fdu2", function(module, exports) {
$parcel$export(module.exports, "buildAliases", () => $ba60058d2167ecc4$export$2c4ef8ee173bbcaa);

var $4DHf6 = parcelRequire("4DHf6");
function $ba60058d2167ecc4$export$2c4ef8ee173bbcaa(aliases) {
    if ((0, $4DHf6.isNotEmptyObject)(aliases)) return {
        aliases: aliases
    };
    return undefined;
}

});

parcelRegister("esDM1", function(module, exports) {
$parcel$export(module.exports, "buildCollaborationContextFields", () => $6e559bb992c62c9e$export$d138783ff9effae1);
function $6e559bb992c62c9e$export$d138783ff9effae1(collaborationContextInfo) {
    return {
        collaborationContextAri: collaborationContextInfo.collaborationContextAri
    };
}

});

parcelRegister("5z1qe", function(module, exports) {
$parcel$export(module.exports, "buildEventOverrides", () => $34d8998188d499af$export$469803cc371327c2);
function $34d8998188d499af$export$469803cc371327c2(event) {
    let result = {};
    if (event.anonymousId) result.anonymousId = event.anonymousId;
    if (event.excludedProperties) result.excludedProperties = event.excludedProperties;
    if (event.userConsents) result.userConsents = event.userConsents;
    return result;
}

});

parcelRegister("1s0TO", function(module, exports) {
$parcel$export(module.exports, "buildGroups", () => $f0d143005b7667d1$export$680f59e10d3eb269);

var $4DHf6 = parcelRequire("4DHf6");
function $f0d143005b7667d1$export$680f59e10d3eb269(groups) {
    if ((0, $4DHf6.isNotEmptyObject)(groups)) return {
        groups: groups
    };
    return undefined;
}

});

parcelRegister("2CsWn", function(module, exports) {
$parcel$export(module.exports, "buildOrgFields", () => $63758ee62a4f1e1b$export$19ccbe55c9aa75d5);
function $63758ee62a4f1e1b$export$19ccbe55c9aa75d5(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}

});

parcelRegister("9GsyC", function(module, exports) {
$parcel$export(module.exports, "buildProductFields", () => $7cd56c5bc3b0bf62$export$bd1896e45d2ef8e8);

var $kQaMY = parcelRequire("kQaMY");
function $7cd56c5bc3b0bf62$export$bd1896e45d2ef8e8(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = (0, $kQaMY.getProductField)(productInfo.env, overrides.env);
    const product = (0, $kQaMY.getProductField)(productInfo.product, overrides.product);
    const subproduct = (0, $kQaMY.getProductField)(productInfo.subproduct(), overrides.subproduct);
    const version = (0, $kQaMY.getProductField)(productInfo.version, overrides.version);
    const origin = (0, $kQaMY.getProductField)(productInfo.origin, overrides.origin);
    const platform = (0, $kQaMY.getProductField)(productInfo.platform, overrides.platform);
    const ic = productInfo.ic; // ic should not be overriden once set
    const cdp = productInfo.cdp;
    const csp = productInfo.csp;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic,
        cdp: cdp,
        csp: csp
    };
}

});
parcelRegister("kQaMY", function(module, exports) {
$parcel$export(module.exports, "getProductField", () => $e2af6aa32a904c3a$export$690c718dc8037b2e);
function $e2af6aa32a904c3a$export$690c718dc8037b2e(field, override) {
    return override === undefined ? field : override;
}

});


parcelRegister("4PRIc", function(module, exports) {
$parcel$export(module.exports, "buildTenantFields", () => $1908dd568b6686f6$export$ab02ab56ae59d840);
function $1908dd568b6686f6$export$ab02ab56ae59d840(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}

});

parcelRegister("9yHtD", function(module, exports) {
$parcel$export(module.exports, "buildUserFields", () => $b19436ed040f8c1b$export$4557a3fdd8921d68);
function $b19436ed040f8c1b$export$4557a3fdd8921d68(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}

});

parcelRegister("6G0jx", function(module, exports) {
$parcel$export(module.exports, "buildWorkspaceFields", () => $f0d3e0fc12391323$export$73c41604cd4b31da);
function $f0d3e0fc12391323$export$73c41604cd4b31da(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}

});

parcelRegister("7aK3r", function(module, exports) {
$parcel$export(module.exports, "extractProductOverrides", () => $7a92e3d12dbbb862$export$e3d99b4bfec06f6e);
function $7a92e3d12dbbb862$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}

});


parcelRegister("lN1hr", function(module, exports) {
$parcel$export(module.exports, "buildActionName", () => $9fcf9612755f891a$export$9c5623a792efc9b0);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $9fcf9612755f891a$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}

});

parcelRegister("8pyDj", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $25cb2866e2d44cd5$export$3a7fe28f9bf4f3d9);

var $d7DAo = parcelRequire("d7DAo");
const $25cb2866e2d44cd5$var$libraryVersion = undefined;
function $25cb2866e2d44cd5$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return (0, $d7DAo.validationMode).QUIET;
    if (environment.includes('prod')) return (0, $d7DAo.validationMode).QUIET;
    return (0, $d7DAo.validationMode).COMPLETE;
}
function $25cb2866e2d44cd5$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $25cb2866e2d44cd5$var$libraryVersion
            },
            validationMode: $25cb2866e2d44cd5$var$getDefaultValidationMode(productInfo)
        }
    };
}

});
parcelRegister("d7DAo", function(module, exports) {
$parcel$export(module.exports, "validationMode", () => $2dd4ee677fb28b79$export$fbd92247fb4d6159);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $2dd4ee677fb28b79$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});

});


parcelRegister("lbIUD", function(module, exports) {
$parcel$export(module.exports, "buildScreenEvent", () => $50850c72f9250f53$export$c7d9a5f56acc4b19);

var $6yEEN = parcelRequire("6yEEN");

var $9Fdu2 = parcelRequire("9Fdu2");

var $4PVz9 = parcelRequire("4PVz9");

var $esDM1 = parcelRequire("esDM1");

var $4sYlB = parcelRequire("4sYlB");

var $5z1qe = parcelRequire("5z1qe");

var $1s0TO = parcelRequire("1s0TO");

var $2CsWn = parcelRequire("2CsWn");

var $9GsyC = parcelRequire("9GsyC");

var $4PRIc = parcelRequire("4PRIc");

var $9yHtD = parcelRequire("9yHtD");

var $6G0jx = parcelRequire("6G0jx");
function $50850c72f9250f53$var$buildAttributes(attributes) {
    return (0, $4PVz9.buildAttributesWithName)('attributes', attributes);
}
function $50850c72f9250f53$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return (0, $4PVz9.buildAttributesWithName)('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $50850c72f9250f53$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, event, containers, aliases, groups) {
    const productFields = (0, $9GsyC.buildProductFields)(productInfo);
    const tenantFields = (0, $4PRIc.buildTenantFields)(tenantInfo);
    const userFields = (0, $9yHtD.buildUserFields)(userInfo);
    const orgFields = (0, $2CsWn.buildOrgFields)(orgInfo);
    const workspaceFields = (0, $6G0jx.buildWorkspaceFields)(workspaceInfo);
    const collaborationContextFields = (0, $esDM1.buildCollaborationContextFields)(collaborationContextInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $6yEEN.eventType).SCREEN
    };
    return {
        ...productFields,
        ...tenantFields,
        ...userFields,
        ...orgFields,
        ...overrides,
        ...$50850c72f9250f53$var$buildAttributes(attributes),
        ...$50850c72f9250f53$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
        ...(0, $4sYlB.buildContainersWithName)(containers),
        ...(0, $5z1qe.buildEventOverrides)(event),
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...collaborationContextFields,
        ...(0, $9Fdu2.buildAliases)(aliases),
        ...(0, $1s0TO.buildGroups)(groups)
    };
}

});

parcelRegister("3CH4k", function(module, exports) {
$parcel$export(module.exports, "default", () => $a91154a2bb04128b$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $a91154a2bb04128b$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $a91154a2bb04128b$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($a91154a2bb04128b$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("dK0yy", function(module, exports) {
$parcel$export(module.exports, "default", () => $53f26d303ce3621e$export$2e2bcd8739ae039);

var $6V50t = parcelRequire("6V50t");
var $5mPNA = parcelRequire("5mPNA");
var $9t0G7 = parcelRequire("9t0G7");

var $6yEEN = parcelRequire("6yEEN");

var $aNsr9 = parcelRequire("aNsr9");
const $53f26d303ce3621e$var$isCrossProductInteractionAttribute = (_, paramName)=>{
    return paramName === (0, $5mPNA.URL_QUERY_PARAM_INTERACTION_SESSION);
};
class $53f26d303ce3621e$export$2e2bcd8739ae039 {
    constructor(options){
        this.validProduct = false;
        this.isEnabled = options.perimeter !== (0, $6yEEN.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            let bridge;
            let interactionSessionId;
            let interactionSource;
            let interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, $9t0G7.validProducts).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                const crossProductUrlPramater = (0, $aNsr9.default)($53f26d303ce3621e$var$isCrossProductInteractionAttribute, options.historyReplaceFn);
                const interactionSessionBlob = (0, $5mPNA.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, $5mPNA.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    const interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch  {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, $6V50t.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
    getInteractionSession() {
        if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
            bridge: this.analyticsCrossProductInteractionClient.getBridge(),
            id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
            prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
            source: this.analyticsCrossProductInteractionClient.getInteractionSource()
        };
        else return {
            bridge: null,
            id: null,
            prevId: null,
            source: null
        };
    }
    /**
   * Validates the cross product interaction session parameters parsed from the URL (if present)
   * If the Base64-encoded URL does not decode into a valid JSON object
   *
   * This method must be called out of the constructor, as the sendEventCallback we expect here
   * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
   */ validateInteractionSession() {
        if (!this.urlValidation.result) this.sendEventCallback({
            action: 'corrupted',
            actionSubject: 'interactionSession',
            attributes: {
                url: this.urlValidation.url
            },
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
}

});
parcelRegister("6V50t", function(module, exports) {
$parcel$export(module.exports, "default", () => $830da856f38c5e68$export$2e2bcd8739ae039);

var $cc5qg = parcelRequire("cc5qg");

var $40Sn3 = parcelRequire("40Sn3");

var $2aEiL = parcelRequire("2aEiL");

var $f2gT6 = parcelRequire("f2gT6");

var $cqoOu = parcelRequire("cqoOu");
const $830da856f38c5e68$export$b9dd752fb13352ce = 'interactionSession.source';
const $830da856f38c5e68$export$e04e3c50573f9af7 = 'interactionSession.bridge';
class $830da856f38c5e68$export$2e2bcd8739ae039 {
    constructor(interactionSessionOptions, bridge, interactionSource){
        this.getCurrentInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
        this.getPreviousInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
        this.getBridge = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($830da856f38c5e68$export$e04e3c50573f9af7) : null;
        this.getInteractionSource = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($830da856f38c5e68$export$b9dd752fb13352ce) : null;
        const shouldDisable = (0, $2aEiL.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $cc5qg.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $40Sn3.isFedrampModerate)();
        this.isEnabled = !shouldDisable;
        if (this.isEnabled) {
            // Get singleton interaction session tracking instance
            this.interactionSessionTracking = (0, $f2gT6.default).getInstance();
            let isValidPersistedId = false;
            if (this.interactionSessionTracking) {
                if (interactionSessionOptions) {
                    this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                    isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
                }
            }
            this.safeSessionStorage = new (0, $cqoOu.default)();
            // Store other interaction session parameters directly in session storage if ID has been validated
            if (isValidPersistedId) {
                bridge && this.safeSessionStorage.setItem($830da856f38c5e68$export$e04e3c50573f9af7, bridge);
                interactionSource && this.safeSessionStorage.setItem($830da856f38c5e68$export$b9dd752fb13352ce, interactionSource);
            }
        }
    }
}

});
parcelRegister("f2gT6", function(module, exports) {
$parcel$export(module.exports, "default", () => $202c63cd0e47e67e$export$2e2bcd8739ae039);

var $koGM0 = parcelRequire("koGM0");
const $202c63cd0e47e67e$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $202c63cd0e47e67e$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($202c63cd0e47e67e$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$202c63cd0e47e67e$export$7bc189309d2ad463];
            else {
                // Initialise InteractionSessionTracking on global window object
                window[$202c63cd0e47e67e$export$7bc189309d2ad463] = new (0, $koGM0.default)();
                interactionSessionTracking = window[$202c63cd0e47e67e$export$7bc189309d2ad463];
            }
        } catch (error) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}

});
parcelRegister("koGM0", function(module, exports) {
$parcel$export(module.exports, "INTERACTION_SESSION_ID_UPDATED_EVENT", () => $89c82a4959e50539$export$5d4c4eab0863aae3);
$parcel$export(module.exports, "default", () => $89c82a4959e50539$export$2e2bcd8739ae039);

var $cqoOu = parcelRequire("cqoOu");
const $89c82a4959e50539$var$INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
const $89c82a4959e50539$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
const $89c82a4959e50539$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
const $89c82a4959e50539$export$285f6bddd927a06d = 1800000; // 30 minutes
const $89c82a4959e50539$export$d050a4cab1b9f734 = 86400000; // 24 hours
const $89c82a4959e50539$export$a92e915d70316eb2 = 5000; // 5 seconds
const $89c82a4959e50539$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $89c82a4959e50539$var$INTEGER_REGEX = /^\d+$/;
const $89c82a4959e50539$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
class $89c82a4959e50539$export$2e2bcd8739ae039 {
    constructor(){
        this.analyticsReady = false;
        this.generateNewSessionId = ()=>{
            if (!this.analyticsReady) return null;
            const currentSessionId = this.safeSessionStorage.getItem($89c82a4959e50539$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            const newSessionId = Date.now().toString();
            this.safeSessionStorage.setItem($89c82a4959e50539$var$INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            const { isValidSession: isValidSession } = this.getCurrentSessionParams();
            if (!isValidSession) // If session is not valid at this point, something has gone wrong with Session Storage access
            // Calling sendInteractionSessionEvent now would result in an infinite loop, so we terminate
            return null;
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                this.safeSessionStorage.setItem($89c82a4959e50539$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                this.sendInteractionSessionEvent('renewed');
            } else this.sendInteractionSessionEvent('started');
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event($89c82a4959e50539$export$5d4c4eab0863aae3));
            return newSessionId;
        };
        this.updateSessionExpiry = ()=>{
            const expiry = Date.now() + this.sessionExpiryTime;
            this.safeSessionStorage.setItem($89c82a4959e50539$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this.debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { updateSessionExpiry: updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this.sessionExpiryDebounceThresholdPercentage * this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (this.sessionExpiryDebounceTimer) clearTimeout(this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this.sessionExpiryDebounceTimer = setTimeout(()=>{
                    updateSessionExpiry();
                }, this.sessionExpiryDebounce);
            }
        };
        this.sessionExpiryTime = $89c82a4959e50539$export$285f6bddd927a06d;
        this.sessionExpiryDebounce = $89c82a4959e50539$export$a92e915d70316eb2;
        this.sessionExpiryDebounceThresholdPercentage = $89c82a4959e50539$export$de43760b2dc10c19;
        this.safeSessionStorage = new (0, $cqoOu.default)();
    }
    getCurrentInteractionSessionId() {
        try {
            const { isValidSession: isValidSession, sessionExpiry: sessionExpiry, sessionId: sessionId } = this.getCurrentSessionParams();
            // If we have an existing valid session we can return the sessionId straight away
            if (isValidSession) {
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return sessionId;
            }
            // To generate a new session ID we must ensure analytics is ready
            if (this.analyticsReady) {
                // Session expiry update must occur before generateNewSessionId. Otherwise we were running
                // into issues of calls attempting to read the session ID before a valid expiry had been set
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return this.generateNewSessionId();
            }
        } catch (err) {
        // Silently swallow exception
        }
        return null;
    }
    getPreviousInteractionSessionId() {
        return this.safeSessionStorage.getItem($89c82a4959e50539$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
    }
    setInteractionSessionId(persistedSessionId) {
        if (this.validateSessionId(persistedSessionId)) {
            const currentSessionId = this.safeSessionStorage.getItem($89c82a4959e50539$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            // If we are already on the required session ID, just return true and make no changes
            // This can happen if the persisted session ID in options is the same as the current session ID
            // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
            // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
            if (currentSessionId === persistedSessionId) return false;
            // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
            // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
            this.debouncedUpdateSessionExpiry(0);
            this.safeSessionStorage.setItem($89c82a4959e50539$var$INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
            this.safeSessionStorage.removeItem($89c82a4959e50539$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            document.dispatchEvent(new Event($89c82a4959e50539$export$5d4c4eab0863aae3));
            return true;
        }
        return false;
    }
    // Must be called with a valid sendEvent function for other methods to work
    setAnalyticsCallback(sendEventCallback) {
        if (this.analyticsReady) // If we already have a valid callback, don't over-write it
        return;
        if (sendEventCallback && typeof sendEventCallback === 'function') {
            this.sendEventCallback = sendEventCallback;
            this.analyticsReady = true;
        } else this.analyticsReady = false;
    }
    validateSessionId(sessionId) {
        // Check if persisted session ID can parse as valid Unix timestamp
        if (sessionId && $89c82a4959e50539$var$INTEGER_REGEX.test(sessionId)) {
            const sessionAge = Date.now() - parseInt(sessionId, 10);
            // Validate that timestamp is not a future time, and is also within the TTL
            if (sessionAge >= 0 && sessionAge <= $89c82a4959e50539$export$d050a4cab1b9f734) return true;
        }
        return false;
    }
    /*
   * This function retrieves the current session ID and expiry from SessionStorage
   * It runs the necessary checks to ensure the session ID is valid and within expiry
   *
   * It returns the values along with a `validSession` boolean
   */ getCurrentSessionParams() {
        const sessionId = this.safeSessionStorage.getItem($89c82a4959e50539$var$INTERACTION_SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this.safeSessionStorage.getItem($89c82a4959e50539$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
   * This function sends a GASv3 analytics event indicating the interaction session has started or renewed
   * It requires this.sendEventCallback to be set via Analytics Web Client to a valid operational event sender function
   *
   * Note that Analytics Web Client's callback function will make its own call to getCurrentInteractionSessionId to retrieve the session ID
   * to attach to the event, so a valid session ID/expiry must be retrievable from SessionStorage before this function is called to avoid infinite loops.
   *
   * This is not an ideal solution but it works with the current architecture of Analytics Web Client.
   */ sendInteractionSessionEvent(action) {
        this.sendEventCallback && this.sendEventCallback({
            action: action,
            actionSubject: 'interactionSession',
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
}

});
parcelRegister("cqoOu", function(module, exports) {
$parcel$export(module.exports, "default", () => $51b6f04e65ca85d4$export$2e2bcd8739ae039);

var $kVBH4 = parcelRequire("kVBH4");

var $cbgsz = parcelRequire("cbgsz");
class $51b6f04e65ca85d4$export$2e2bcd8739ae039 extends (0, $cbgsz.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = window.sessionStorage || (0, $kVBH4.default);
        } catch (err) {
            storageToUse = (0, $kVBH4.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("kVBH4", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7067c2d36788641$export$2e2bcd8739ae039);

var $aoEbD = parcelRequire("aoEbD");
// eslint-disable-next-line import/no-anonymous-default-export
const $e7067c2d36788641$var$inmemorystorage = new (0, $aoEbD.InMemoryStore)();
var $e7067c2d36788641$export$2e2bcd8739ae039 = $e7067c2d36788641$var$inmemorystorage;

});
parcelRegister("aoEbD", function(module, exports) {
$parcel$export(module.exports, "InMemoryStore", () => $a300058f3382c015$export$90e3e001bcac59c7);
class $a300058f3382c015$export$90e3e001bcac59c7 {
    constructor(){
        this.data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this.data[key] = value;
            this.length = Object.keys(this.data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this.data) return this.data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this.data) delete this.data[key];
            this.length = Object.keys(this.data).length;
            return null;
        };
        this.clear = ()=>{
            this.data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this.data)[index];
    }
}

});


parcelRegister("cbgsz", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb58d6e7da8b8d56$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $jMPT2 = parcelRequire("jMPT2");

var $kVBH4 = parcelRequire("kVBH4");

var $b3VY1 = parcelRequire("b3VY1");
const $fb58d6e7da8b8d56$export$41c06fdd37b7e9a5 = 'awc';
const $fb58d6e7da8b8d56$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
class $fb58d6e7da8b8d56$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this.store;
        this.getItem = (key)=>this.store.getItem(this.createKey(key));
        this.removeItem = (key)=>this.store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this.store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this.store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this.store === (0, $kVBH4.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this.store || {});
            let inMemoryStorage;
            if ((0, $b3VY1.isSupported)(window[$fb58d6e7da8b8d56$export$770aa8bc07b3de03])) inMemoryStorage = window[$fb58d6e7da8b8d56$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $kVBH4.default);
                if (!window[$fb58d6e7da8b8d56$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$fb58d6e7da8b8d56$export$770aa8bc07b3de03] = (0, $kVBH4.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this.store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this.store = inMemoryStorage;
        };
        this.clear = ()=>this.store.clear();
        this.key = (index)=>this.store.key(index);
        this.getPrefix = ()=>this.prefix;
        this.createKey = (key)=>{
            if (this.prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($fb58d6e7da8b8d56$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $jMPT2.envType).PROD) prefixes.push(options.envPrefix);
        this.prefix = prefixes.join('-');
        if ((0, $b3VY1.isSupported)(storageToUse)) this.store = storageToUse;
        else this.swapToInMemory();
    }
}

});
parcelRegister("jMPT2", function(module, exports) {
$parcel$export(module.exports, "envType", () => $bd26d07d8edd972b$export$56ac8ebc9870b1b9);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // This type has been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $bd26d07d8edd972b$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});

});

parcelRegister("b3VY1", function(module, exports) {
$parcel$export(module.exports, "isSupported", () => $7ebad7868a170bbc$export$48c17662a6902497);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ function $7ebad7868a170bbc$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

});






parcelRegister("5mPNA", function(module, exports) {
$parcel$export(module.exports, "URL_QUERY_PARAM_INTERACTION_SESSION", () => $a95fb8024cb18746$export$81d16f1428ce0486);
$parcel$export(module.exports, "generateUrlWithParams", () => $a95fb8024cb18746$export$2e3999ec51334ffe);
const $a95fb8024cb18746$export$81d16f1428ce0486 = 'xpis';
const $a95fb8024cb18746$export$2e3999ec51334ffe = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    let partialUrl = false;
    let urlObj;
    // If relative URL provided, add localhost as placeholder base, to be stripped later
    try {
        urlObj = new URL(url);
    } catch  {
        urlObj = new URL(url, 'http://localhost/');
        partialUrl = true;
    }
    urlObj.searchParams.set($a95fb8024cb18746$export$81d16f1428ce0486, paramValueEncoded);
    if (partialUrl) return urlObj.pathname + urlObj.search;
    else return urlObj.toString();
};

});

parcelRegister("9t0G7", function(module, exports) {
$parcel$export(module.exports, "validProducts", () => $f3ea743b2ba0eac5$export$b1e8b4360a046e61);
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
const $f3ea743b2ba0eac5$export$b1e8b4360a046e61 = [
    'jira',
    'confluence',
    'townsquare',
    'loom',
    'atlassianStudio',
    'bitbucket',
    'admin'
];

});

parcelRegister("aNsr9", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e244c6cc78c8c6e$export$2e2bcd8739ae039);

var $9FFsN = parcelRequire("9FFsN");

var $atzxl = parcelRequire("atzxl");

var $hlFNB = parcelRequire("hlFNB");
const $3e244c6cc78c8c6e$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = (0, $atzxl.defaultHistoryReplaceFn))=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $9FFsN.parseUrl)(removedFragmentURL);
    const captureParams = (0, $hlFNB.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $hlFNB.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $9FFsN.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$3e244c6cc78c8c6e$export$2e2bcd8739ae039 = $3e244c6cc78c8c6e$var$urlParamExtractor;

});
parcelRegister("atzxl", function(module, exports) {
$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $2e553f90a053a364$export$600dd5bf1b049f11);
const $2e553f90a053a364$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);

});

parcelRegister("hlFNB", function(module, exports) {
$parcel$export(module.exports, "mapKeys", () => $4bcb8c6de098326f$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $4bcb8c6de098326f$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $4bcb8c6de098326f$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $4bcb8c6de098326f$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $4bcb8c6de098326f$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $4bcb8c6de098326f$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $4bcb8c6de098326f$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $4bcb8c6de098326f$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $4bcb8c6de098326f$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $4bcb8c6de098326f$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $4bcb8c6de098326f$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $4bcb8c6de098326f$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $4bcb8c6de098326f$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$4bcb8c6de098326f$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $4bcb8c6de098326f$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});



parcelRegister("gAgTu", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d26ee32da0268d0$export$2e2bcd8739ae039);

var $1y7U8 = parcelRequire("1y7U8");

var $jgKMu = parcelRequire("jgKMu");

var $5hVPW = parcelRequire("5hVPW");
class $1d26ee32da0268d0$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        };
        this.startLowPriorityEventDelay = (timeout = (0, $1y7U8.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $1y7U8.MAX_DELAY_TIMEOUT)) : (0, $1y7U8.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $5hVPW.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        };
        this.stopLowPriorityEventDelay = (reason = (0, $5hVPW.StopLowPriorityEventDelayReason).MANUAL)=>{
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            this.delayCallback?.(reason);
            this.delayCallback = undefined;
        };
        this.isDelayingLowPriorityEvents = ()=>this.isDelaying;
        this.isDelaying = false;
        this.delayQueue = new (0, $jgKMu.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("1y7U8", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", () => $fc758d9589088227$export$cf090d5281b5ae06);
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", () => $fc758d9589088227$export$8575e30be0feb909);
const $fc758d9589088227$export$cf090d5281b5ae06 = 10000;
const $fc758d9589088227$export$8575e30be0feb909 = 30000;

});

parcelRegister("jgKMu", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddaf52dbe4e16b0a$export$2e2bcd8739ae039);

var $lN1hr = parcelRequire("lN1hr");

var $hlFNB = parcelRequire("hlFNB");

var $3wFsO = parcelRequire("3wFsO");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $ddaf52dbe4e16b0a$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $ddaf52dbe4e16b0a$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $ddaf52dbe4e16b0a$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        };
        this.size = ()=>this.eventArgs.length;
        this.startFlush = ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        };
        this.cancelFlush = ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        };
        this.flushNextBatch = ()=>{
            const batch = this.eventArgs.splice(0, $ddaf52dbe4e16b0a$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $ddaf52dbe4e16b0a$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        };
        this.compressEventArgs = (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $hlFNB.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $hlFNB.equals)(group.userInfo, args.userInfo) && (0, $hlFNB.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $lN1hr.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        };
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $3wFsO.default)(compressionRules);
    }
}

});
parcelRegister("3wFsO", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed642d3803226b27$export$2e2bcd8739ae039);
/* eslint-disable implicit-arrow-linebreak */ /* eslint-disable max-classes-per-file */ 
var $ccwBB = parcelRequire("ccwBB");

var $hlFNB = parcelRequire("hlFNB");

var $h5eAc = parcelRequire("h5eAc");
class $ed642d3803226b27$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        this.canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
        this.compress = (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        };
        this.createGroups = (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $ccwBB.buildActionFields)(event, event.eventType);
                    contextFields = (0, $hlFNB.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $hlFNB.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []);
        this.compressGroup = (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>({
                        ...actionFields,
                        ...group.contextFields
                    }));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        };
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $h5eAc.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("h5eAc", function(module, exports) {
$parcel$export(module.exports, "CompressionRule", () => $8e4398b3fe08e42d$export$89b3253ddfd2e6e8);

var $3mq7P = parcelRequire("3mq7P");

var $hlFNB = parcelRequire("hlFNB");

var $9l1HQ = parcelRequire("9l1HQ");

var $iFSFK = parcelRequire("iFSFK");
class $8e4398b3fe08e42d$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
   * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
   * @param event
   * @returns {boolean}
   */ this.canCompress = (event)=>{
            try {
                return event && (0, $3mq7P.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        };
        /**
   * This function compresses as many events in the given collection as possible.<p>
   * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
   * appended to the end of the resulting array.
   *
   * @param events A collection of analytic events to compress
   * @returns {Array.<Object>} The action fields for the resulting compressed events
   */ this.compress = (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $hlFNB.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $iFSFK.validateActionEventType)(event.eventType);
                (0, $9l1HQ.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        };
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("3mq7P", function(module, exports) {
$parcel$export(module.exports, "isActionEventType", () => $6caa211cccd5604c$export$d19cebda16f7579a);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $6yEEN = parcelRequire("6yEEN");
function $6caa211cccd5604c$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $6yEEN.eventType).OPERATIONAL:
        case (0, $6yEEN.eventType).TRACK:
        case (0, $6yEEN.eventType).UI:
            return true;
        default:
            return false;
    }
}

});

parcelRegister("9l1HQ", function(module, exports) {
$parcel$export(module.exports, "validateActionEvent", () => $e8d8d013c4d3c887$export$e0c121325c66ed4c);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $cof0D = parcelRequire("cof0D");
function $e8d8d013c4d3c887$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    (0, $cof0D.validateContainers)(event.containers);
}

});
parcelRegister("cof0D", function(module, exports) {
$parcel$export(module.exports, "validateContainers", () => $e3c151643c3ba0ec$export$e63ea5d8477971d3);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $7fdF2 = parcelRequire("7fdF2");
function $e3c151643c3ba0ec$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>(0, $7fdF2.validateContainersObject)(container));
}

});
parcelRegister("7fdF2", function(module, exports) {
$parcel$export(module.exports, "validateContainersObject", () => $ba592b3841a86885$export$df8ff30e3c960006);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $gmwxH = parcelRequire("gmwxH");
function $ba592b3841a86885$export$df8ff30e3c960006(container) {
    if (!(0, $gmwxH.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}

});



parcelRegister("iFSFK", function(module, exports) {
$parcel$export(module.exports, "validateActionEventType", () => $bf745d79a7e3b06f$export$4a8d7476662aebcc);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $6yEEN = parcelRequire("6yEEN");

var $3mq7P = parcelRequire("3mq7P");
const $bf745d79a7e3b06f$var$actionEventTypes = Object.freeze([
    (0, $6yEEN.eventType).OPERATIONAL,
    (0, $6yEEN.eventType).TRACK,
    (0, $6yEEN.eventType).UI
]);
function $bf745d79a7e3b06f$export$4a8d7476662aebcc(type) {
    if (!(0, $3mq7P.isActionEventType)(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$bf745d79a7e3b06f$var$actionEventTypes}]`);
    return true;
}

});




parcelRegister("5hVPW", function(module, exports) {
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $236fb7d2bb39a6c6$export$fa6e3729c21cb8f);
var $236fb7d2bb39a6c6$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("h6Sce", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba200e6434f568f1$export$2e2bcd8739ae039);

var $hLqf1 = parcelRequire("hLqf1");

var $01o2L = parcelRequire("01o2L");

var $akdUN = parcelRequire("akdUN");

var $6FwgN = parcelRequire("6FwgN");

var $2Sn0X = parcelRequire("2Sn0X");

var $80hV4 = parcelRequire("80hV4");

var $jQSOC = parcelRequire("jQSOC");

var $fTVBT = parcelRequire("fTVBT");

var $4t7l6 = parcelRequire("4t7l6");

var $dqphw = parcelRequire("dqphw");

var $6KUTo = parcelRequire("6KUTo");

var $h5bp1 = parcelRequire("h5bp1");

var $8hcKA = parcelRequire("8hcKA");

var $2Wbf8 = parcelRequire("2Wbf8");

var $hCUC3 = parcelRequire("hCUC3");

var $387qv = parcelRequire("387qv");
class $ba200e6434f568f1$var$AnalyticsAPIResponse {
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
}
class $ba200e6434f568f1$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $ba200e6434f568f1$var$EventValidationReport {
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $ba200e6434f568f1$export$2e2bcd8739ae039 {
    constructor(options){
        this.originTracingClient = null;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        this.sendEvents = async (items, callback)=>{
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = {
                ...metricsPayload,
                httpRetryCount: httpRetryCount,
                lastSendEventsErrorReason: this.lastSendEventsError?.message || null,
                // Temporary back-compat
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: metadataInfo?.props || null,
                metadataClientMetrics: this.metadataClient?.metrics || null
            };
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                this.applyExclusions(item);
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                const response = await (0, $2Wbf8.sendEvents)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                this.originTracingClient?.cleanupOriginParameters(items);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, $4t7l6.FetchError) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, $6KUTo.LastError)('ServerBusyError', error);
                else {
                    const errorName = error instanceof Error && (0, $hCUC3.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                    this.lastSendEventsError = new (0, $6KUTo.LastError)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        };
        this.options = {
            ...options,
            requestTimeout: options.requestTimeout || (0, $jQSOC.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        };
        this.user = new (0, $387qv.default)(this.options?.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $01o2L.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $hLqf1.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $hCUC3.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $hCUC3.SegmentEventTypes).TRACK,
            properties: (0, $8hcKA.prepareEventProperties)(builtEvent),
            event: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $hCUC3.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $hCUC3.SegmentEventTypes).PAGE,
            properties: (0, $8hcKA.prepareEventProperties)(builtEvent),
            name: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $hCUC3.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $hCUC3.SegmentEventTypes).IDENTIFY,
            traits: (0, $8hcKA.prepareEventProperties)(builtEvent)
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $h5bp1.prepareEventContext)(context);
        const segmentContext = (0, $80hV4.buildContext)(clonedContext, overrides);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, $akdUN.default)()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    applyExclusions(item) {
        const msg = item.msg;
        const properties = msg.properties;
        const traits = msg.traits;
        const excluded = msg.context?.excludedProperties;
        if (!excluded) return;
        if (excluded.anonymousId === true) msg.anonymousId = undefined;
        if (excluded.interactionSession === true) {
            if (properties) properties.interactionSession = undefined;
        }
        if (excluded.sessionId === true) {
            if (properties) properties.sessionId = undefined;
        }
        if (excluded.pageLoadId === true) {
            if (properties) properties.pageLoadId = undefined;
        }
        if (excluded.tabId === true) {
            if (properties) properties.tabId = undefined;
        }
        if (excluded.taskSessions === true) {
            if (properties) properties.taskSessions = undefined;
        }
        if (excluded.userId === true) {
            msg.userId = undefined;
            if (properties) properties.userIdType = undefined;
        }
        if (excluded.xid === true) {
            if (properties) properties.xid = undefined;
            if (traits) traits.xid = undefined;
        }
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo?.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            // Skip cleaning up props object and its keys
            // to avoid having to check the existence of the fields in props object
            // and manipulate them to calculate metadata signature in analytics service
            if (key === 'props') continue;
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch  {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $ba200e6434f568f1$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $ba200e6434f568f1$var$Message(responseObject.message?.error || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $ba200e6434f568f1$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, // In case 'error' were to be undefined we'll convert it to null.
            analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $6FwgN.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    /** @internal Used by AnalyticsWebClient to wire up origin tracing cleanup. */ setOriginTracingClient(client) {
        this.originTracingClient = client;
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
}
class $ba200e6434f568f1$var$BatchInterceptor {
    static{
        this.http_error_regex = /HTTP Error\s([0-9]{3})\s\((.+)\)/;
    }
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                analyticsAPIResponse.validationReports?.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new (0, $fTVBT.EventResponse)(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new (0, $2Sn0X.AnalyticsResponse)(success, statusCode, (0, $dqphw.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = analyticsAPIResponse.message?.error !== null ? analyticsAPIResponse.message.error : (0, $dqphw.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $dqphw.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $dqphw.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new (0, $fTVBT.EventResponse)(item.msg.messageId, [], item.msg));
                });
                return new (0, $2Sn0X.AnalyticsResponse)(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error?.message) {
            const match = error.message.match($ba200e6434f568f1$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new (0, $fTVBT.EventResponse)(item.msg.messageId, [], item.msg));
                });
                return new (0, $2Sn0X.AnalyticsResponse)(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new (0, $fTVBT.EventResponse)(item.msg.messageId, [], item.msg));
        });
        return new (0, $2Sn0X.AnalyticsResponse)(false, -1, (0, $dqphw.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}

});
parcelRegister("hLqf1", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba06f754ab45912a$export$2e2bcd8739ae039);

var $c4drF = parcelRequire("c4drF");

var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ba06f754ab45912a$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $c4drF.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("c4drF", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_POLLING_OPTIONS", () => $f042c86e7f39cc1c$export$d219df4fe04c04a7);
$parcel$export(module.exports, "default", () => $f042c86e7f39cc1c$export$2e2bcd8739ae039);

var $ldEFV = parcelRequire("ldEFV");

var $8xvEx = parcelRequire("8xvEx");

var $1Olia = parcelRequire("1Olia");

var $4C2iD = parcelRequire("4C2iD");

var $2eIO7 = parcelRequire("2eIO7");

var $01o2L = parcelRequire("01o2L");

var $5JD19 = parcelRequire("5JD19");

var $begmT = parcelRequire("begmT");

var $7YeV5 = parcelRequire("7YeV5");

var $iIQlI = parcelRequire("iIQlI");
const $f042c86e7f39cc1c$var$ONE_MINUTE = 60000;
const $f042c86e7f39cc1c$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $f042c86e7f39cc1c$var$ONE_MINUTE,
    minRetryDelay: $f042c86e7f39cc1c$var$ONE_MINUTE,
    maxRetryDelay: $f042c86e7f39cc1c$var$ONE_MINUTE
};
const $f042c86e7f39cc1c$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // The maximum number of events that can be stored in the resilience queue (IndexedDB/memory).
    // This limit is per product and is enforced by the EventCountGuard in the resilience layer.
    maxQueueSize: 8000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $f042c86e7f39cc1c$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $1Olia.default)(product, {
            logger: logger,
            maxAttempts: options?.maxAttempts,
            maxEventLimit: options?.maxQueueSize || $f042c86e7f39cc1c$export$d219df4fe04c04a7.maxQueueSize
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $begmT.default)({
            ...this.options,
            waitInterval: options?.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }, this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $begmT.default)({
            ...$f042c86e7f39cc1c$var$LONG_POLLING_OPTIONS,
            waitInterval: $f042c86e7f39cc1c$var$LONG_POLLING_OPTIONS.flushWaitMs
        }, this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $01o2L.default)();
        this.networkStatus = new (0, $5JD19.default)((status)=>{
            if (status === (0, $iIQlI.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $4C2iD.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $iIQlI.NetworkStatusEnum).OFFLINE) {
            done((0, $7YeV5.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $2eIO7.CallbackProcessingErrorName)) {
                done((0, $7YeV5.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $ldEFV.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $8xvEx.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $4C2iD.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $7YeV5.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $7YeV5.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $7YeV5.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || $f042c86e7f39cc1c$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : $f042c86e7f39cc1c$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: options?.batchFlushSize || $f042c86e7f39cc1c$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: options?.flushBeforeUnload || $f042c86e7f39cc1c$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: options?.flushWaitMs || $f042c86e7f39cc1c$export$d219df4fe04c04a7.flushWaitMs,
            maxQueueSize: options?.maxQueueSize || $f042c86e7f39cc1c$export$d219df4fe04c04a7.maxQueueSize,
            maxAttempts: options?.maxAttempts || $f042c86e7f39cc1c$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: options?.maxRetryDelay || $f042c86e7f39cc1c$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || $f042c86e7f39cc1c$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("ldEFV", function(module, exports) {
$parcel$export(module.exports, "default", () => $882dc867356bc33a$export$2e2bcd8739ae039);

var $hQXbP = parcelRequire("hQXbP");

var $gqRNZ = parcelRequire("gqRNZ");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $882dc867356bc33a$var$validSuffixs = Object.values((0, $hQXbP.LocalStorageKeySuffix));
var $882dc867356bc33a$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $882dc867356bc33a$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $hQXbP.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $gqRNZ.createLocalStorageKeys)(prefix, id);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(queue);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimStart);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("hQXbP", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKeySuffix", () => $d8453ab6d7de843e$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $d8453ab6d7de843e$export$8bb2c1fb2b1765a9);
var $d8453ab6d7de843e$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $d8453ab6d7de843e$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("gqRNZ", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageKeys", () => $7c597dd6673c24a5$export$8433d54f767cbec5);

var $hQXbP = parcelRequire("hQXbP");
const $7c597dd6673c24a5$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $hQXbP.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $hQXbP.LocalStorageKeySuffix).ACK}`,
        [(0, $hQXbP.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $hQXbP.LocalStorageKeySuffix).QUEUE}`,
        [(0, $hQXbP.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $hQXbP.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $hQXbP.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $hQXbP.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $hQXbP.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $hQXbP.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("8xvEx", function(module, exports) {
$parcel$export(module.exports, "default", () => $be1d83f9b54d1711$export$2e2bcd8739ae039);

var $akdUN = parcelRequire("akdUN");

var $hQXbP = parcelRequire("hQXbP");

var $gqRNZ = parcelRequire("gqRNZ");
const $be1d83f9b54d1711$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $be1d83f9b54d1711$var$findOtherQueues = (queuePrefix)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $hQXbP.LocalStorageKeySuffix).ACK) try {
                // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $hQXbP.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch  {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch  {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $be1d83f9b54d1711$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(ack, start.toString());
    await $be1d83f9b54d1711$var$promisedSetTimeout((0, $hQXbP.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $hQXbP.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $be1d83f9b54d1711$var$promisedSetTimeout((0, $hQXbP.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $hQXbP.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $be1d83f9b54d1711$var$reclaim(options, callback);
};
const $be1d83f9b54d1711$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = {
            ...item,
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        };
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $be1d83f9b54d1711$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $be1d83f9b54d1711$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $be1d83f9b54d1711$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.queue);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.inProgress);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimEnd);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.ack);
};
var $be1d83f9b54d1711$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, $akdUN.default)();
    const queuesToReclaim = $be1d83f9b54d1711$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$be1d83f9b54d1711$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $gqRNZ.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});
parcelRegister("akdUN", function(module, exports) {
$parcel$export(module.exports, "default", () => $550e2bec6cfe75c2$export$2e2bcd8739ae039);
// UUID v4 generator with fallback for non-secure contexts
function $550e2bec6cfe75c2$export$2e2bcd8739ae039() {
    const g = globalThis;
    try {
        if (g.crypto && typeof g.crypto.randomUUID === 'function') return g.crypto.randomUUID();
    } catch  {
    // ignore and fallback
    }
    // Fallback to Math.random-based v4 UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.floor(Math.random() * 16);
        const v = c === 'x' ? r : r & 0x3 | 0x8; // x => random hex digit; y => set RFC 4122 variant bits (10xx), yielding 8, 9, a, or b
        return v.toString(16);
    });
}

});


parcelRegister("1Olia", function(module, exports) {
$parcel$export(module.exports, "default", () => $dff95ef306d8cb1e$export$2e2bcd8739ae039);

var $rfmTU = parcelRequire("rfmTU");
var $dff95ef306d8cb1e$export$2e2bcd8739ae039 = (0, $rfmTU.default);

});
parcelRegister("rfmTU", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe84693c3db8260d$export$2e2bcd8739ae039);

var $4C2iD = parcelRequire("4C2iD");

var $8860M = parcelRequire("8860M");

var $94QKN = parcelRequire("94QKN");

var $cbnIY = parcelRequire("cbnIY");

var $5arE4 = parcelRequire("5arE4");

var $20x1F = parcelRequire("20x1F");
class $fe84693c3db8260d$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $8860M.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $5arE4.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $94QKN.default))) options.logger?.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
        }
        return new (0, $20x1F.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $4C2iD.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $4C2iD.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $cbnIY.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $4C2iD.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $20x1F.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $4C2iD.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("4C2iD", function(module, exports) {
$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $1a3ed7c526d9ac95$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $1a3ed7c526d9ac95$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $1a3ed7c526d9ac95$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $1a3ed7c526d9ac95$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $1a3ed7c526d9ac95$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $1a3ed7c526d9ac95$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $1a3ed7c526d9ac95$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $1a3ed7c526d9ac95$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $1a3ed7c526d9ac95$export$7710d69e6f450f20);
const $1a3ed7c526d9ac95$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $1a3ed7c526d9ac95$export$8cad224051643259 = 'analytics-web-client';
const $1a3ed7c526d9ac95$export$3d8420be07b276ab = 'analytics-resilience';
const $1a3ed7c526d9ac95$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $1a3ed7c526d9ac95$export$89d9c1ff8ac91862 = 'timeAdded';
const $1a3ed7c526d9ac95$export$a37d385bcd713809 = 'retryAttempts';
const $1a3ed7c526d9ac95$export$6d8635fed0e4b14d = 15000;
var $1a3ed7c526d9ac95$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $1a3ed7c526d9ac95$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("8860M", function(module, exports) {
$parcel$export(module.exports, "createOptionsWithDefaults", () => $92e957c04fb15daf$export$ddc6718318090f71);

var $1n9ft = parcelRequire("1n9ft");
const $92e957c04fb15daf$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $1n9ft.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $1n9ft.EVENT_COUNT_LIMIT)
    });

});
parcelRegister("1n9ft", function(module, exports) {
$parcel$export(module.exports, "GET_ITEM_COUNT", () => $67507f0d6afa2492$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $67507f0d6afa2492$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $67507f0d6afa2492$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $67507f0d6afa2492$export$1188664dfff364c8);
const $67507f0d6afa2492$export$b6df3d334cec060f = 7;
const $67507f0d6afa2492$export$14ef152a03a4b6ee = 60000;
const $67507f0d6afa2492$export$da9ab7b2fd5998e8 = 10;
const $67507f0d6afa2492$export$1188664dfff364c8 = 8000;

});


parcelRegister("94QKN", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f3145fe2ff9cf8d$export$2e2bcd8739ae039);
const $2f3145fe2ff9cf8d$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $2f3145fe2ff9cf8d$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $2f3145fe2ff9cf8d$export$2e2bcd8739ae039.prototype);
        this.name = $2f3145fe2ff9cf8d$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("cbnIY", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $3de84c348995c363$export$74101021e0969375);

var $caN3I = parcelRequire("caN3I");

var $2eIO7 = parcelRequire("2eIO7");

var $eG7ts = parcelRequire("eG7ts");
const $3de84c348995c363$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $caN3I.AbandonWriteErrorName) || errorWithName.name === (0, $2eIO7.CallbackProcessingErrorName) || errorWithName.name === (0, $eG7ts.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("caN3I", function(module, exports) {
$parcel$export(module.exports, "AbandonWriteErrorName", () => $cc73796265993b01$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $cc73796265993b01$export$2e2bcd8739ae039);
const $cc73796265993b01$export$ba95206613c96b28 = 'AbandonWriteError';
class $cc73796265993b01$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $cc73796265993b01$export$2e2bcd8739ae039.prototype);
        this.name = $cc73796265993b01$export$ba95206613c96b28;
    }
}

});

parcelRegister("2eIO7", function(module, exports) {
$parcel$export(module.exports, "CallbackProcessingErrorName", () => $61e8a86132e5e7df$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $61e8a86132e5e7df$export$2e2bcd8739ae039);
const $61e8a86132e5e7df$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $61e8a86132e5e7df$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $61e8a86132e5e7df$export$2e2bcd8739ae039.prototype);
        this.name = $61e8a86132e5e7df$export$a409c8de90e11e14;
    }
}

});

parcelRegister("eG7ts", function(module, exports) {
$parcel$export(module.exports, "InvalidPolicyErrorName", () => $fec22f9fa6df835a$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $fec22f9fa6df835a$export$2e2bcd8739ae039);
const $fec22f9fa6df835a$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $fec22f9fa6df835a$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $fec22f9fa6df835a$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("5arE4", function(module, exports) {
$parcel$export(module.exports, "default", () => $230a3e9f45263a56$export$2e2bcd8739ae039);

var $lDglx = parcelRequire("lDglx");

var $4C2iD = parcelRequire("4C2iD");

var $7f6E8 = parcelRequire("7f6E8");

var $8860M = parcelRequire("8860M");

var $1n9ft = parcelRequire("1n9ft");

var $2eIO7 = parcelRequire("2eIO7");

var $eG7ts = parcelRequire("eG7ts");

var $94QKN = parcelRequire("94QKN");

var $cbnIY = parcelRequire("cbnIY");

var $eX2VP = parcelRequire("eX2VP");

var $1Ww9U = parcelRequire("1Ww9U");

var $2PhLz = parcelRequire("2PhLz");
class $230a3e9f45263a56$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.startDB = async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $94QKN.default)());
                    }, (0, $4C2iD.INDEXEDDB_TIMEOUT));
                    /*
         * The database version number can never change.
         * An upgrade transaction is limited to only one connection to the database.
         * Once this is done, we cannot open any connections with older versions of the schema.
         * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
         *
         * Due to the nature of how AWC is used (multiple tabs that are very long lived),
         * we will not be able to run version upgrades via indexeddb.
         *
         * This does not mean we cant change what is stored in the tables,
         * this limitation just prevents us from:
         *   - Creating new ObjectStores in this database connection, and
         *   - Creating new indexes on our ObjectStores
         *
         * Any upgrades we wish to run in the future will have to create a new database,
         * and migrate all the data from older databases.
         *
         * This also means any migrations we make will have to be supported until we have evidence
         * that no events are coming from old versions of the database.
         * This may take a long time.
         */ const request = window.indexedDB.open((0, $4C2iD.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $4C2iD.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $4C2iD.TIME_TO_PROCESS_AFTER_INDEX), (0, $4C2iD.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $4C2iD.RETRY_INDEX), (0, $4C2iD.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $4C2iD.TIME_ADDED_INDEX), (0, $4C2iD.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $4C2iD.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $94QKN.default)());
                    };
                    try {
                        await (0, $2PhLz.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $94QKN.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $94QKN.default)());
                }
            });
        };
        this.addItem = async (item, options = {}, policy = (0, $4C2iD.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $7f6E8.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $4C2iD.GuardPolicy).IGNORE) throw new (0, $eG7ts.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $cbnIY.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.bulkAddItem = async (itemOptions, policy = (0, $4C2iD.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map(({ item: item, ...options })=>(0, $7f6E8.convertToItemWrapper)(item, namespace, options));
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $cbnIY.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.getItems = async (count = (0, $1n9ft.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $1n9ft.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $4C2iD.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = {
                            ...cursor.value
                        };
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $1n9ft.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $1Ww9U.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $1Ww9U.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $lDglx.commitTransaction)(transaction, this.logger);
            return getResult;
        };
        this.deleteItems = async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $lDglx.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        this.getItemCount = async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $4C2iD.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $2PhLz.requestToPromise)(request);
            await (0, $lDglx.commitTransaction)(transaction, this.logger);
            return event.target.result;
        };
        this.processItems = async (processFn, count = (0, $1n9ft.GET_ITEM_COUNT))=>{
            const { items: items, ...partialResult } = await this.getItems(count);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $2eIO7.default)(error);
            }
        };
        this.deleteItem = async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $2PhLz.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        };
        this.getObjectStoreAndTransaction = async (mode)=>{
            const transaction = (await this.db).transaction((0, $4C2iD.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $4C2iD.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        };
        this.options = (0, $8860M.createOptionsWithDefaults)(options);
        this.namespace = namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $94QKN.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $eX2VP.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $4C2iD.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("lDglx", function(module, exports) {
$parcel$export(module.exports, "commitTransaction", () => $ce6f8012e62aaa76$export$feab8418f018df89);

var $8Xkw9 = parcelRequire("8Xkw9");
const $ce6f8012e62aaa76$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return (0, $8Xkw9.transactionToPromise)(transaction);
};

});
parcelRegister("8Xkw9", function(module, exports) {
$parcel$export(module.exports, "transactionToPromise", () => $a98b25187ecff225$export$2a5213bce1720b42);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $a98b25187ecff225$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};

});


parcelRegister("7f6E8", function(module, exports) {
$parcel$export(module.exports, "convertToItemWrapper", () => $9c3b46972b767e0a$export$aec476f33d77be11);

var $akdUN = parcelRequire("akdUN");
const $9c3b46972b767e0a$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, $akdUN.default)(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });

});

parcelRegister("eX2VP", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa5726a13f8da1a5$export$2e2bcd8739ae039);

var $lDglx = parcelRequire("lDglx");

var $4C2iD = parcelRequire("4C2iD");

var $caN3I = parcelRequire("caN3I");

var $2PhLz = parcelRequire("2PhLz");
class $aa5726a13f8da1a5$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
   * This query fetches the oldest events currently stored in AWC IndexedDb object store
   * and deletes them sequentially
   */ this.deleteOldestNEvents = async (objectStore, count)=>{
            const productTimeAddedIndex = objectStore.index((0, $4C2iD.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $2PhLz.requestToPromise)(getAllRequest);
            const result = event?.target?.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $4C2iD.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $4C2iD.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $4C2iD.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $4C2iD.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $2PhLz.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $lDglx.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $caN3I.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $4C2iD.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $2PhLz.requestToPromise)(request);
        return event.target.result;
    }
}

});
parcelRegister("2PhLz", function(module, exports) {
$parcel$export(module.exports, "requestToPromise", () => $87e8c430941c7718$export$85ceed0783e42041);
// Not to be used on cursors or other requests that may call onsuccess multiple times.
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $87e8c430941c7718$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};

});


parcelRegister("1Ww9U", function(module, exports) {
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $931811cd3a6ef6e5$export$342d941b6f724995);
const $931811cd3a6ef6e5$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});


parcelRegister("20x1F", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8dab793bb6dc78e$export$2e2bcd8739ae039);

var $4C2iD = parcelRequire("4C2iD");

var $7f6E8 = parcelRequire("7f6E8");

var $8860M = parcelRequire("8860M");

var $1n9ft = parcelRequire("1n9ft");

var $2eIO7 = parcelRequire("2eIO7");

var $eG7ts = parcelRequire("eG7ts");

var $84aRh = parcelRequire("84aRh");
class $e8dab793bb6dc78e$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $8860M.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $84aRh.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $4C2iD.GuardPolicy).ABANDON) {
        if (policy === (0, $4C2iD.GuardPolicy).IGNORE) throw new (0, $eG7ts.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $7f6E8.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $4C2iD.GuardPolicy).ABANDON) {
        const items = itemOptions.map(({ item: item, ...addOptions })=>(0, $7f6E8.convertToItemWrapper)(item, this.namespace, addOptions));
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $4C2iD.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $1n9ft.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $1n9ft.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $1n9ft.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push({
                    ...wrappedItem
                });
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $1n9ft.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const { items: items, ...partialGetResult } = this.synchronousGetItems(count);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $2eIO7.default)(error);
        }
    }
    storeType() {
        return (0, $4C2iD.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("84aRh", function(module, exports) {
$parcel$export(module.exports, "default", () => $18ca09e71d3625b0$export$2e2bcd8739ae039);

var $4C2iD = parcelRequire("4C2iD");

var $caN3I = parcelRequire("caN3I");
class $18ca09e71d3625b0$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
   * Unlike IndexedDb, we cannot take advantage of any index. So we are,
   * treating the memory store as a sorted set when adding items.
   */ this.insertItemsToMemoryStore = (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $4C2iD.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $4C2iD.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $4C2iD.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $caN3I.default)((0, $4C2iD.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("01o2L", function(module, exports) {
$parcel$export(module.exports, "default", () => $00d15616a7580b75$export$2e2bcd8739ae039);

var $8FTGg = parcelRequire("8FTGg");
let $00d15616a7580b75$var$cachedMetricsClient = null;
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$00d15616a7580b75$export$2e2bcd8739ae039 = ()=>{
    if (!$00d15616a7580b75$var$cachedMetricsClient) $00d15616a7580b75$var$cachedMetricsClient = new (0, $8FTGg.MetricsCollector)();
    return $00d15616a7580b75$var$cachedMetricsClient;
};

});
parcelRegister("8FTGg", function(module, exports) {
$parcel$export(module.exports, "MetricsCollector", () => $57efc7e81e4aed70$export$4b62ee5120ab50a8);

var $iIQlI = parcelRequire("iIQlI");
class $57efc7e81e4aed70$export$4b62ee5120ab50a8 {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        this.itemsDiscardedByRetry = 0;
        // Number of events created by the product in current tab.
        this.eventCount = 0;
        // Number of events discarded due to reaching queue max size.
        this.itemsDiscardedByOverflow = 0;
        // Will be used in the future when we get more resilience mechanisms
        this.resilienceMechanism = (0, $iIQlI.ResilienceMechanism).INDEXEDDB;
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        this.localstorageNumberOfQueuesPurged = 0;
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        this.localstorageNumberOfFullReclaims = 0;
        // Queue was found but not all events were able to be put into resilienceDb.
        this.localstorageNumberOfPartialReclaims = 0;
        // Reclaim failed for a queue and reclaim was abandonded.
        this.localstorageNumberOfFailedReclaims = 0;
    }
}

});
parcelRegister("iIQlI", function(module, exports) {
$parcel$export(module.exports, "ResilienceMechanism", () => $548d8509bef1f923$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $548d8509bef1f923$export$ee138fa712d11b84);
var $548d8509bef1f923$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $548d8509bef1f923$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});



parcelRegister("5JD19", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0e073258382a972$export$2e2bcd8739ae039);

var $iIQlI = parcelRequire("iIQlI");
class $e0e073258382a972$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $iIQlI.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $iIQlI.NetworkStatusEnum).ONLINE));
        }
    }
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $iIQlI.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $iIQlI.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $iIQlI.NetworkStatusEnum).ONLINE;
        return (0, $iIQlI.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("begmT", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d9c1d737878794e$export$2e2bcd8739ae039);

var $sYtmI = parcelRequire("sYtmI");

var $7YeV5 = parcelRequire("7YeV5");
const $0d9c1d737878794e$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $0d9c1d737878794e$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $0d9c1d737878794e$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        this.schedule = ({ immediate: immediate } = {})=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = 1;
                else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Calculate backoff for normal or failure scenario
            } else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
        };
        this.stop = ()=>{
            this.clearTimeout();
            this.queuedSchedule = 0;
        };
        this.getFailureCount = ()=>this.failureCount;
        this.getCallbackStatus = ()=>{
            return this.callbackTimer.getCallbackStatus();
        };
        this.clearTimeout = ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        };
        this.run = ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $7YeV5.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        };
        this.done = (state)=>{
            this.operationInFlight = false;
            if (state === (0, $7YeV5.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $sYtmI.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $7YeV5.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        };
        this.processQueuedSchedule = ()=>{
            if (this.queuedSchedule !== 0) {
                const immediate = this.queuedSchedule === 1;
                this.queuedSchedule = 0;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        };
        this.calculateBackoff = ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage, waitInterval: waitInterval } = this.options;
            // Helper for deviation based on a single random sample
            const jitter = (base, symmetric)=>{
                if (!backoffJitterPercentage || base <= 0) return 0;
                const r = (Math.random() - 0.5) * 2;
                const frac = symmetric ? r : Math.abs(r);
                return Math.floor(frac * backoffJitterPercentage * base);
            };
            // No failures: wait interval with positive-only jitter
            if (this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
            // Failures: exponential backoff with symmetric jitter
            const base = Math.min(minRetryDelay * backoffFactor ** this.failureCount, maxRetryDelay);
            const withJitter = base + jitter(base, true);
            return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
        };
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $0d9c1d737878794e$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $0d9c1d737878794e$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $0d9c1d737878794e$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $0d9c1d737878794e$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $0d9c1d737878794e$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $0d9c1d737878794e$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = 0;
        this.callbackTimer = new (0, $sYtmI.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("sYtmI", function(module, exports) {
$parcel$export(module.exports, "CallbackStatus", () => $8a68e7ee8683649b$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $8a68e7ee8683649b$export$590a718599f8f8b3);
var $8a68e7ee8683649b$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $8a68e7ee8683649b$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $8a68e7ee8683649b$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Tracks the settimeout; so that we can clear the timeout
        this.timeoutHandle = undefined;
        this.callbackStatus = "idle";
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case "idle":
            case "timedOut":
            case "completed":
                if (event === "execute") this.callbackStatus = "running";
                break;
            case "running":
                switch(event){
                    case "complete":
                        this.callbackStatus = "completed";
                        break;
                    case "timeout":
                        this.callbackStatus = "timedOut";
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, "execute");
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, "timeout");
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== "timedOut") {
                this.transitionCallbackStatus(this.callbackStatus, "complete");
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("7YeV5", function(module, exports) {
$parcel$export(module.exports, "DoneState", () => $7513cdff52141dbd$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
var $7513cdff52141dbd$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("6FwgN", function(module, exports) {
$parcel$export(module.exports, "attachXidToMultipleEvents", () => $2a9ecaf8403f5e37$export$c21270cab66ab290);

var $dADIb = parcelRequire("dADIb");
async function $2a9ecaf8403f5e37$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>(0, $dADIb.attachXidToSingleEvent)(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("dADIb", function(module, exports) {
$parcel$export(module.exports, "attachXidToSingleEvent", () => $373446a34900a6b1$export$c9c3aaf655d6f275);

var $hCUC3 = parcelRequire("hCUC3");
function $373446a34900a6b1$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $hCUC3.SegmentEventTypes).PAGE || item.msg.type === (0, $hCUC3.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = {
            ...item.msg.properties,
            xid: xid
        };
    } else if (item.msg.traits && item.msg.type === (0, $hCUC3.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = {
            ...item.msg.traits,
            xid: xid
        };
    }
    return item;
}

});
parcelRegister("hCUC3", function(module, exports) {
$parcel$export(module.exports, "SegmentEventTypes", () => $af39c8ca899dd473$export$ddf929981dc6feb3);
$parcel$export(module.exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", () => $af39c8ca899dd473$export$96f086dcf574a9e2);
var $af39c8ca899dd473$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $af39c8ca899dd473$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $af39c8ca899dd473$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
const $af39c8ca899dd473$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];

});



parcelRegister("2Sn0X", function(module, exports) {
$parcel$export(module.exports, "AnalyticsResponse", () => $6b6fb619c362ba48$export$133650fcdde1b226);
class $6b6fb619c362ba48$export$133650fcdde1b226 {
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}

});

parcelRegister("80hV4", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $7047c6f69b8b5b0b$export$3a7fe28f9bf4f3d9);
// @ts-ignore

var $9FgWr = parcelRequire("9FgWr");
// Shallow removal of all falsey properties from an object, returning a new object.
const $7047c6f69b8b5b0b$var$removeFalseyProperties = (obj)=>{
    const result = {};
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) // If the value is not strictly true, map it to undefined
        {
            if (obj[key]) result[key] = obj[key];
        }
    }
    return result;
};
const $7047c6f69b8b5b0b$export$3a7fe28f9bf4f3d9 = (context, overrides)=>{
    const result = {
        ...context.context,
        userAgent: navigator.userAgent
    };
    // use nestedRemoveUndefinedValues to strip undefined properties before
    // spreading the override object since we want properties that explicitly
    // set to 'undefined' to not overwrite any values, just like properties
    // that are 'undefined' because they're not set at all will.
    if (overrides?.excludedProperties) result.excludedProperties = {
        ...result.excludedProperties,
        ...(0, $9FgWr.nestedRemoveUndefinedValues)(overrides.excludedProperties, '$.excludedProperties')
    };
    if (overrides?.userConsents) result.userConsents = {
        ...result.userConsents,
        ...(0, $9FgWr.nestedRemoveUndefinedValues)(overrides.userConsents, '$.userConsents')
    };
    // Remove any falsey properties since we only want to have exclusions
    // that were explicitly declared as excluded.
    if (result.excludedProperties) result.excludedProperties = $7047c6f69b8b5b0b$var$removeFalseyProperties(result.excludedProperties);
    return result;
};

});
parcelRegister("9FgWr", function(module, exports) {
$parcel$export(module.exports, "nestedRemoveUndefinedValues", () => $15b853f473192d66$export$2250ccecd1e040fd);
// @ts-ignore
// This function will essentially deepClone as well
const $15b853f473192d66$export$2250ccecd1e040fd = (obj, path)=>{
    const recursionDepthLimit = 512;
    const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth)=>{
        if (source === null || typeof source !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            const originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        const clone = {};
        Object.keys(source).forEach((key)=>{
            const value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const newArray = [];
                    value.forEach((v, i)=>{
                        const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};

});


parcelRegister("jQSOC", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $9437ee47ce2b0774$export$9175ce0e1c95daf2);
$parcel$export(module.exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", () => $9437ee47ce2b0774$export$8fddcd1eff390364);
$parcel$export(module.exports, "DEFAULT_METADATA_REFRESH_INTERVAL", () => $9437ee47ce2b0774$export$92ed669a3d41dad3);
$parcel$export(module.exports, "DEFAULT_METADATA_MIN_RETRY_DELAY", () => $9437ee47ce2b0774$export$6649d5c857717efe);
$parcel$export(module.exports, "DEFAULT_METADATA_MAX_RETRY_DELAY", () => $9437ee47ce2b0774$export$33e7628d3b2c0e2);
$parcel$export(module.exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", () => $9437ee47ce2b0774$export$6f1c008dd0c3b67e);
const $9437ee47ce2b0774$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $9437ee47ce2b0774$export$8fddcd1eff390364 = 60000; // 60 seconds
const $9437ee47ce2b0774$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $9437ee47ce2b0774$export$6649d5c857717efe = 5000; // 5 seconds
const $9437ee47ce2b0774$export$33e7628d3b2c0e2 = 3600000; // 60 minutes
const $9437ee47ce2b0774$export$6f1c008dd0c3b67e = 10; // 10 milliseconds

});

parcelRegister("fTVBT", function(module, exports) {
$parcel$export(module.exports, "EventResponse", () => $04ba0d63647d631b$export$51e0b986fdbf3840);
class $04ba0d63647d631b$export$51e0b986fdbf3840 {
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}

});

parcelRegister("4t7l6", function(module, exports) {
$parcel$export(module.exports, "FetchError", () => $253b1eb1274c3321$export$26e841bcf1aeb894);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
class $253b1eb1274c3321$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}

});

parcelRegister("dqphw", function(module, exports) {
$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $65bd245a90529cca$export$ba118f9de1e5ac63);
const $65bd245a90529cca$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("6KUTo", function(module, exports) {
$parcel$export(module.exports, "LastError", () => $0e37a3456569258b$export$a63e16b3351b8c36);

var $4t7l6 = parcelRequire("4t7l6");
class $0e37a3456569258b$export$a63e16b3351b8c36 {
    constructor(reason, error){
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof (0, $4t7l6.FetchError) ? error.statusCode : null;
    }
}

});

parcelRegister("h5bp1", function(module, exports) {
$parcel$export(module.exports, "prepareEventContext", () => $d5ad63104ffb2a38$export$6b26e26d40264200);
// @ts-ignore

var $3WNR1 = parcelRequire("3WNR1");

var $9FgWr = parcelRequire("9FgWr");
const $d5ad63104ffb2a38$export$6b26e26d40264200 = (context)=>{
    const propertiesWithoutUndefined = (0, $9FgWr.nestedRemoveUndefinedValues)(context, '$.context');
    return (0, (/*@__PURE__*/$parcel$interopDefault($3WNR1)))(propertiesWithoutUndefined);
};

});

parcelRegister("8hcKA", function(module, exports) {
$parcel$export(module.exports, "prepareEventProperties", () => $ebf176d11616a164$export$44d22e5fb02cc68e);
// @ts-ignore

var $3WNR1 = parcelRequire("3WNR1");

var $9FgWr = parcelRequire("9FgWr");
const $ebf176d11616a164$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = (0, $9FgWr.nestedRemoveUndefinedValues)(properties, '$.properties');
    // Remove any override properties that shouldn't be included in the event body
    delete propertiesWithoutUndefined.excludedProperties;
    delete propertiesWithoutUndefined.userConsents;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3WNR1)))(propertiesWithoutUndefined);
};

});

parcelRegister("2Wbf8", function(module, exports) {
$parcel$export(module.exports, "sendEvents", () => $71ce80c242b9af2e$export$8e8f0180c1b41fad);

var $2IvOD = parcelRequire("2IvOD");

var $4t7l6 = parcelRequire("4t7l6");
const $71ce80c242b9af2e$export$8e8f0180c1b41fad = async (options)=>{
    const signal = $71ce80c242b9af2e$var$createOrGetAbortController(options)?.signal;
    const corsOptions = $71ce80c242b9af2e$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, {
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal,
        ...corsOptions
    });
    if (response.status !== 200) throw new (0, $4t7l6.FetchError)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    try {
        let responseBody = await response.clone().json();
        if (responseBody.success === true) return response;
    } catch  {}
    throw new (0, $4t7l6.FetchError)('Invalid HTTP Response (Invalid response body)', 200, 'Invalid response body');
};
const $71ce80c242b9af2e$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $71ce80c242b9af2e$var$getCorsForUrl = (0, $2IvOD.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});

parcelRegister("387qv", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ec3877863d57ff1$export$2e2bcd8739ae039);

var $75pqB = parcelRequire("75pqB");

var $3VIC4 = parcelRequire("3VIC4");

var $fFAhf = parcelRequire("fFAhf");

var $i9AMt = parcelRequire("i9AMt");

var $akdUN = parcelRequire("akdUN");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $6ec3877863d57ff1$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $6ec3877863d57ff1$var$SAFE = 'SAFE';
const $6ec3877863d57ff1$var$UNSAFE = 'UNSAFE';
const $6ec3877863d57ff1$var$NOT_FOUND = 'NOT_FOUND';
const $6ec3877863d57ff1$var$COOKIE = 'COOKIE';
const $6ec3877863d57ff1$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $6ec3877863d57ff1$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $i9AMt.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $fFAhf.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $3VIC4.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $3VIC4.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $6ec3877863d57ff1$var$LOCAL_STORAGE ? this.store.getItem((0, $3VIC4.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $3VIC4.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $6ec3877863d57ff1$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $6ec3877863d57ff1$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch  {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $6ec3877863d57ff1$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($6ec3877863d57ff1$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $75pqB.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $6ec3877863d57ff1$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $6ec3877863d57ff1$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $6ec3877863d57ff1$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $6ec3877863d57ff1$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($6ec3877863d57ff1$var$COOKIE);
        switch(cookieValue.type){
            case $6ec3877863d57ff1$var$SAFE:
            case $6ec3877863d57ff1$var$UNSAFE:
                this.store.setItem((0, $3VIC4.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $6ec3877863d57ff1$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator) {
        const generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : ()=>{
            return (0, $akdUN.default)();
        };
        const newAnonId = generator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("3VIC4", function(module, exports) {
$parcel$export(module.exports, "AWCCookiesKeys", () => $a7be9a79b9b3fbaf$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $a7be9a79b9b3fbaf$export$d4cb17942ea57c95);
var $a7be9a79b9b3fbaf$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $a7be9a79b9b3fbaf$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $a7be9a79b9b3fbaf$var$isSecure = ()=>{
    try {
        return globalThis && globalThis.location && globalThis.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $a7be9a79b9b3fbaf$export$d4cb17942ea57c95 = {
    ["AWC_TLD_TEST"]: new $a7be9a79b9b3fbaf$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $a7be9a79b9b3fbaf$var$isSecure(),
        path: '/'
    }),
    ["AWC_ANALYTICS_DEBUG"]: new $a7be9a79b9b3fbaf$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $a7be9a79b9b3fbaf$var$isSecure(),
        path: '/'
    }),
    ["AJS_ANONYMOUS_ID"]: new $a7be9a79b9b3fbaf$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $a7be9a79b9b3fbaf$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("fFAhf", function(module, exports) {
$parcel$export(module.exports, "default", () => $572e7ed0755f0cb9$export$2e2bcd8739ae039);

var $6yOvq = parcelRequire("6yOvq");

var $3VIC4 = parcelRequire("3VIC4");

var $d5TBb = parcelRequire("d5TBb");

var $44mCf = parcelRequire("44mCf");
class $572e7ed0755f0cb9$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $44mCf.canUseCookie)(disableCookiePersistence) ? (0, $6yOvq.default) : new (0, $d5TBb.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $3VIC4.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $3VIC4.AllAnalyticsCookies)[name].getKey(), value, {
            ...(0, $3VIC4.AllAnalyticsCookies)[name].getAttributes(),
            // Function is memoized so we only calculate this once per page load
            domain: (0, $44mCf.getTld)(),
            ...options
        });
    }
    get(name) {
        if (!(0, $3VIC4.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $3VIC4.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $3VIC4.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $3VIC4.AllAnalyticsCookies)[name].getKey(), {
            ...options
        });
    }
}

});
parcelRegister("d5TBb", function(module, exports) {
$parcel$export(module.exports, "default", () => $d241ec98c26dae1e$export$2e2bcd8739ae039);

var $i9AMt = parcelRequire("i9AMt");
class $d241ec98c26dae1e$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $i9AMt.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("i9AMt", function(module, exports) {
$parcel$export(module.exports, "default", () => $6351ed4248e9951a$export$2e2bcd8739ae039);

var $bN4rZ = parcelRequire("bN4rZ");

var $adCuR = parcelRequire("adCuR");
class $6351ed4248e9951a$export$2e2bcd8739ae039 extends (0, $adCuR.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.localStorage || (0, $bN4rZ.default);
        } catch (err) {
            storageToUse = (0, $bN4rZ.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("bN4rZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b55ecc9b2bea828e$export$2e2bcd8739ae039);

var $fjlbX = parcelRequire("fjlbX");
// eslint-disable-next-line import/no-anonymous-default-export
const $b55ecc9b2bea828e$var$inmemorystorage = new (0, $fjlbX.InMemoryStore)();
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b55ecc9b2bea828e$export$2e2bcd8739ae039 = $b55ecc9b2bea828e$var$inmemorystorage;

});
parcelRegister("fjlbX", function(module, exports) {
$parcel$export(module.exports, "InMemoryStore", () => $f474ef4d98c809dd$export$90e3e001bcac59c7);
class $f474ef4d98c809dd$export$90e3e001bcac59c7 {
    constructor(){
        this._data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        };
        this.clear = ()=>{
            this._data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this._data)[index];
    }
}

});


parcelRegister("adCuR", function(module, exports) {
$parcel$export(module.exports, "default", () => $344d15765865c9c9$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $6yEEN = parcelRequire("6yEEN");

var $bN4rZ = parcelRequire("bN4rZ");

var $6WlvL = parcelRequire("6WlvL");
const $344d15765865c9c9$export$41c06fdd37b7e9a5 = 'awc';
const $344d15765865c9c9$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
class $344d15765865c9c9$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this._store;
        this.getItem = (key)=>this._store.getItem(this.createKey(key));
        this.removeItem = (key)=>this._store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this._store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this._store === (0, $bN4rZ.default) || typeof globalThis === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ((0, $6WlvL.isSupported)(globalThis[$344d15765865c9c9$export$770aa8bc07b3de03])) inMemoryStorage = globalThis[$344d15765865c9c9$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $bN4rZ.default);
                if (!globalThis[$344d15765865c9c9$export$770aa8bc07b3de03]) // If not already attached to globalThis then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                globalThis[$344d15765865c9c9$export$770aa8bc07b3de03] = (0, $bN4rZ.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        };
        this.clear = ()=>this._store.clear();
        this.key = (index)=>this._store.key(index);
        this.getPrefix = ()=>this._prefix;
        this.createKey = (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($344d15765865c9c9$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $6yEEN.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ((0, $6WlvL.isSupported)(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});
parcelRegister("6WlvL", function(module, exports) {
$parcel$export(module.exports, "isSupported", () => $1c27c81a57123648$export$48c17662a6902497);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $1c27c81a57123648$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

});




parcelRegister("44mCf", function(module, exports) {
$parcel$export(module.exports, "canUseCookie", () => $4c096f9acd8c1d81$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $4c096f9acd8c1d81$export$de6821eed3d5f32d);

var $6yOvq = parcelRequire("6yOvq");

var $2IvOD = parcelRequire("2IvOD");

var $3VIC4 = parcelRequire("3VIC4");
const $4c096f9acd8c1d81$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $4c096f9acd8c1d81$export$eb80e1beaa8dacf8 = (0, $3VIC4.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $4c096f9acd8c1d81$export$19164982d36535d8 = 'tld_test';
const $4c096f9acd8c1d81$export$de6821eed3d5f32d = (0, $2IvOD.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, $6yOvq.default).set($4c096f9acd8c1d81$export$eb80e1beaa8dacf8, $4c096f9acd8c1d81$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, $6yOvq.default).get($4c096f9acd8c1d81$export$eb80e1beaa8dacf8) === $4c096f9acd8c1d81$export$19164982d36535d8) {
            (0, $6yOvq.default).remove($4c096f9acd8c1d81$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});




parcelRegister("b4wuS", function(module, exports) {
$parcel$export(module.exports, "MetadataClient", () => $2dfe2130b57d2548$export$1ac223ae496131c9);

var $jKjZR = parcelRequire("jKjZR");

var $5JD19 = parcelRequire("5JD19");

var $c4drF = parcelRequire("c4drF");

var $begmT = parcelRequire("begmT");

var $7YeV5 = parcelRequire("7YeV5");

var $iIQlI = parcelRequire("iIQlI");

var $g34ub = parcelRequire("g34ub");

var $jQSOC = parcelRequire("jQSOC");

var $4t7l6 = parcelRequire("4t7l6");

var $6A6xV = parcelRequire("6A6xV");

var $wIHxY = parcelRequire("wIHxY");

var $hCUC3 = parcelRequire("hCUC3");
class $2dfe2130b57d2548$export$1ac223ae496131c9 {
    static{
        this.INITIAL_REFRESH_DELAY = 1;
    }
    static{
        this.Factory = (apiHostProtocol, apiHost, product)=>{
            return new $2dfe2130b57d2548$export$1ac223ae496131c9(apiHostProtocol, apiHost, product);
        };
    }
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $jKjZR.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            minRetryDelay: (0, $jQSOC.DEFAULT_METADATA_MIN_RETRY_DELAY),
            maxRetryDelay: (0, $jQSOC.DEFAULT_METADATA_MAX_RETRY_DELAY)
        });
        this._scheduler = new (0, $begmT.default)({
            ...this._options,
            waitInterval: (0, $jQSOC.DEFAULT_METADATA_REFRESH_INTERVAL)
        }, this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
    /**
   * Starts the metadata client. This will start the scheduler and begin
   * fetching metadata.
   *
   * @param allowRestart - If false, the client will not be restarted if it has already been stopped
   *						 by a call to stop().
   */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $2dfe2130b57d2548$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        this._fetchAbortController?.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $5JD19.default)((status)=>{
            if (status === (0, $iIQlI.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        if ((0, $g34ub.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        this._fetchAbortController?.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $6A6xV.fetchMetadata)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $jQSOC.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $wIHxY.MetadataResponse).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, $4t7l6.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, $hCUC3.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        if (this._userInfo?.userId === userInfo?.userId && this._userInfo?.userIdType === userInfo?.userIdType) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        if (this._tenantInfo?.tenantId === tenantInfo?.tenantId && this._tenantInfo?.tenantIdType === tenantInfo?.tenantIdType) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        if (this._networkStatus?.getNetworkStatus() === (0, $iIQlI.NetworkStatusEnum).OFFLINE) {
            done((0, $7YeV5.DoneState).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $7YeV5.DoneState).SUCCESS);
            this._scheduler.schedule();
        } catch  {
            done((0, $7YeV5.DoneState).ERROR);
        }
    }
    /**
   * Schedules a refresh of the metadata when the user or tenant info changes. There is
   * a short delay to allow for multiple changes to be batched together, such as when the
   * callers sets the user info and tenant info in quick succession.
   */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $jQSOC.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || (0, $c4drF.DEFAULT_POLLING_OPTIONS).backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : (0, $c4drF.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
            maxRetryDelay: options?.maxRetryDelay || (0, $c4drF.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || (0, $c4drF.DEFAULT_POLLING_OPTIONS).minRetryDelay
        };
    }
}

});
parcelRegister("jKjZR", function(module, exports) {
$parcel$export(module.exports, "isStargateProxyPath", () => $973ffd7dc1662a19$export$83a9dd8d74be72c);

var $4Pm5b = parcelRequire("4Pm5b");
function $973ffd7dc1662a19$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === (0, $4Pm5b.stargateProxyUrl)();
}

});
parcelRegister("4Pm5b", function(module, exports) {
$parcel$export(module.exports, "stargateProxyUrl", () => $8c95fc60ff472bec$export$78e02cfb66671ad0);
$parcel$export(module.exports, "selectHost", () => $8c95fc60ff472bec$export$18c0b81944902eae);

var $6yEEN = parcelRequire("6yEEN");

const $8c95fc60ff472bec$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $8c95fc60ff472bec$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $8c95fc60ff472bec$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $8c95fc60ff472bec$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $8c95fc60ff472bec$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $8c95fc60ff472bec$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $8c95fc60ff472bec$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $8c95fc60ff472bec$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $8c95fc60ff472bec$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
/**
* Returns the full Stargate proxy URL (host + proxy path) for the current host.
*
* This is the default endpoint for Commercial, FedRAMP Moderate (with Stargate),
* and Oasis IC environments. Using the first-party proxy works around browser
* restrictions with third-party cookies.
*
* In non-browser environments (e.g. SSR) where `window` is not defined, the host
* portion is omitted and the function returns only `STARGATE_PROXY_PATH`
* (i.e. `/gateway/api/gasv3/api/v1`).
*/ function $8c95fc60ff472bec$export$78e02cfb66671ad0() {
    return (typeof window !== 'undefined' ? window.location.host : '') + $8c95fc60ff472bec$export$5df9262e102d0c32;
}
const $8c95fc60ff472bec$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $6yEEN.envType).LOCAL || env === (0, $6yEEN.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $6yEEN.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $6yEEN.envType).PROD ? $8c95fc60ff472bec$var$FEDRAMP_PROD_HOST : $8c95fc60ff472bec$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $6yEEN.envType).PROD ? $8c95fc60ff472bec$var$STARGATE_FEDRAMP_PROD_HOST : $8c95fc60ff472bec$var$STARGATE_FEDRAMP_STAGING_HOST;
    return $8c95fc60ff472bec$export$78e02cfb66671ad0();
};
const $8c95fc60ff472bec$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $6yEEN.envType).PROD ? $8c95fc60ff472bec$var$PROD_HOST : $8c95fc60ff472bec$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $6yEEN.envType).PROD ? $8c95fc60ff472bec$var$STARGATE_PROD_HOST : $8c95fc60ff472bec$var$STARGATE_STAGING_HOST;
    return $8c95fc60ff472bec$export$78e02cfb66671ad0();
};
function $8c95fc60ff472bec$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, ic: ic, envOverride: envOverride, apiHost: apiHost }) {
    // If the caller has explicitly set an apiHost, use it as the endpoint.
    if (apiHost) return apiHost;
    // When running inside an IC, events are routed through the Stargate proxy.
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true. Legacy URLs are not supported in IC environments.');
        return $8c95fc60ff472bec$export$78e02cfb66671ad0();
    }
    if (perimeter === (0, $6yEEN.perimeterType).FEDRAMP_MODERATE) return $8c95fc60ff472bec$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $8c95fc60ff472bec$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}

});


parcelRegister("g34ub", function(module, exports) {
$parcel$export(module.exports, "TestSupport", () => $b19be266a2c13a8a$export$44b578549c42d779);
class $b19be266a2c13a8a$export$44b578549c42d779 {
    static{
        this.DISABLE_METADATA_CALLS_PROPERTY = '__awc_disable_metadata_calls__';
    }
    static{
        this.DISABLE_EVENT_CALLS_PROPERTY = '__awc_disable_event_calls__';
    }
    static{
        this.DISABLE_FETCH_CALLS_PROPERTY = '__awc_disable_fetch_calls__';
    }
    static{
        this.SYNTHETIC_FLAG_OVERRIDE_PROPERTY = '__awc_synthetic_flag_override__';
    }
    static isGeminiVREnvironment() {
        try {
            for(const k in globalThis){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($b19be266a2c13a8a$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($b19be266a2c13a8a$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($b19be266a2c13a8a$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getSyntheticFlagOverride() {
        return this.getGlobalTriStateProperty($b19be266a2c13a8a$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) return globalThis[propertyName] === true;
        return false;
    }
    static getGlobalTriStateProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) {
            const value = globalThis[propertyName];
            if (typeof value === 'boolean') return value;
        }
        return undefined;
    }
}

});

parcelRegister("6A6xV", function(module, exports) {
$parcel$export(module.exports, "fetchMetadata", () => $9bb63a70da714223$export$55b0d0261469055);

var $2IvOD = parcelRequire("2IvOD");

var $4t7l6 = parcelRequire("4t7l6");
const $9bb63a70da714223$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    const requestAbortController = $9bb63a70da714223$var$createRequestAbortController(timeout, signal);
    const corsOptions = $9bb63a70da714223$var$getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${params.userInfo?.userId || ''}`,
        userIdType: `${params.userInfo?.userIdType || ''}`,
        tenantId: `${params.tenantInfo?.tenantId || ''}`,
        tenantIdType: `${params.tenantInfo?.tenantIdType || ''}`
    }).toString();
    const response = await fetch(metadataUrl, {
        method: 'GET',
        signal: requestAbortController.signal,
        ...corsOptions
    });
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $4t7l6.FetchError)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $9bb63a70da714223$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal?.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $9bb63a70da714223$var$getCorsForUrl = (0, $2IvOD.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});

parcelRegister("wIHxY", function(module, exports) {
$parcel$export(module.exports, "MetadataResponse", () => $ba6031df816672e9$export$4b1a5e5486cc0d80);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
class $ba6031df816672e9$export$4b1a5e5486cc0d80 {
    constructor(props, url){
        this.props = props;
        this.url = url;
    }
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json?.url) ? json.url.trim() : '';
        return new $ba6031df816672e9$export$4b1a5e5486cc0d80(json?.props || null, url.startsWith('http') ? url : null);
    }
}

});


parcelRegister("4YfNf", function(module, exports) {
$parcel$export(module.exports, "isFirstParty", () => $9bf1c33c93ebfa36$export$f56713ced121eb91);

var $6yEEN = parcelRequire("6yEEN");
const $9bf1c33c93ebfa36$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $6yEEN.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};

});

parcelRegister("fsyj7", function(module, exports) {
$parcel$export(module.exports, "isThirdParty", () => $96fefcf3a49fa805$export$ab34f90cc32c8960);

var $6yEEN = parcelRequire("6yEEN");
const $96fefcf3a49fa805$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $6yEEN.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

});

parcelRegister("7YjGB", function(module, exports) {
$parcel$export(module.exports, "LoggingResponseCallback", () => $4fbb9b73847da03f$export$48361b6ed38f1b0);
class $4fbb9b73847da03f$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $4fbb9b73847da03f$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}

});

parcelRegister("gxsPs", function(module, exports) {
$parcel$export(module.exports, "objectValues", () => $434bc43c89d2a86a$export$ad1854f4a08c15f8);
function $434bc43c89d2a86a$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}

});

parcelRegister("ezsdd", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8741e5cf8146677$export$2e2bcd8739ae039);

var $6yEEN = parcelRequire("6yEEN");

var $aNsr9 = parcelRequire("aNsr9");
class $b8741e5cf8146677$export$2e2bcd8739ae039 {
    static{
        this.messageEvent = 'origin landed';
    }
    constructor(){
        this.pendingCleanup = null;
        this.handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $6yEEN.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture params WITHOUT removing from URL (explicit no-op required because
            // urlParamExtractor defaults to calling history.replaceState if omitted)
            const paramExtractorReplace = ()=>{};
            const capturedURLParams = (0, $aNsr9.default)(isCaptureParam, paramExtractorReplace);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const capturedOriginTraces = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            if (Object.keys(capturedOriginTraces).length > 0) this.pendingCleanup = ()=>{
                (0, $aNsr9.default)(isCaptureParam, historyReplaceFn);
            };
            return capturedOriginTraces;
        };
        this._originStore = {};
    }
    /** Executes and clears any pending origin param cleanup. No-op if nothing is pending. */ _cleanupOriginParams() {
        if (this.pendingCleanup) {
            const cleanup = this.pendingCleanup;
            this.pendingCleanup = null;
            cleanup();
        }
    }
    /**
   * Designed to be invoked after a successful flush with the batch of flushed events.
   */ cleanupOriginParameters(events) {
        try {
            if (this.pendingCleanup) {
                const hasOriginLanded = events.some((item)=>'event' in item.msg && item.msg.event === $b8741e5cf8146677$export$2e2bcd8739ae039.messageEvent);
                if (hasOriginLanded) this._cleanupOriginParams();
            }
        } catch  {
        // Silently ignore cleanup errors to avoid disrupting the flush cycle
        }
    }
}

});

parcelRegister("9D95u", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8b369d7f47b502c$export$2e2bcd8739ae039);

var $f4X2T = parcelRequire("f4X2T");

var $i9AMt = parcelRequire("i9AMt");
// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
const $b8b369d7f47b502c$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $b8b369d7f47b502c$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $b8b369d7f47b502c$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $b8b369d7f47b502c$export$285f6bddd927a06d = 1800000;
const $b8b369d7f47b502c$export$a92e915d70316eb2 = 5000;
const $b8b369d7f47b502c$export$de43760b2dc10c19 = 0.9;
class $b8b369d7f47b502c$export$2e2bcd8739ae039 {
    constructor(options = {}){
        this._generateNewSessionId = ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($b8b369d7f47b502c$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        };
        this._updateSessionExpiry = ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($b8b369d7f47b502c$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this._debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        };
        this._sessionExpiryTime = options.sessionExpiryTime || $b8b369d7f47b502c$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $b8b369d7f47b502c$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $b8b369d7f47b502c$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : (0, $f4X2T.NOOP);
        this._safeLocalStorage = new (0, $i9AMt.default)();
    }
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($b8b369d7f47b502c$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($b8b369d7f47b502c$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$b8b369d7f47b502c$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
}

});
parcelRegister("f4X2T", function(module, exports) {
$parcel$export(module.exports, "NOOP", () => $ba4ec6e887e122e4$export$5702a91a6f42969f);
// 90% of expiry
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $ba4ec6e887e122e4$export$5702a91a6f42969f = ()=>{};

});


parcelRegister("8kCZu", function(module, exports) {
$parcel$export(module.exports, "default", () => $cffffb4be491cbfd$export$2e2bcd8739ae039);

var $bN4rZ = parcelRequire("bN4rZ");

var $adCuR = parcelRequire("adCuR");
class $cffffb4be491cbfd$export$2e2bcd8739ae039 extends (0, $adCuR.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.sessionStorage || (0, $bN4rZ.default);
        } catch (err) {
            storageToUse = (0, $bN4rZ.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("79qz9", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d61f9207a561211$export$2e2bcd8739ae039);

var $8kCZu = parcelRequire("8kCZu");

var $akdUN = parcelRequire("akdUN");
const $5d61f9207a561211$var$STORAGE_KEY = 'tab.id';
class $5d61f9207a561211$export$2e2bcd8739ae039 {
    constructor(){
        this._generateNewTabId = ()=>{
            const newTabId = (0, $akdUN.default)();
            this._safeSessionStorage.setItem($5d61f9207a561211$var$STORAGE_KEY, newTabId);
            return newTabId;
        };
        this._safeSessionStorage = new (0, $8kCZu.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($5d61f9207a561211$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}

});

parcelRegister("fMH0v", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0d8dd21a2f776bc$export$2e2bcd8739ae039);

var $9FFsN = parcelRequire("9FFsN");

var $6yEEN = parcelRequire("6yEEN");

var $hlFNB = parcelRequire("hlFNB");

var $8kCZu = parcelRequire("8kCZu");

var $aNsr9 = parcelRequire("aNsr9");

var $akdUN = parcelRequire("akdUN");
const $e0d8dd21a2f776bc$var$STORAGE_KEY = 'taskSessions';
const $e0d8dd21a2f776bc$var$INIT_KEY = 'taskSessionsInit';
const $e0d8dd21a2f776bc$var$AWC_PARAM_PREFIX = 'awc.';
const $e0d8dd21a2f776bc$var$TASK_SESSION_RELOAD_TIME = 3000;
class $e0d8dd21a2f776bc$export$2e2bcd8739ae039 {
    constructor(){
        this._taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem($e0d8dd21a2f776bc$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($e0d8dd21a2f776bc$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($e0d8dd21a2f776bc$var$INIT_KEY) || '0', 10) < currentTimestamp - $e0d8dd21a2f776bc$var$TASK_SESSION_RELOAD_TIME;
        this._removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split($e0d8dd21a2f776bc$var$AWC_PARAM_PREFIX)[1];
        this._isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith($e0d8dd21a2f776bc$var$AWC_PARAM_PREFIX);
        this.getAllTaskSessions = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($e0d8dd21a2f776bc$var$STORAGE_KEY) || '');
            } catch  {
                return {};
            }
        };
        this._writeToSessionStorage = (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($e0d8dd21a2f776bc$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch  {}
        };
        this._appendTaskSessions = (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        };
        this._safelyRemoveKey = (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        };
        this.createTaskSession = (taskSessionName)=>{
            const taskSessionId = (0, $akdUN.default)();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        };
        this.createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        };
        this.completeTaskSession = (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        };
        this.formatTaskSessionQueryString = ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $9FFsN.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $hlFNB.pick)(currentState, includedTaskSessions) : (0, $hlFNB.omit)(currentState, Object.values((0, $6yEEN.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = {
                ...(0, $hlFNB.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$e0d8dd21a2f776bc$var$AWC_PARAM_PREFIX + taskSessionName),
                ...query
            };
            return `${url}?${(0, $9FFsN.stringify)(queryWithTaskSessions)}`;
        };
        this.stripQueryParameters = ()=>{
            const extractedTaskSessions = (0, $hlFNB.mapKeys)((0, $aNsr9.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        };
        const currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $8kCZu.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($e0d8dd21a2f776bc$var$INIT_KEY, currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch  {}
    }
}

});

parcelRegister("lches", function(module, exports) {
$parcel$export(module.exports, "default", () => $2eccb035b0c97033$export$2e2bcd8739ae039);

var $6yOvq = parcelRequire("6yOvq");

var $3VIC4 = parcelRequire("3VIC4");

var $g34ub = parcelRequire("g34ub");
const $2eccb035b0c97033$var$MAX_CACHE_SIZE = 100;
const $2eccb035b0c97033$var$COOKIE_NAME = (0, $3VIC4.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $2eccb035b0c97033$var$DEBUG_TAG = 'synthetic';
class $2eccb035b0c97033$var$TestingCache {
    constructor(syntheticFlagOverride, enableTestingCache){
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = $2eccb035b0c97033$var$TestingCache.getDebugCookie();
        this.bind();
    }
    saveEvent(event) {
        try {
            if (!event) return;
            this.bind();
            this.addSyntheticTag(event);
            this.cache(event);
        } catch  {
        // Ignore errors from testing cache.
        }
    }
    bind() {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: ()=>window.testAnalytics.eventCache,
            clear: ()=>{
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem('awc.ui.viewed.last.sent');
                    localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                    localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                    localStorage.removeItem('awc-local.ui.viewed.last.sent');
                } catch  {
                // Ignore errors from localStorage.
                }
            }
        };
    }
    cache(event) {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
        if (window.testAnalytics.eventCache.length >= $2eccb035b0c97033$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    }
    addSyntheticTag(event) {
        if (!this.shouldSetSyntheticFlag()) return;
        if (event.tags instanceof Array) {
            if (!event.tags.includes($2eccb035b0c97033$var$DEBUG_TAG)) event.tags.push($2eccb035b0c97033$var$DEBUG_TAG);
        } else event.tags = [
            $2eccb035b0c97033$var$DEBUG_TAG
        ];
    }
    shouldCacheEvent() {
        return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
    }
    shouldSetSyntheticFlag() {
        if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
        const globalSyntheticOverride = (0, $g34ub.TestSupport).getSyntheticFlagOverride();
        if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
        return this.shouldCacheEvent();
    }
    static getDebugCookie() {
        try {
            return JSON.parse((0, $6yOvq.default).get($2eccb035b0c97033$var$COOKIE_NAME) || 'false') === true;
        } catch  {
            (0, $6yOvq.default).remove($2eccb035b0c97033$var$COOKIE_NAME);
        }
        return false;
    }
}
var $2eccb035b0c97033$export$2e2bcd8739ae039 = $2eccb035b0c97033$var$TestingCache;

});

parcelRegister("lqefr", function(module, exports) {
$parcel$export(module.exports, "default", () => $097420b529b8174e$export$2e2bcd8739ae039);

var $6yEEN = parcelRequire("6yEEN");

var $1Zypc = parcelRequire("1Zypc");

var $i9AMt = parcelRequire("i9AMt");
const $097420b529b8174e$var$DEFAULT_DELAY = 2000; // 2 seconds
const $097420b529b8174e$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $097420b529b8174e$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const $097420b529b8174e$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
var $097420b529b8174e$var$SendEventDecision = /*#__PURE__*/ function(SendEventDecision) {
    SendEventDecision[SendEventDecision["FocusLost"] = 0] = "FocusLost";
    SendEventDecision[SendEventDecision["UserOrTenantIncomplete"] = 1] = "UserOrTenantIncomplete";
    SendEventDecision[SendEventDecision["MalformedUiViewedRateLimited"] = 2] = "MalformedUiViewedRateLimited";
    SendEventDecision[SendEventDecision["EligibleToSend"] = 3] = "EligibleToSend";
    SendEventDecision[SendEventDecision["UiViewedRateLimited"] = 4] = "UiViewedRateLimited";
    return SendEventDecision;
}($097420b529b8174e$var$SendEventDecision || {});
class $097420b529b8174e$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        this.start = ()=>{
            this._startInterval();
            this._bindEventListeners();
        };
        this.stop = ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        };
        this.resetTimers = ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        };
        this.signalUserActive = ()=>{
            this._sendUserActiveEvents();
        };
        this._bindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        };
        this._unbindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        };
        this._startInterval = ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleDwellTimerTriggered, this._delay);
        };
        this._stopInterval = ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        };
        this._getProductKey = (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        };
        this._getLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._parseLocalStorageData = (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || '');
            } catch  {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        };
        this._getMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._setLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        };
        this._setMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        };
        this._handleDwellTimerTriggered = ()=>{
            const document = (0, $1Zypc.getDocument)();
            if (document && !document.hasFocus()) return;
            this._sendUserActiveEvents();
        };
        this._sendUserActiveEvents = ()=>{
            const { embeddedProduct: embeddedProduct, ...context } = this._getContext();
            this._sendEvent(this._product, context, false);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        };
        this._sendEvent = (product, context, isEmbeddedProduct)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const sendEventDecision = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(sendEventDecision){
                case 3:
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                    break;
                case 1:
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                    break;
                default:
                    break;
            }
        };
        this._shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, $6yEEN.tenantType).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return 1;
                return 2;
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return 3;
            return 4;
        };
        this._createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product: product,
                source: 'ui',
                action: action,
                actionSubject: actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = {
                    ...event.attributes,
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                };
            }
            if (lastScreenEvent) event.attributes = {
                ...event.attributes,
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            };
            return event;
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $097420b529b8174e$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $097420b529b8174e$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $097420b529b8174e$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $097420b529b8174e$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $i9AMt.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});
parcelRegister("1Zypc", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $5a446e1345c26f8c$export$f65ca476c09acec0);
const $5a446e1345c26f8c$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("grc8S", function(module, exports) {
$parcel$export(module.exports, "validateIdentifyEvent", () => $7887eeb2a106f514$export$c16a4e16aa4026c0);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $6yEEN = parcelRequire("6yEEN");

var $7ruzK = parcelRequire("7ruzK");

var $gxsPs = parcelRequire("gxsPs");
function $7887eeb2a106f514$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $7ruzK.isType)((0, $6yEEN.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $gxsPs.objectValues)((0, $6yEEN.userType))}]`);
}

});

parcelRegister("l0B9l", function(module, exports) {
$parcel$export(module.exports, "validateOperationalEvent", () => $b06f39794e9500a4$export$1e561554275607ef);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $9l1HQ = parcelRequire("9l1HQ");
function $b06f39794e9500a4$export$1e561554275607ef(event) {
    (0, $9l1HQ.validateActionEvent)(event);
}

});

parcelRegister("j8q2U", function(module, exports) {
$parcel$export(module.exports, "validatePlatform", () => $9094e15a5a2ac071$export$801b46c35394d316);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $6yEEN = parcelRequire("6yEEN");

var $7ruzK = parcelRequire("7ruzK");

var $gxsPs = parcelRequire("gxsPs");
function $9094e15a5a2ac071$export$801b46c35394d316(productInfo) {
    if (!(0, $7ruzK.isType)((0, $6yEEN.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $gxsPs.objectValues)((0, $6yEEN.platformType))}]`);
    if (productInfo.origin === (0, $6yEEN.originType).DESKTOP && !(0, $7ruzK.isType)((0, $6yEEN.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $6yEEN.originType).WEB && !(0, $7ruzK.isType)((0, $6yEEN.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});

parcelRegister("foSph", function(module, exports) {
$parcel$export(module.exports, "validateScreenEvent", () => $58a625a553fa959b$export$dc993432a592dc27);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ function $58a625a553fa959b$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}

});

parcelRegister("fSLua", function(module, exports) {
$parcel$export(module.exports, "validateTrackEvent", () => $2714bfa4dbf6ccc7$export$8c014fd74b0c8b99);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $9l1HQ = parcelRequire("9l1HQ");
function $2714bfa4dbf6ccc7$export$8c014fd74b0c8b99(event) {
    (0, $9l1HQ.validateActionEvent)(event);
}

});

parcelRegister("6RBzd", function(module, exports) {
$parcel$export(module.exports, "validateUIEvent", () => $a743960e4a92713f$export$e5bac0930c812e90);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $9l1HQ = parcelRequire("9l1HQ");
function $a743960e4a92713f$export$e5bac0930c812e90(event) {
    (0, $9l1HQ.validateActionEvent)(event);
}

});

parcelRegister("hNvco", function(module, exports) {
$parcel$export(module.exports, "default", () => $b12ad62ff59d1201$export$2e2bcd8739ae039);
function $b12ad62ff59d1201$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("jIMQu", function(module, exports) {
$parcel$export(module.exports, "XIDPromise", () => $19bfc829ab585028$export$fbe53bbbe682bcdd);

var $blkpN = parcelRequire("blkpN");
const $19bfc829ab585028$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $blkpN.createTimeoutXid)()), (0, $blkpN.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $blkpN.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("blkpN", function(module, exports) {
$parcel$export(module.exports, "XID_TIMEOUT", () => $5b05870376aed452$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $5b05870376aed452$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $5b05870376aed452$export$fa341d0c750d705b);

var $fNacg = parcelRequire("fNacg");
const $5b05870376aed452$export$545bcbd53afabfa3 = 5000;
const $5b05870376aed452$export$af4087e36d63846 = ()=>[
        {
            type: (0, $fNacg.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $fNacg.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $5b05870376aed452$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $fNacg.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $fNacg.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("fNacg", function(module, exports) {
$parcel$export(module.exports, "XIDItemType", () => $8436d7eb5bd6f3eb$export$92ca0438bcb0d396);
var $8436d7eb5bd6f3eb$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $8436d7eb5bd6f3eb$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("Mb6Wv", function(module, exports) {
$parcel$export(module.exports, "httpClientIntegration", () => $090d1a37efbf2295$export$8a3b7aeb379b3907);

var $84KxT = parcelRequire("84KxT");
var $bkEHm = parcelRequire("bkEHm");
var $i38Fr = parcelRequire("i38Fr");
var $568f3 = parcelRequire("568f3");
var $9zTQv = parcelRequire("9zTQv");
var $gflYe = parcelRequire("gflYe");
var $1VQS3 = parcelRequire("1VQS3");
var $aieBB = parcelRequire("aieBB");
var $gmBzB = parcelRequire("gmBzB");

var $8x8vX = parcelRequire("8x8vX");

var $d70tI = parcelRequire("d70tI");
const $090d1a37efbf2295$var$INTEGRATION_NAME = 'HttpClient';
const $090d1a37efbf2295$var$_httpClientIntegration = (options = {})=>{
    const _options = {
        failedRequestStatusCodes: [
            [
                500,
                599
            ]
        ],
        failedRequestTargets: [
            /.*/
        ],
        ...options
    };
    return {
        name: $090d1a37efbf2295$var$INTEGRATION_NAME,
        setup (client) {
            $090d1a37efbf2295$var$_wrapFetch(client, _options);
            $090d1a37efbf2295$var$_wrapXHR(client, _options);
        }
    };
};
/**
 * Create events for failed client side HTTP requests.
 */ const $090d1a37efbf2295$export$8a3b7aeb379b3907 = (0, $568f3.defineIntegration)($090d1a37efbf2295$var$_httpClientIntegration);
/**
 * Interceptor function for fetch requests
 *
 * @param requestInfo The Fetch API request info
 * @param response The Fetch API response
 * @param requestInit The request init object
 */ function $090d1a37efbf2295$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error) {
    if ($090d1a37efbf2295$var$_shouldCaptureResponse(options, response.status, response.url)) {
        const request = $090d1a37efbf2295$var$_getRequest(requestInfo, requestInit);
        let requestHeaders, responseHeaders, requestCookies, responseCookies;
        if ($090d1a37efbf2295$var$_shouldSendDefaultPii()) {
            [requestHeaders, requestCookies] = $090d1a37efbf2295$var$_parseCookieHeaders('Cookie', request);
            [responseHeaders, responseCookies] = $090d1a37efbf2295$var$_parseCookieHeaders('Set-Cookie', response);
        }
        const event = $090d1a37efbf2295$var$_createEvent({
            url: request.url,
            method: request.method,
            status: response.status,
            requestHeaders: requestHeaders,
            responseHeaders: responseHeaders,
            requestCookies: requestCookies,
            responseCookies: responseCookies,
            error: error
        });
        (0, $i38Fr.captureEvent)(event);
    }
}
function $090d1a37efbf2295$var$_parseCookieHeaders(cookieHeader, obj) {
    const headers = $090d1a37efbf2295$var$_extractFetchHeaders(obj.headers);
    let cookies;
    try {
        const cookieString = headers[cookieHeader] || headers[cookieHeader.toLowerCase()] || undefined;
        if (cookieString) cookies = $090d1a37efbf2295$var$_parseCookieString(cookieString);
    } catch  {
    // ignore it if parsing fails
    }
    return [
        headers,
        cookies
    ];
}
/**
 * Interceptor function for XHR requests
 *
 * @param xhr The XHR request
 * @param method The HTTP method
 * @param headers The HTTP headers
 */ function $090d1a37efbf2295$var$_xhrResponseHandler(options, xhr, method, headers, error) {
    if ($090d1a37efbf2295$var$_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
        let requestHeaders, responseCookies, responseHeaders;
        if ($090d1a37efbf2295$var$_shouldSendDefaultPii()) {
            try {
                const cookieString = xhr.getResponseHeader('Set-Cookie') || xhr.getResponseHeader('set-cookie') || undefined;
                if (cookieString) responseCookies = $090d1a37efbf2295$var$_parseCookieString(cookieString);
            } catch  {
            // ignore it if parsing fails
            }
            try {
                responseHeaders = $090d1a37efbf2295$var$_getXHRResponseHeaders(xhr);
            } catch  {
            // ignore it if parsing fails
            }
            requestHeaders = headers;
        }
        const event = $090d1a37efbf2295$var$_createEvent({
            url: xhr.responseURL,
            method: method,
            status: xhr.status,
            requestHeaders: requestHeaders,
            responseHeaders: // Can't access request cookies from XHR
            responseHeaders,
            responseCookies: responseCookies,
            error: error
        });
        (0, $i38Fr.captureEvent)(event);
    }
}
/**
 * Extracts response size from `Content-Length` header when possible
 *
 * @param headers
 * @returns The response size in bytes or undefined
 */ function $090d1a37efbf2295$var$_getResponseSizeFromHeaders(headers) {
    if (headers) {
        const contentLength = headers['Content-Length'] || headers['content-length'];
        if (contentLength) return parseInt(contentLength, 10);
    }
    return undefined;
}
/**
 * Creates an object containing cookies from the given cookie string
 *
 * @param cookieString The cookie string to parse
 * @returns The parsed cookies
 */ function $090d1a37efbf2295$var$_parseCookieString(cookieString) {
    return cookieString.split('; ').reduce((acc, cookie)=>{
        const [key, value] = cookie.split('=');
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Extracts the headers as an object from the given Fetch API request or response object
 *
 * @param headers The headers to extract
 * @returns The extracted headers as an object
 */ function $090d1a37efbf2295$var$_extractFetchHeaders(headers) {
    const result = {};
    headers.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
/**
 * Extracts the response headers as an object from the given XHR object
 *
 * @param xhr The XHR object to extract the response headers from
 * @returns The response headers as an object
 */ function $090d1a37efbf2295$var$_getXHRResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Checks if the given target url is in the given list of targets
 *
 * @param target The target url to check
 * @returns true if the target url is in the given list of targets, false otherwise
 */ function $090d1a37efbf2295$var$_isInGivenRequestTargets(failedRequestTargets, target) {
    return failedRequestTargets.some((givenRequestTarget)=>{
        if (typeof givenRequestTarget === 'string') return target.includes(givenRequestTarget);
        return givenRequestTarget.test(target);
    });
}
/**
 * Checks if the given status code is in the given range
 *
 * @param status The status code to check
 * @returns true if the status code is in the given range, false otherwise
 */ function $090d1a37efbf2295$var$_isInGivenStatusRanges(failedRequestStatusCodes, status) {
    return failedRequestStatusCodes.some((range)=>{
        if (typeof range === 'number') return range === status;
        return status >= range[0] && status <= range[1];
    });
}
/**
 * Wraps `fetch` function to capture request and response data
 */ function $090d1a37efbf2295$var$_wrapFetch(client, options) {
    if (!(0, $gmBzB.supportsNativeFetch)()) return;
    (0, $bkEHm.addFetchInstrumentationHandler)((handlerData)=>{
        if ((0, $9zTQv.getClient)() !== client) return;
        const { response: response, args: args, error: error, virtualError: virtualError } = handlerData;
        const [requestInfo, requestInit] = args;
        if (!response) return;
        $090d1a37efbf2295$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error || virtualError);
    }, false);
}
/**
 * Wraps XMLHttpRequest to capture request and response data
 */ function $090d1a37efbf2295$var$_wrapXHR(client, options) {
    if (!('XMLHttpRequest' in (0, $gflYe.GLOBAL_OBJ))) return;
    (0, $8x8vX.addXhrInstrumentationHandler)((handlerData)=>{
        if ((0, $9zTQv.getClient)() !== client) return;
        const { error: error, virtualError: virtualError } = handlerData;
        const xhr = handlerData.xhr;
        const sentryXhrData = xhr[0, $8x8vX.SENTRY_XHR_DATA_KEY];
        if (!sentryXhrData) return;
        const { method: method, request_headers: headers } = sentryXhrData;
        try {
            $090d1a37efbf2295$var$_xhrResponseHandler(options, xhr, method, headers, error || virtualError);
        } catch (e) {
            (0, $d70tI.DEBUG_BUILD) && (0, $aieBB.logger).warn('Error while extracting response event form XHR response', e);
        }
    });
}
/**
 * Checks whether to capture given response as an event
 *
 * @param status response status code
 * @param url response url
 */ function $090d1a37efbf2295$var$_shouldCaptureResponse(options, status, url) {
    return $090d1a37efbf2295$var$_isInGivenStatusRanges(options.failedRequestStatusCodes, status) && $090d1a37efbf2295$var$_isInGivenRequestTargets(options.failedRequestTargets, url) && !(0, $1VQS3.isSentryRequestUrl)(url, (0, $9zTQv.getClient)());
}
/**
 * Creates a synthetic Sentry event from given response data
 *
 * @param data response data
 * @returns event
 */ function $090d1a37efbf2295$var$_createEvent(data) {
    const client = (0, $9zTQv.getClient)();
    const virtualStackTrace = client && data.error && data.error instanceof Error ? data.error.stack : undefined;
    // Remove the first frame from the stack as it's the HttpClient call
    const stack = virtualStackTrace && client ? client.getOptions().stackParser(virtualStackTrace, 0, 1) : undefined;
    const message = `HTTP Client Error with status code: ${data.status}`;
    const event = {
        message: message,
        exception: {
            values: [
                {
                    type: 'Error',
                    value: message,
                    stacktrace: stack ? {
                        frames: stack
                    } : undefined
                }
            ]
        },
        request: {
            url: data.url,
            method: data.method,
            headers: data.requestHeaders,
            cookies: data.requestCookies
        },
        contexts: {
            response: {
                status_code: data.status,
                headers: data.responseHeaders,
                cookies: data.responseCookies,
                body_size: $090d1a37efbf2295$var$_getResponseSizeFromHeaders(data.responseHeaders)
            }
        }
    };
    (0, $84KxT.addExceptionMechanism)(event, {
        type: 'http.client',
        handled: false
    });
    return event;
}
function $090d1a37efbf2295$var$_getRequest(requestInfo, requestInit) {
    if (!requestInit && requestInfo instanceof Request) return requestInfo;
    // If both are set, we try to construct a new Request with the given arguments
    // However, if e.g. the original request has a `body`, this will throw an error because it was already accessed
    // In this case, as a fallback, we just use the original request - using both is rather an edge case
    if (requestInfo instanceof Request && requestInfo.bodyUsed) return requestInfo;
    return new Request(requestInfo, requestInit);
}
function $090d1a37efbf2295$var$_shouldSendDefaultPii() {
    const client = (0, $9zTQv.getClient)();
    return client ? Boolean(client.getOptions().sendDefaultPii) : false;
}

});
parcelRegister("bkEHm", function(module, exports) {
$parcel$export(module.exports, "addFetchInstrumentationHandler", () => $840121d5c565c152$export$f75d3c772c923df0);

var $5hnoa = parcelRequire("5hnoa");

var $2bu2L = parcelRequire("2bu2L");

var $gmBzB = parcelRequire("gmBzB");

var $a2WQ6 = parcelRequire("a2WQ6");

var $gflYe = parcelRequire("gflYe");

var $b9xCt = parcelRequire("b9xCt");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $840121d5c565c152$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $b9xCt.addHandler)(type, handler);
    (0, $b9xCt.maybeInstrument)(type, ()=>$840121d5c565c152$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $840121d5c565c152$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $b9xCt.addHandler)(type, handler);
    (0, $b9xCt.maybeInstrument)(type, ()=>$840121d5c565c152$var$instrumentFetch($840121d5c565c152$var$streamHandler));
}
function $840121d5c565c152$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $gmBzB.supportsNativeFetch)()) return;
    (0, $2bu2L.fill)((0, $gflYe.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $840121d5c565c152$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $a2WQ6.timestampInSeconds)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $840121d5c565c152$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $b9xCt.triggerHandlers)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $gflYe.GLOBAL_OBJ), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $b9xCt.triggerHandlers)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $a2WQ6.timestampInSeconds)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $b9xCt.triggerHandlers)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $a2WQ6.timestampInSeconds)() * 1000,
                    error: error
                });
                if ((0, $5hnoa.isError)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $2bu2L.addNonEnumerableProperty)(error, 'framesToPop', 1);
                }
                // We enhance the not-so-helpful "Failed to fetch" error messages with the host
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                if (error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    error.message = `${error.message} (${url.host})`;
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $840121d5c565c152$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $840121d5c565c152$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $840121d5c565c152$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $b9xCt.triggerHandlers)('fetch-body-resolved', {
            endTimestamp: (0, $a2WQ6.timestampInSeconds)() * 1000,
            response: response
        });
    });
}
function $840121d5c565c152$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $840121d5c565c152$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($840121d5c565c152$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $840121d5c565c152$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $840121d5c565c152$var$getUrlFromResource(url),
            method: $840121d5c565c152$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $840121d5c565c152$var$getUrlFromResource(arg),
        method: $840121d5c565c152$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $840121d5c565c152$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $5hnoa.isRequest)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}

});
parcelRegister("gmBzB", function(module, exports) {
$parcel$export(module.exports, "supportsHistory", () => $be9bd8abcc7e660c$export$67fc34576016d6ec);
$parcel$export(module.exports, "isNativeFunction", () => $be9bd8abcc7e660c$export$d5f608b368e73f38);
$parcel$export(module.exports, "supportsNativeFetch", () => $be9bd8abcc7e660c$export$c82d238e23c40b21);

var $dYTLo = parcelRequire("dYTLo");

var $aieBB = parcelRequire("aieBB");

var $gflYe = parcelRequire("gflYe");
const $be9bd8abcc7e660c$var$WINDOW = (0, $gflYe.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $be9bd8abcc7e660c$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $be9bd8abcc7e660c$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $be9bd8abcc7e660c$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $be9bd8abcc7e660c$export$67fc34576016d6ec() {
    return 'history' in $be9bd8abcc7e660c$var$WINDOW && !!$be9bd8abcc7e660c$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $be9bd8abcc7e660c$export$edf3cb81fd7d2a3e = $be9bd8abcc7e660c$var$_isFetchSupported;
function $be9bd8abcc7e660c$var$_isFetchSupported() {
    if (!('fetch' in $be9bd8abcc7e660c$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $be9bd8abcc7e660c$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $be9bd8abcc7e660c$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$be9bd8abcc7e660c$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($be9bd8abcc7e660c$export$d5f608b368e73f38($be9bd8abcc7e660c$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $be9bd8abcc7e660c$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $be9bd8abcc7e660c$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $be9bd8abcc7e660c$export$531055a6c684a70a() {
    return 'ReportingObserver' in $be9bd8abcc7e660c$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $be9bd8abcc7e660c$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$be9bd8abcc7e660c$var$_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("b9xCt", function(module, exports) {
$parcel$export(module.exports, "addHandler", () => $81ea9d1d14903414$export$a4e09611e30da72e);
$parcel$export(module.exports, "maybeInstrument", () => $81ea9d1d14903414$export$e18d6c5462c01368);
$parcel$export(module.exports, "triggerHandlers", () => $81ea9d1d14903414$export$b18c893e424d3127);

var $dYTLo = parcelRequire("dYTLo");

var $aieBB = parcelRequire("aieBB");

var $9QP64 = parcelRequire("9QP64");
// We keep the handlers globally
const $81ea9d1d14903414$var$handlers = {};
const $81ea9d1d14903414$var$instrumented = {};
/** Add a handler function. */ function $81ea9d1d14903414$export$a4e09611e30da72e(type, handler) {
    $81ea9d1d14903414$var$handlers[type] = $81ea9d1d14903414$var$handlers[type] || [];
    $81ea9d1d14903414$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $81ea9d1d14903414$export$b17eab759a1cb5fe() {
    Object.keys($81ea9d1d14903414$var$handlers).forEach((key)=>{
        $81ea9d1d14903414$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $81ea9d1d14903414$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$81ea9d1d14903414$var$instrumented[type]) {
        $81ea9d1d14903414$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $81ea9d1d14903414$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $81ea9d1d14903414$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $9QP64.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("568f3", function(module, exports) {
$parcel$export(module.exports, "getIntegrationsToSetup", () => $3b63e7f0ac37fc6c$export$68bc4c01ab8ae766);
$parcel$export(module.exports, "setupIntegrations", () => $3b63e7f0ac37fc6c$export$51abed9797baa598);
$parcel$export(module.exports, "setupIntegration", () => $3b63e7f0ac37fc6c$export$e7390a03b70a6f2f);
$parcel$export(module.exports, "afterSetupIntegrations", () => $3b63e7f0ac37fc6c$export$35abcfd71227c6ca);
$parcel$export(module.exports, "defineIntegration", () => $3b63e7f0ac37fc6c$export$2323046b9414659f);

var $9zTQv = parcelRequire("9zTQv");

var $dYTLo = parcelRequire("dYTLo");

var $aieBB = parcelRequire("aieBB");
const $3b63e7f0ac37fc6c$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $3b63e7f0ac37fc6c$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $3b63e7f0ac37fc6c$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $3b63e7f0ac37fc6c$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $3b63e7f0ac37fc6c$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $3b63e7f0ac37fc6c$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $3b63e7f0ac37fc6c$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $3b63e7f0ac37fc6c$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($3b63e7f0ac37fc6c$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $3b63e7f0ac37fc6c$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $3b63e7f0ac37fc6c$export$2d8f5188773bcddd(integration) {
    const client = (0, $9zTQv.getClient)();
    if (!client) {
        (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $3b63e7f0ac37fc6c$export$2323046b9414659f(fn) {
    return fn;
}

});

parcelRegister("1VQS3", function(module, exports) {
$parcel$export(module.exports, "isSentryRequestUrl", () => $16842058dc81b5b6$export$d92e61f5600202af);
/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function $16842058dc81b5b6$export$d92e61f5600202af(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $16842058dc81b5b6$var$checkDsn(url, dsn) || $16842058dc81b5b6$var$checkTunnel(url, tunnel);
}
function $16842058dc81b5b6$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $16842058dc81b5b6$var$removeTrailingSlash(url) === $16842058dc81b5b6$var$removeTrailingSlash(tunnel);
}
function $16842058dc81b5b6$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $16842058dc81b5b6$var$removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}

});

parcelRegister("8x8vX", function(module, exports) {
$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", () => $63680292f0848cdf$export$55b6bb1e45c6cf59);
$parcel$export(module.exports, "addXhrInstrumentationHandler", () => $63680292f0848cdf$export$26ace48dd54c9aea);

var $b9xCt = parcelRequire("b9xCt");
var $5hnoa = parcelRequire("5hnoa");
var $a2WQ6 = parcelRequire("a2WQ6");

var $lATnS = parcelRequire("lATnS");
const $63680292f0848cdf$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $63680292f0848cdf$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $b9xCt.addHandler)(type, handler);
    (0, $b9xCt.maybeInstrument)(type, $63680292f0848cdf$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $63680292f0848cdf$export$c67d533bf77cbf54() {
    if (!(0, $lATnS.WINDOW).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $a2WQ6.timestampInSeconds)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $5hnoa.isString)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $63680292f0848cdf$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$63680292f0848cdf$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$63680292f0848cdf$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $a2WQ6.timestampInSeconds)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $b9xCt.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$63680292f0848cdf$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $5hnoa.isString)(header) && (0, $5hnoa.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$63680292f0848cdf$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $a2WQ6.timestampInSeconds)() * 1000,
                xhr: sendThisArg
            };
            (0, $b9xCt.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $63680292f0848cdf$var$parseXhrUrlArg(url) {
    if ((0, $5hnoa.isString)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}

});
parcelRegister("lATnS", function(module, exports) {
$parcel$export(module.exports, "WINDOW", () => $fb87ebe1fc5e813d$export$56d8a8a25bd48b81);

var $gflYe = parcelRequire("gflYe");
const $fb87ebe1fc5e813d$export$56d8a8a25bd48b81 = (0, $gflYe.GLOBAL_OBJ);

});



parcelRegister("4pCtk", function(module, exports) {
$parcel$export(module.exports, "init", () => $336756f68c9ea87a$export$2cd8252107eb640b);

var $1xV5I = parcelRequire("1xV5I");
var $i38Fr = parcelRequire("i38Fr");

var $24Re2 = parcelRequire("24Re2");

var $1v5pe = parcelRequire("1v5pe");
/**
 * Inits the React SDK
 */ function $336756f68c9ea87a$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $24Re2.applySdkMetadata)(opts, 'react');
    (0, $i38Fr.setContext)('react', {
        version: $1v5pe.version
    });
    return (0, $1xV5I.init)(opts);
}

});
parcelRegister("1xV5I", function(module, exports) {
$parcel$export(module.exports, "init", () => $1205289c810481d1$export$2cd8252107eb640b);

var $8XUiG = parcelRequire("8XUiG");
var $2LMnF = parcelRequire("2LMnF");
var $568f3 = parcelRequire("568f3");
var $fKqf9 = parcelRequire("fKqf9");
var $5Q5jK = parcelRequire("5Q5jK");
var $9QP64 = parcelRequire("9QP64");

var $4JkzE = parcelRequire("4JkzE");

var $1Nf5L = parcelRequire("1Nf5L");

var $eqEgC = parcelRequire("eqEgC");

var $fhvVd = parcelRequire("fhvVd");

var $ftZY9 = parcelRequire("ftZY9");

var $8ioiY = parcelRequire("8ioiY");

var $2hDZ1 = parcelRequire("2hDZ1");

var $1XvQL = parcelRequire("1XvQL");

var $6fKHd = parcelRequire("6fKHd");

var $k3ocW = parcelRequire("k3ocW");
/** Get the default integrations for the browser SDK. */ function $1205289c810481d1$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v10): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $fKqf9.inboundFiltersIntegration)(),
        (0, $2LMnF.functionToStringIntegration)(),
        (0, $eqEgC.browserApiErrorsIntegration)(),
        (0, $1Nf5L.breadcrumbsIntegration)(),
        (0, $ftZY9.globalHandlersIntegration)(),
        (0, $2hDZ1.linkedErrorsIntegration)(),
        (0, $8XUiG.dedupeIntegration)(),
        (0, $8ioiY.httpContextIntegration)(),
        (0, $fhvVd.browserSessionIntegration)()
    ];
}
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $1205289c810481d1$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $k3ocW.checkAndWarnIfIsEmbeddedBrowserExtension)();
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $9QP64.stackParserFromStackParserOptions)(options.stackParser || (0, $1XvQL.defaultStackParser)),
        integrations: (0, $568f3.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: options.defaultIntegrations == null ? $1205289c810481d1$export$5783b2920b1d62b9() : options.defaultIntegrations
        }),
        transport: options.transport || (0, $6fKHd.makeFetchTransport)
    };
    return (0, $5Q5jK.initAndBind)((0, $4JkzE.BrowserClient), clientOptions);
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $1205289c810481d1$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $1205289c810481d1$export$4e4d8b287d028b6b(callback) {
    callback();
}

});
parcelRegister("8XUiG", function(module, exports) {
$parcel$export(module.exports, "dedupeIntegration", () => $686f8183337ccc90$export$6d39aa44cd0c7567);

var $dYTLo = parcelRequire("dYTLo");

var $568f3 = parcelRequire("568f3");

var $aieBB = parcelRequire("aieBB");

var $9QP64 = parcelRequire("9QP64");
const $686f8183337ccc90$var$INTEGRATION_NAME = 'Dedupe';
const $686f8183337ccc90$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $686f8183337ccc90$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($686f8183337ccc90$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $686f8183337ccc90$export$6d39aa44cd0c7567 = (0, $568f3.defineIntegration)($686f8183337ccc90$var$_dedupeIntegration);
/** only exported for tests. */ function $686f8183337ccc90$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($686f8183337ccc90$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($686f8183337ccc90$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $686f8183337ccc90$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$686f8183337ccc90$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$686f8183337ccc90$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $686f8183337ccc90$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $686f8183337ccc90$var$_getExceptionFromEvent(previousEvent);
    const currentException = $686f8183337ccc90$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$686f8183337ccc90$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$686f8183337ccc90$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $686f8183337ccc90$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $9QP64.getFramesFromEvent)(currentEvent);
    let previousFrames = (0, $9QP64.getFramesFromEvent)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $686f8183337ccc90$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $686f8183337ccc90$var$_getExceptionFromEvent(event) {
    return event.exception?.values && event.exception.values[0];
}

});

parcelRegister("2LMnF", function(module, exports) {
$parcel$export(module.exports, "functionToStringIntegration", () => $20457ff9fb694faa$export$7918117e9202e4fb);

var $9zTQv = parcelRequire("9zTQv");

var $568f3 = parcelRequire("568f3");

var $2bu2L = parcelRequire("2bu2L");
let $20457ff9fb694faa$var$originalFunctionToString;
const $20457ff9fb694faa$var$INTEGRATION_NAME = 'FunctionToString';
const $20457ff9fb694faa$var$SETUP_CLIENTS = new WeakMap();
const $20457ff9fb694faa$var$_functionToStringIntegration = ()=>{
    return {
        name: $20457ff9fb694faa$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $20457ff9fb694faa$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $2bu2L.getOriginalFunction)(this);
                    const context = $20457ff9fb694faa$var$SETUP_CLIENTS.has((0, $9zTQv.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $20457ff9fb694faa$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $20457ff9fb694faa$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $20457ff9fb694faa$export$7918117e9202e4fb = (0, $568f3.defineIntegration)($20457ff9fb694faa$var$_functionToStringIntegration);

});

parcelRegister("fKqf9", function(module, exports) {
$parcel$export(module.exports, "inboundFiltersIntegration", () => $b76f824353ff652c$export$cb3c5c2ceb9818ba);

var $dYTLo = parcelRequire("dYTLo");

var $568f3 = parcelRequire("568f3");

var $ewOPj = parcelRequire("ewOPj");

var $aieBB = parcelRequire("aieBB");

var $84KxT = parcelRequire("84KxT");

var $j5FsG = parcelRequire("j5FsG");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $b76f824353ff652c$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $b76f824353ff652c$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $b76f824353ff652c$export$9a84f518c163c552 = (0, $568f3.defineIntegration)((options = {})=>{
    let mergedOptions;
    return {
        name: $b76f824353ff652c$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $b76f824353ff652c$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $b76f824353ff652c$var$_mergeOptions(options, clientOptions);
            }
            return $b76f824353ff652c$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $b76f824353ff652c$export$cb3c5c2ceb9818ba = (0, $568f3.defineIntegration)((options = {})=>{
    return {
        ...$b76f824353ff652c$export$9a84f518c163c552(options),
        name: 'InboundFilters'
    };
});
function $b76f824353ff652c$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $b76f824353ff652c$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $b76f824353ff652c$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($b76f824353ff652c$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $84KxT.getEventDescription)(event)}`);
            return true;
        }
        if ($b76f824353ff652c$var$_isUselessError(event)) {
            (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $84KxT.getEventDescription)(event)}`);
            return true;
        }
        if ($b76f824353ff652c$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $84KxT.getEventDescription)(event)}.\nUrl: ${$b76f824353ff652c$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$b76f824353ff652c$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $84KxT.getEventDescription)(event)}.\nUrl: ${$b76f824353ff652c$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($b76f824353ff652c$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $84KxT.getEventDescription)(event)}`);
            return true;
        }
    }
    return false;
}
function $b76f824353ff652c$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $ewOPj.getPossibleEventMessages)(event).some((message)=>(0, $j5FsG.stringMatchesSomePattern)(message, ignoreErrors));
}
function $b76f824353ff652c$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $j5FsG.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $b76f824353ff652c$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $b76f824353ff652c$var$_getEventFilterUrl(event);
    return !url ? false : (0, $j5FsG.stringMatchesSomePattern)(url, denyUrls);
}
function $b76f824353ff652c$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $b76f824353ff652c$var$_getEventFilterUrl(event);
    return !url ? true : (0, $j5FsG.stringMatchesSomePattern)(url, allowUrls);
}
function $b76f824353ff652c$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $b76f824353ff652c$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $b76f824353ff652c$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).error(`Cannot extract url for event ${(0, $84KxT.getEventDescription)(event)}`);
        return null;
    }
}
function $b76f824353ff652c$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}

});
parcelRegister("ewOPj", function(module, exports) {
$parcel$export(module.exports, "getPossibleEventMessages", () => $a93b7af6f24eabcc$export$d55a97c329cacfcc);
/**
 * Get a list of possible event messages from a Sentry event.
 */ function $a93b7af6f24eabcc$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch (e) {
    // ignore errors here
    }
    return possibleMessages;
}

});


parcelRegister("5Q5jK", function(module, exports) {
$parcel$export(module.exports, "initAndBind", () => $4405ef04fbd2141e$export$5333c3f1c58d9bc1);

var $9zTQv = parcelRequire("9zTQv");

var $dYTLo = parcelRequire("dYTLo");

var $aieBB = parcelRequire("aieBB");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $4405ef04fbd2141e$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $dYTLo.DEBUG_BUILD) (0, $aieBB.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $aieBB.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $9zTQv.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $4405ef04fbd2141e$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $4405ef04fbd2141e$export$ecb76f41d43c0e43(client) {
    (0, $9zTQv.getCurrentScope)().setClient(client);
}

});

parcelRegister("4JkzE", function(module, exports) {
$parcel$export(module.exports, "BrowserClient", () => $371b52f0660682b0$export$1df9218a526d318d);

var $9PC3T = parcelRequire("9PC3T");
var $jOgZk = parcelRequire("jOgZk");
var $24Re2 = parcelRequire("24Re2");
var $23BMG = parcelRequire("23BMG");
var $s8ZK9 = parcelRequire("s8ZK9");

var $eLy2b = parcelRequire("eLy2b");

var $2NPnx = parcelRequire("2NPnx");
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ const $371b52f0660682b0$var$DEFAULT_FLUSH_INTERVAL = 5000;
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $371b52f0660682b0$export$1df9218a526d318d extends (0, $23BMG.Client) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $371b52f0660682b0$export$4e107b20a7f977(options);
        const sdkSource = (0, $2NPnx.WINDOW).SENTRY_SDK_SOURCE || (0, $s8ZK9.getSDKSource)();
        (0, $24Re2.applySdkMetadata)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        const { sendDefaultPii: sendDefaultPii, sendClientReports: sendClientReports, _experiments: _experiments } = this._options;
        const enableLogs = _experiments?.enableLogs;
        if ((0, $2NPnx.WINDOW).document && (sendClientReports || enableLogs)) (0, $2NPnx.WINDOW).document.addEventListener('visibilitychange', ()=>{
            if ((0, $2NPnx.WINDOW).document.visibilityState === 'hidden') {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $9PC3T._INTERNAL_flushLogsBuffer)(this);
            }
        });
        if (enableLogs) {
            this.on('flush', ()=>{
                (0, $9PC3T._INTERNAL_flushLogsBuffer)(this);
            });
            this.on('afterCaptureLog', ()=>{
                if (this._logFlushIdleTimeout) clearTimeout(this._logFlushIdleTimeout);
                this._logFlushIdleTimeout = setTimeout(()=>{
                    (0, $9PC3T._INTERNAL_flushLogsBuffer)(this);
                }, $371b52f0660682b0$var$DEFAULT_FLUSH_INTERVAL);
            });
        }
        if (sendDefaultPii) {
            this.on('postprocessEvent', (0, $jOgZk.addAutoIpAddressToUser));
            this.on('beforeSendSession', (0, $jOgZk.addAutoIpAddressToSession));
        }
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $eLy2b.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $eLy2b.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
/** Exported only for tests. */ function $371b52f0660682b0$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $2NPnx.WINDOW).SENTRY_RELEASE?.id,
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}

});
parcelRegister("9PC3T", function(module, exports) {
$parcel$export(module.exports, "_INTERNAL_flushLogsBuffer", () => $728666c736b03021$export$f8ed83d3b6a0b504);

var $23BMG = parcelRequire("23BMG");

var $9zTQv = parcelRequire("9zTQv");

var $dYTLo = parcelRequire("dYTLo");

var $hvPI9 = parcelRequire("hvPI9");

var $kh78x = parcelRequire("kh78x");

var $5hnoa = parcelRequire("5hnoa");

var $aieBB = parcelRequire("aieBB");

var $a2WQ6 = parcelRequire("a2WQ6");

var $gflYe = parcelRequire("gflYe");

var $7d4dT = parcelRequire("7d4dT");

var $377Lw = parcelRequire("377Lw");
const $728666c736b03021$var$MAX_LOG_BUFFER_SIZE = 100;
// The reference to the Client <> LogBuffer map is stored to ensure it's always the same
(0, $gflYe.GLOBAL_OBJ)._sentryClientToLogBufferMap = new WeakMap();
/**
 * Converts a log attribute to a serialized log attribute.
 *
 * @param key - The key of the log attribute.
 * @param value - The value of the log attribute.
 * @returns The serialized log attribute.
 */ function $728666c736b03021$export$84cb46f4adfc5d14(value) {
    switch(typeof value){
        case 'number':
            if (Number.isInteger(value)) return {
                value: value,
                type: 'integer'
            };
            return {
                value: value,
                type: 'double'
            };
        case 'boolean':
            return {
                value: value,
                type: 'boolean'
            };
        case 'string':
            return {
                value: value,
                type: 'string'
            };
        default:
            {
                let stringValue = '';
                try {
                    stringValue = JSON.stringify(value) ?? '';
                } catch  {
                // Do nothing
                }
                return {
                    value: stringValue,
                    type: 'string'
                };
            }
    }
}
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $728666c736b03021$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $728666c736b03021$export$743ba6f7ec19225f(client, serializedLog) {
    const logBuffer = $728666c736b03021$export$5365c9902fb9e770(client);
    if (logBuffer === undefined) (0, $gflYe.GLOBAL_OBJ)._sentryClientToLogBufferMap?.set(client, [
        serializedLog
    ]);
    else {
        (0, $gflYe.GLOBAL_OBJ)._sentryClientToLogBufferMap?.set(client, [
            ...logBuffer,
            serializedLog
        ]);
        if (logBuffer.length >= $728666c736b03021$var$MAX_LOG_BUFFER_SIZE) $728666c736b03021$export$f8ed83d3b6a0b504(client, logBuffer);
    }
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $728666c736b03021$export$3ab3d16b9eebd986(beforeLog, client = (0, $9zTQv.getClient)(), currentScope = (0, $9zTQv.getCurrentScope)(), captureSerializedLog = $728666c736b03021$export$743ba6f7ec19225f) {
    if (!client) {
        (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn('No client available to capture log.');
        return;
    }
    const { _experiments: _experiments, release: release, environment: environment } = client.getOptions();
    const { enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = _experiments ?? {};
    if (!enableLogs) {
        (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn('logging option not enabled, log will not be captured.');
        return;
    }
    const [, traceContext] = (0, $23BMG._getTraceInfoFromScope)(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: user } = $728666c736b03021$var$getMergedScopeData(currentScope);
    // Only attach user to log attributes if sendDefaultPii is enabled
    if (client.getOptions().sendDefaultPii) {
        const { id: id, email: email, username: username } = user;
        $728666c736b03021$var$setLogAttribute(processedLogAttributes, 'user.id', id, false);
        $728666c736b03021$var$setLogAttribute(processedLogAttributes, 'user.email', email, false);
        $728666c736b03021$var$setLogAttribute(processedLogAttributes, 'user.name', username, false);
    }
    $728666c736b03021$var$setLogAttribute(processedLogAttributes, 'sentry.release', release);
    $728666c736b03021$var$setLogAttribute(processedLogAttributes, 'sentry.environment', environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $728666c736b03021$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.name', name);
    $728666c736b03021$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.version', version);
    const beforeLogMessage = beforeLog.message;
    if ((0, $5hnoa.isParameterizedString)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $kh78x._getSpanForScope)(currentScope);
    // Add the parent span ID to the log attributes for trace context
    $728666c736b03021$var$setLogAttribute(processedLogAttributes, 'sentry.trace.parent_span_id', span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit('beforeCaptureLog', processedLog);
    const log = beforeSendLog ? beforeSendLog(processedLog) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: attributes = {}, severityNumber: severityNumber } = log;
    const serializedLog = {
        timestamp: (0, $a2WQ6.timestampInSeconds)(),
        level: level,
        body: message,
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? (0, $7d4dT.SEVERITY_TEXT_TO_SEVERITY_NUMBER)[level],
        attributes: Object.keys(attributes).reduce((acc, key)=>{
            acc[key] = $728666c736b03021$export$84cb46f4adfc5d14(attributes[key]);
            return acc;
        }, {})
    };
    captureSerializedLog(client, serializedLog);
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $728666c736b03021$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $728666c736b03021$export$5365c9902fb9e770(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $377Lw.createLogEnvelope)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    (0, $gflYe.GLOBAL_OBJ)._sentryClientToLogBufferMap?.set(client, []);
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function $728666c736b03021$export$5365c9902fb9e770(client) {
    return (0, $gflYe.GLOBAL_OBJ)._sentryClientToLogBufferMap?.get(client);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function $728666c736b03021$var$getMergedScopeData(currentScope) {
    const scopeData = (0, $9zTQv.getGlobalScope)().getScopeData();
    (0, $hvPI9.mergeScopeData)(scopeData, (0, $9zTQv.getIsolationScope)().getScopeData());
    (0, $hvPI9.mergeScopeData)(scopeData, currentScope.getScopeData());
    return scopeData;
}

});
parcelRegister("23BMG", function(module, exports) {
$parcel$export(module.exports, "Client", () => $17f92bba74dce684$export$1f2bb630327ac4b6);
$parcel$export(module.exports, "_getTraceInfoFromScope", () => $17f92bba74dce684$export$fb7d833b3fdedf5f);

var $fJ5mt = parcelRequire("fJ5mt");

var $6dn1i = parcelRequire("6dn1i");

var $9zTQv = parcelRequire("9zTQv");

var $dYTLo = parcelRequire("dYTLo");

var $crdTc = parcelRequire("crdTc");

var $568f3 = parcelRequire("568f3");

var $4fgW6 = parcelRequire("4fgW6");

var $9r8JS = parcelRequire("9r8JS");

var $ewOPj = parcelRequire("ewOPj");

var $7t9x6 = parcelRequire("7t9x6");

var $fSgUh = parcelRequire("fSgUh");

var $bxlWC = parcelRequire("bxlWC");

var $4LMHq = parcelRequire("4LMHq");

var $aD71f = parcelRequire("aD71f");

var $62hZr = parcelRequire("62hZr");

var $4jD1U = parcelRequire("4jD1U");

var $2YWrS = parcelRequire("2YWrS");

var $5hnoa = parcelRequire("5hnoa");

var $aieBB = parcelRequire("aieBB");

var $84KxT = parcelRequire("84KxT");

var $lHcvp = parcelRequire("lHcvp");
/* eslint-disable max-lines */ const $17f92bba74dce684$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $17f92bba74dce684$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $17f92bba74dce684$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $17f92bba74dce684$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
function $17f92bba74dce684$var$_makeInternalError(message) {
    return {
        message: message,
        [$17f92bba74dce684$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $17f92bba74dce684$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$17f92bba74dce684$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $17f92bba74dce684$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $17f92bba74dce684$var$INTERNAL_ERROR_SYMBOL in error;
}
function $17f92bba74dce684$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $17f92bba74dce684$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $17f92bba74dce684$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $4jD1U.makeDsn)(options.dsn);
        else (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $fJ5mt.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $84KxT.uuid4)();
        // ensure we haven't captured this very object before
        if ((0, $84KxT.checkOrSetAlreadyCaught)(exception)) {
            (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).log($17f92bba74dce684$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $84KxT.uuid4)(),
            ...hint
        };
        const eventMessage = (0, $5hnoa.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $5hnoa.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $84KxT.uuid4)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $84KxT.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).log($17f92bba74dce684$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $4fgW6.updateSession)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $lHcvp.resolvedSyncPromise)(true);
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $568f3.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $568f3.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $crdTc.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $2YWrS.addItemToEnvelope)(env, (0, $2YWrS.createAttachmentEnvelopeItem)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $6dn1i.DEFAULT_ENVIRONMENT) } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn($17f92bba74dce684$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn($17f92bba74dce684$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = (0, $crdTc.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).error('Transport disabled');
        return (0, $lHcvp.resolvedSyncPromise)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $568f3.setupIntegrations)(this, integrations);
        (0, $568f3.afterSetupIntegrations)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism?.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $4fgW6.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $lHcvp.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $bxlWC.prepareEvent)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = {
                trace: (0, $9zTQv.getTraceContextFromScope)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $9r8JS.getDynamicSamplingContextFromScope)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $9zTQv.getCurrentScope)(), isolationScope = (0, $9zTQv.getIsolationScope)()) {
        if ((0, $dYTLo.DEBUG_BUILD) && $17f92bba74dce684$var$isErrorEvent(event)) (0, $aieBB.logger).log(`Captured error event \`${(0, $ewOPj.getPossibleEventMessages)(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $dYTLo.DEBUG_BUILD) {
                if ($17f92bba74dce684$var$_isDoNotSendEventError(reason)) (0, $aieBB.logger).log(reason.message);
                else if ($17f92bba74dce684$var$_isInternalError(reason)) (0, $aieBB.logger).warn(reason.message);
                else (0, $aieBB.logger).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $17f92bba74dce684$var$isTransactionEvent(event);
        const isError = $17f92bba74dce684$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $fSgUh.parseSampleRate)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return (0, $lHcvp.rejectedSyncPromise)($17f92bba74dce684$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $17f92bba74dce684$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $17f92bba74dce684$var$processBeforeSend(this, options, prepared, hint);
            return $17f92bba74dce684$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $17f92bba74dce684$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($17f92bba74dce684$var$_isDoNotSendEventError(reason) || $17f92bba74dce684$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $17f92bba74dce684$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $62hZr.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $4jD1U.dsnToString)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
const $17f92bba74dce684$export$4f22f74eddb7716a = $17f92bba74dce684$export$1f2bb630327ac4b6;
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $17f92bba74dce684$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $5hnoa.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $5hnoa.isPlainObject)(event) && event !== null) throw $17f92bba74dce684$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $17f92bba74dce684$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $5hnoa.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw $17f92bba74dce684$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $17f92bba74dce684$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    let processedEvent = event;
    if ($17f92bba74dce684$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($17f92bba74dce684$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan) {
            // process root span
            const processedRootSpanJson = beforeSendSpan((0, $aD71f.convertTransactionEventToSpanJson)(processedEvent));
            if (!processedRootSpanJson) (0, $4LMHq.showSpanDropWarning)();
            else // update event with processed root span values
            processedEvent = (0, $7t9x6.merge)(event, (0, $aD71f.convertSpanJsonToTransactionEvent)(processedRootSpanJson));
            // process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                for (const span of processedEvent.spans){
                    const processedSpan = beforeSendSpan(span);
                    if (!processedSpan) {
                        (0, $4LMHq.showSpanDropWarning)();
                        processedSpans.push(span);
                    } else processedSpans.push(processedSpan);
                }
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $17f92bba74dce684$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $17f92bba74dce684$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** Extract trace information from scope */ function $17f92bba74dce684$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return (0, $9zTQv.withScope)(scope, ()=>{
        const span = (0, $4LMHq.getActiveSpan)();
        const traceContext = span ? (0, $4LMHq.spanToTraceContext)(span) : (0, $9zTQv.getTraceContextFromScope)(scope);
        const dynamicSamplingContext = span ? (0, $9r8JS.getDynamicSamplingContextFromSpan)(span) : (0, $9r8JS.getDynamicSamplingContextFromScope)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}

});
parcelRegister("crdTc", function(module, exports) {
$parcel$export(module.exports, "createSessionEnvelope", () => $90e2c7c457ad5982$export$124b03c077baa2f3);
$parcel$export(module.exports, "createEventEnvelope", () => $90e2c7c457ad5982$export$c31057337a18010f);

var $9r8JS = parcelRequire("9r8JS");

var $4LMHq = parcelRequire("4LMHq");

var $4jD1U = parcelRequire("4jD1U");

var $2YWrS = parcelRequire("2YWrS");


/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $90e2c7c457ad5982$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $90e2c7c457ad5982$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $2YWrS.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $4jD1U.dsnToString)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $2YWrS.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $90e2c7c457ad5982$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $2YWrS.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $90e2c7c457ad5982$var$enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = (0, $2YWrS.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $2YWrS.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $90e2c7c457ad5982$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $9r8JS.getDynamicSamplingContextFromSpan)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $4jD1U.dsnToString)(dsn)
        }
    };
    const beforeSendSpan = client?.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $4LMHq.spanToJSON)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $4LMHq.showSpanDropWarning)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $4LMHq.spanToJSON);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $2YWrS.createSpanEnvelopeItem)(spanJson));
    }
    return (0, $2YWrS.createEnvelope)(headers, items);
}

});
parcelRegister("2YWrS", function(module, exports) {
$parcel$export(module.exports, "createEnvelope", () => $22be860e1f36b348$export$f93f7f385160c44e);
$parcel$export(module.exports, "addItemToEnvelope", () => $22be860e1f36b348$export$d650323442802f6f);
$parcel$export(module.exports, "forEachEnvelopeItem", () => $22be860e1f36b348$export$c56c55acf0136fd3);
$parcel$export(module.exports, "serializeEnvelope", () => $22be860e1f36b348$export$32f9b428425aac85);
$parcel$export(module.exports, "createSpanEnvelopeItem", () => $22be860e1f36b348$export$655cf139bc8b8afd);
$parcel$export(module.exports, "createAttachmentEnvelopeItem", () => $22be860e1f36b348$export$d8fc80952cc31fa4);
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", () => $22be860e1f36b348$export$b11169581eeaf237);
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", () => $22be860e1f36b348$export$d369f3b2758f6743);
$parcel$export(module.exports, "createEventEnvelopeHeaders", () => $22be860e1f36b348$export$92b6093782fe661b);

var $k8rSc = parcelRequire("k8rSc");

var $4jD1U = parcelRequire("4jD1U");

var $366rg = parcelRequire("366rg");

var $gflYe = parcelRequire("gflYe");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $22be860e1f36b348$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $22be860e1f36b348$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $22be860e1f36b348$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $22be860e1f36b348$export$604a45d95a155e2b(envelope, types) {
    return $22be860e1f36b348$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $22be860e1f36b348$var$encodeUTF8(input) {
    const carrier = (0, $k8rSc.getSentryCarrier)((0, $gflYe.GLOBAL_OBJ));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $22be860e1f36b348$var$decodeUTF8(input) {
    const carrier = (0, $k8rSc.getSentryCarrier)((0, $gflYe.GLOBAL_OBJ));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $22be860e1f36b348$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $22be860e1f36b348$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $22be860e1f36b348$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $366rg.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $22be860e1f36b348$var$concatBuffers(parts);
}
function $22be860e1f36b348$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $22be860e1f36b348$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $22be860e1f36b348$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($22be860e1f36b348$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $22be860e1f36b348$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $22be860e1f36b348$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $22be860e1f36b348$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $22be860e1f36b348$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    log: 'log_item'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $22be860e1f36b348$export$b11169581eeaf237(type) {
    return $22be860e1f36b348$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $22be860e1f36b348$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $22be860e1f36b348$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $4jD1U.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}

});


parcelRegister("aD71f", function(module, exports) {
$parcel$export(module.exports, "convertTransactionEventToSpanJson", () => $7bd2fdc30124db31$export$d9c6b2464b0a687e);
$parcel$export(module.exports, "convertSpanJsonToTransactionEvent", () => $7bd2fdc30124db31$export$f2d8fce5ae150e92);

var $gJuxI = parcelRequire("gJuxI");
/**
 * Converts a transaction event to a span JSON object.
 */ function $7bd2fdc30124db31$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? '',
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? '',
        origin: origin,
        profile_id: data?.[0, $gJuxI.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[0, $gJuxI.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $7bd2fdc30124db31$export$f2d8fce5ae150e92(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $gJuxI.SEMANTIC_ATTRIBUTE_PROFILE_ID)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $gJuxI.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}

});

parcelRegister("62hZr", function(module, exports) {
$parcel$export(module.exports, "createClientReportEnvelope", () => $4650e26573e42442$export$f3b9ed77c03eeb00);

var $2YWrS = parcelRequire("2YWrS");

var $a2WQ6 = parcelRequire("a2WQ6");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $4650e26573e42442$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $a2WQ6.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $2YWrS.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});


parcelRegister("7d4dT", function(module, exports) {
$parcel$export(module.exports, "SEVERITY_TEXT_TO_SEVERITY_NUMBER", () => $53fd05ef8da3ef1f$export$4fb50c0840d636d1);
/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $53fd05ef8da3ef1f$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};

});

parcelRegister("377Lw", function(module, exports) {
$parcel$export(module.exports, "createLogEnvelope", () => $24480ca0dbfb6a1c$export$cdcd668e6516443f);

var $4jD1U = parcelRequire("4jD1U");

var $2YWrS = parcelRequire("2YWrS");
/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @returns The created log container envelope item.
 */ function $24480ca0dbfb6a1c$export$efdf3b13edb1118e(items) {
    return [
        {
            type: 'log',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.log+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $24480ca0dbfb6a1c$export$cdcd668e6516443f(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $4jD1U.dsnToString)(dsn);
    return (0, $2YWrS.createEnvelope)(headers, [
        $24480ca0dbfb6a1c$export$efdf3b13edb1118e(logs)
    ]);
}

});


parcelRegister("jOgZk", function(module, exports) {
$parcel$export(module.exports, "addAutoIpAddressToUser", () => $e6bfdd5379a27713$export$3e12ad68afa434ac);
$parcel$export(module.exports, "addAutoIpAddressToSession", () => $e6bfdd5379a27713$export$e8e2d07ba63e2b6c);
// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 */ function $e6bfdd5379a27713$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: '{{auto}}'
    };
}
/**
 * @internal
 */ function $e6bfdd5379a27713$export$e8e2d07ba63e2b6c(session) {
    if ('aggregates' in session) {
        if (session.attrs?.['ip_address'] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: '{{auto}}'
        };
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}

});

parcelRegister("24Re2", function(module, exports) {
$parcel$export(module.exports, "applySdkMetadata", () => $18353df816427939$export$b9f95b027256052c);

var $gQ8Cj = parcelRequire("gQ8Cj");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $18353df816427939$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $gQ8Cj.SDK_VERSION)
            })),
        version: (0, $gQ8Cj.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("s8ZK9", function(module, exports) {
$parcel$export(module.exports, "getSDKSource", () => $054997d4cbef69d8$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $054997d4cbef69d8$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $054997d4cbef69d8$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}

});

parcelRegister("eLy2b", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $abffdaf8fb035481$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $abffdaf8fb035481$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $abffdaf8fb035481$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $abffdaf8fb035481$export$5425b53185d13d6c);

var $84KxT = parcelRequire("84KxT");
var $2bu2L = parcelRequire("2bu2L");
var $9zTQv = parcelRequire("9zTQv");
var $5hnoa = parcelRequire("5hnoa");
var $366rg = parcelRequire("366rg");
var $lHcvp = parcelRequire("lHcvp");
/**
 * This function creates an exception from a JavaScript Error
 */ function $abffdaf8fb035481$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $abffdaf8fb035481$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $abffdaf8fb035481$export$2e9ae379995d99e3(ex),
        value: $abffdaf8fb035481$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $abffdaf8fb035481$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $9zTQv.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $abffdaf8fb035481$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $366rg.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $abffdaf8fb035481$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $5hnoa.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $abffdaf8fb035481$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $abffdaf8fb035481$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $abffdaf8fb035481$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $abffdaf8fb035481$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $abffdaf8fb035481$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $abffdaf8fb035481$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $abffdaf8fb035481$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $abffdaf8fb035481$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $abffdaf8fb035481$var$getSkipFirstStackStringLines(ex) {
    if (ex && $abffdaf8fb035481$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $abffdaf8fb035481$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $abffdaf8fb035481$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $abffdaf8fb035481$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $abffdaf8fb035481$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $abffdaf8fb035481$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($abffdaf8fb035481$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $abffdaf8fb035481$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $abffdaf8fb035481$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $84KxT.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $lHcvp.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $abffdaf8fb035481$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $abffdaf8fb035481$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $lHcvp.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $abffdaf8fb035481$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $5hnoa.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $abffdaf8fb035481$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $5hnoa.isDOMError)(exception) || (0, $5hnoa.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $abffdaf8fb035481$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $5hnoa.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $abffdaf8fb035481$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $84KxT.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $5hnoa.isError)(exception)) // we have a real Error object, do nothing
    return $abffdaf8fb035481$var$eventFromError(stackParser, exception);
    if ((0, $5hnoa.isPlainObject)(exception) || (0, $5hnoa.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $abffdaf8fb035481$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $84KxT.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $abffdaf8fb035481$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $84KxT.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $84KxT.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $abffdaf8fb035481$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $abffdaf8fb035481$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $84KxT.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $5hnoa.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $abffdaf8fb035481$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $2bu2L.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $5hnoa.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $5hnoa.isEvent)(exception)) {
        const className = $abffdaf8fb035481$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $abffdaf8fb035481$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $abffdaf8fb035481$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}

});


parcelRegister("1Nf5L", function(module, exports) {
$parcel$export(module.exports, "breadcrumbsIntegration", () => $14e612feab9fab89$export$c079d904b326663a);

var $fSO6C = parcelRequire("fSO6C");
var $fbw0W = parcelRequire("fbw0W");
var $bkEHm = parcelRequire("bkEHm");
var $568f3 = parcelRequire("568f3");
var $eRp9F = parcelRequire("eRp9F");
var $9zTQv = parcelRequire("9zTQv");
var $68KEs = parcelRequire("68KEs");
var $84KxT = parcelRequire("84KxT");
var $aieBB = parcelRequire("aieBB");
var $i02s1 = parcelRequire("i02s1");
var $j5FsG = parcelRequire("j5FsG");
var $ehlrk = parcelRequire("ehlrk");

var $6ztv6 = parcelRequire("6ztv6");
var $lxHNO = parcelRequire("lxHNO");
var $8x8vX = parcelRequire("8x8vX");

var $d70tI = parcelRequire("d70tI");

var $2NPnx = parcelRequire("2NPnx");
/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $14e612feab9fab89$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $14e612feab9fab89$var$INTEGRATION_NAME = 'Breadcrumbs';
const $14e612feab9fab89$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $14e612feab9fab89$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v10): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $fbw0W.addConsoleInstrumentationHandler)($14e612feab9fab89$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $6ztv6.addClickKeypressInstrumentationHandler)($14e612feab9fab89$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $8x8vX.addXhrInstrumentationHandler)($14e612feab9fab89$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $bkEHm.addFetchInstrumentationHandler)($14e612feab9fab89$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $lxHNO.addHistoryInstrumentationHandler)($14e612feab9fab89$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $14e612feab9fab89$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $14e612feab9fab89$export$c079d904b326663a = (0, $568f3.defineIntegration)($14e612feab9fab89$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $14e612feab9fab89$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $9zTQv.getClient)() !== client) return;
        (0, $fSO6C.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $84KxT.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $14e612feab9fab89$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $9zTQv.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $14e612feab9fab89$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $d70tI.DEBUG_BUILD) && (0, $aieBB.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$14e612feab9fab89$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$14e612feab9fab89$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $14e612feab9fab89$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $14e612feab9fab89$var$_isEvent(event) ? event.target : event;
            target = (0, $68KEs.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $68KEs.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $fSO6C.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $14e612feab9fab89$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $9zTQv.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $ehlrk.severityLevelFromString)(handlerData.level),
            message: (0, $j5FsG.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $j5FsG.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $fSO6C.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $14e612feab9fab89$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $9zTQv.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $8x8vX.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $eRp9F.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $fSO6C.addBreadcrumb)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $14e612feab9fab89$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $9zTQv.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $fSO6C.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response?.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $eRp9F.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $fSO6C.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $14e612feab9fab89$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $9zTQv.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $i02s1.parseUrl)((0, $2NPnx.WINDOW).location.href);
        let parsedFrom = from ? (0, $i02s1.parseUrl)(from) : undefined;
        const parsedTo = (0, $i02s1.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $fSO6C.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $14e612feab9fab89$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("fSO6C", function(module, exports) {
$parcel$export(module.exports, "addBreadcrumb", () => $b902c41e03a375fc$export$efda9a273d7a036d);

var $9zTQv = parcelRequire("9zTQv");

var $aieBB = parcelRequire("aieBB");

var $a2WQ6 = parcelRequire("a2WQ6");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $b902c41e03a375fc$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $b902c41e03a375fc$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $9zTQv.getClient)();
    const isolationScope = (0, $9zTQv.getIsolationScope)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $b902c41e03a375fc$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $a2WQ6.dateTimestampInSeconds)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $aieBB.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}

});

parcelRegister("fbw0W", function(module, exports) {
$parcel$export(module.exports, "addConsoleInstrumentationHandler", () => $b0e0b76bc0109824$export$1d6e0d073f9e6723);

var $aieBB = parcelRequire("aieBB");

var $2bu2L = parcelRequire("2bu2L");

var $gflYe = parcelRequire("gflYe");

var $b9xCt = parcelRequire("b9xCt");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $b0e0b76bc0109824$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $b9xCt.addHandler)(type, handler);
    (0, $b9xCt.maybeInstrument)(type, $b0e0b76bc0109824$var$instrumentConsole);
}
function $b0e0b76bc0109824$var$instrumentConsole() {
    if (!('console' in (0, $gflYe.GLOBAL_OBJ))) return;
    (0, $aieBB.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $gflYe.GLOBAL_OBJ).console)) return;
        (0, $2bu2L.fill)((0, $gflYe.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $aieBB.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $b9xCt.triggerHandlers)('console', handlerData);
                const log = (0, $aieBB.originalConsoleMethods)[level];
                log?.apply((0, $gflYe.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRegister("eRp9F", function(module, exports) {
$parcel$export(module.exports, "getBreadcrumbLogLevelFromHttpStatusCode", () => $ad19872a8514b2ef$export$b8cfcc4175694bcc);
/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $ad19872a8514b2ef$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

});

parcelRegister("i02s1", function(module, exports) {
$parcel$export(module.exports, "parseUrl", () => $d1aa20c764076cd9$export$7a5253c0f62e0150);

var $gJuxI = parcelRequire("gJuxI");
// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $d1aa20c764076cd9$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $d1aa20c764076cd9$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $d1aa20c764076cd9$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    const base = urlBase ?? (isRelative ? $d1aa20c764076cd9$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $d1aa20c764076cd9$export$5339fcdc8e2a427c(url) {
    if ($d1aa20c764076cd9$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function $d1aa20c764076cd9$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? 'GET';
    const route = routeName ? routeName : urlObject ? kind === 'client' ? $d1aa20c764076cd9$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : '/';
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $d1aa20c764076cd9$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $gJuxI.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin,
        [(0, $gJuxI.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url'
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[0, $gJuxI.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
    }
    if (request?.method) attributes[0, $gJuxI.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[0, $gJuxI.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
        }
        if (!$d1aa20c764076cd9$export$e258e13805402ba7(urlObject)) {
            attributes[0, $gJuxI.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        $d1aa20c764076cd9$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $d1aa20c764076cd9$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $d1aa20c764076cd9$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $d1aa20c764076cd9$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

});

parcelRegister("ehlrk", function(module, exports) {
$parcel$export(module.exports, "severityLevelFromString", () => $a65348b5f91d1c40$export$d771ef054122c30a);
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $a65348b5f91d1c40$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}

});

parcelRegister("6ztv6", function(module, exports) {
$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", () => $4c8ce52dd54877d3$export$5aeffd3db2cf9df7);

var $b9xCt = parcelRequire("b9xCt");
var $2bu2L = parcelRequire("2bu2L");
var $84KxT = parcelRequire("84KxT");

var $lATnS = parcelRequire("lATnS");
const $4c8ce52dd54877d3$var$DEBOUNCE_DURATION = 1000;
let $4c8ce52dd54877d3$var$debounceTimerID;
let $4c8ce52dd54877d3$var$lastCapturedEventType;
let $4c8ce52dd54877d3$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4c8ce52dd54877d3$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $b9xCt.addHandler)(type, handler);
    (0, $b9xCt.maybeInstrument)(type, $4c8ce52dd54877d3$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $4c8ce52dd54877d3$export$3014bbf0af0e1d4a() {
    if (!(0, $lATnS.WINDOW).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $b9xCt.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $4c8ce52dd54877d3$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $lATnS.WINDOW).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $lATnS.WINDOW).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $lATnS.WINDOW);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.('addEventListener')) return;
        (0, $2bu2L.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $4c8ce52dd54877d3$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $2bu2L.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $4c8ce52dd54877d3$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $4c8ce52dd54877d3$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $4c8ce52dd54877d3$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $4c8ce52dd54877d3$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $4c8ce52dd54877d3$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $4c8ce52dd54877d3$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($4c8ce52dd54877d3$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $2bu2L.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $2bu2L.addNonEnumerableProperty)(target, '_sentryId', (0, $84KxT.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$4c8ce52dd54877d3$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $4c8ce52dd54877d3$var$lastCapturedEventType = event.type;
            $4c8ce52dd54877d3$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($4c8ce52dd54877d3$var$debounceTimerID);
        $4c8ce52dd54877d3$var$debounceTimerID = (0, $lATnS.WINDOW).setTimeout(()=>{
            $4c8ce52dd54877d3$var$lastCapturedEventTargetId = undefined;
            $4c8ce52dd54877d3$var$lastCapturedEventType = undefined;
        }, $4c8ce52dd54877d3$var$DEBOUNCE_DURATION);
    };
}
function $4c8ce52dd54877d3$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});

parcelRegister("lxHNO", function(module, exports) {
$parcel$export(module.exports, "addHistoryInstrumentationHandler", () => $faeea846eefe0bf4$export$3f18c56c58114e75);

var $b9xCt = parcelRequire("b9xCt");
var $2bu2L = parcelRequire("2bu2L");
var $gmBzB = parcelRequire("gmBzB");

var $lATnS = parcelRequire("lATnS");
let $faeea846eefe0bf4$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $faeea846eefe0bf4$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $b9xCt.addHandler)(type, handler);
    (0, $b9xCt.maybeInstrument)(type, $faeea846eefe0bf4$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $faeea846eefe0bf4$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $lATnS.WINDOW).addEventListener('popstate', ()=>{
        const to = (0, $lATnS.WINDOW).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $faeea846eefe0bf4$var$lastHref;
        $faeea846eefe0bf4$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $b9xCt.triggerHandlers)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $gmBzB.supportsHistory)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                const from = $faeea846eefe0bf4$var$lastHref;
                // Ensure the URL is absolute
                // this can be either a path, then it is relative to the current origin
                // or a full URL of the current origin - other origins are not allowed
                // See: https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#url
                // coerce to string (this is what pushState does)
                const to = $faeea846eefe0bf4$var$getAbsoluteUrl(String(url));
                // keep track of the current URL state, as we always receive only the updated state
                $faeea846eefe0bf4$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $b9xCt.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $2bu2L.fill)((0, $lATnS.WINDOW).history, 'pushState', historyReplacementFunction);
    (0, $2bu2L.fill)((0, $lATnS.WINDOW).history, 'replaceState', historyReplacementFunction);
}
function $faeea846eefe0bf4$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $lATnS.WINDOW).location.origin);
        return url.toString();
    } catch  {
        // fallback, just do nothing
        return urlOrPath;
    }
}

});


parcelRegister("eqEgC", function(module, exports) {
$parcel$export(module.exports, "browserApiErrorsIntegration", () => $a812ba9e384c65f1$export$59bfe9f1c76150e);

var $568f3 = parcelRequire("568f3");
var $2bu2L = parcelRequire("2bu2L");
var $9QP64 = parcelRequire("9QP64");

var $2NPnx = parcelRequire("2NPnx");
const $a812ba9e384c65f1$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $a812ba9e384c65f1$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $a812ba9e384c65f1$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $a812ba9e384c65f1$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $2bu2L.fill)((0, $2NPnx.WINDOW), 'setTimeout', $a812ba9e384c65f1$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $2bu2L.fill)((0, $2NPnx.WINDOW), 'setInterval', $a812ba9e384c65f1$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $2bu2L.fill)((0, $2NPnx.WINDOW), 'requestAnimationFrame', $a812ba9e384c65f1$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $2NPnx.WINDOW)) (0, $2bu2L.fill)(XMLHttpRequest.prototype, 'send', $a812ba9e384c65f1$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $a812ba9e384c65f1$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$a812ba9e384c65f1$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $a812ba9e384c65f1$export$59bfe9f1c76150e = (0, $568f3.defineIntegration)($a812ba9e384c65f1$var$_browserApiErrorsIntegration);
function $a812ba9e384c65f1$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $2NPnx.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $9QP64.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
function $a812ba9e384c65f1$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $2NPnx.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $9QP64.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $a812ba9e384c65f1$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $2bu2L.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $9QP64.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $2bu2L.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $9QP64.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $2NPnx.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $a812ba9e384c65f1$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $2NPnx.WINDOW);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.('addEventListener')) return;
    (0, $2bu2L.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($a812ba9e384c65f1$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $2NPnx.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $9QP64.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            if (integrationOptions.unregisterOriginalCallbacks) $a812ba9e384c65f1$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $2NPnx.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $9QP64.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $2bu2L.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $a812ba9e384c65f1$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}
function $a812ba9e384c65f1$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === 'object' && 'removeEventListener' in target && typeof target.removeEventListener === 'function') target.removeEventListener(eventName, fn);
}

});

parcelRegister("fhvVd", function(module, exports) {
$parcel$export(module.exports, "browserSessionIntegration", () => $b201348f4a24b21f$export$1baa7880e357371c);

var $i38Fr = parcelRequire("i38Fr");
var $568f3 = parcelRequire("568f3");
var $aieBB = parcelRequire("aieBB");

var $lxHNO = parcelRequire("lxHNO");

var $d70tI = parcelRequire("d70tI");

var $2NPnx = parcelRequire("2NPnx");
/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $b201348f4a24b21f$export$1baa7880e357371c = (0, $568f3.defineIntegration)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $2NPnx.WINDOW).document === 'undefined') {
                (0, $d70tI.DEBUG_BUILD) && (0, $aieBB.logger).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $i38Fr.startSession)({
                ignoreDuration: true
            });
            (0, $i38Fr.captureSession)();
            // We want to create a session for every navigation as well
            (0, $lxHNO.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $i38Fr.startSession)({
                        ignoreDuration: true
                    });
                    (0, $i38Fr.captureSession)();
                }
            });
        }
    };
});

});

parcelRegister("ftZY9", function(module, exports) {
$parcel$export(module.exports, "globalHandlersIntegration", () => $b459a2388533521e$export$66acc70e8cf2b71a);

var $jfzEt = parcelRequire("jfzEt");
var $9Gtyb = parcelRequire("9Gtyb");
var $i38Fr = parcelRequire("i38Fr");
var $568f3 = parcelRequire("568f3");
var $9zTQv = parcelRequire("9zTQv");
var $68KEs = parcelRequire("68KEs");
var $5hnoa = parcelRequire("5hnoa");
var $aieBB = parcelRequire("aieBB");
var $9QP64 = parcelRequire("9QP64");

var $d70tI = parcelRequire("d70tI");

var $eLy2b = parcelRequire("eLy2b");

var $2NPnx = parcelRequire("2NPnx");
const $b459a2388533521e$var$INTEGRATION_NAME = 'GlobalHandlers';
const $b459a2388533521e$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $b459a2388533521e$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $b459a2388533521e$var$_installGlobalOnErrorHandler(client);
                $b459a2388533521e$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $b459a2388533521e$var$_installGlobalOnUnhandledRejectionHandler(client);
                $b459a2388533521e$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $b459a2388533521e$export$66acc70e8cf2b71a = (0, $568f3.defineIntegration)($b459a2388533521e$var$_globalHandlersIntegration);
function $b459a2388533521e$var$_installGlobalOnErrorHandler(client) {
    (0, $jfzEt.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $b459a2388533521e$var$getOptions();
        if ((0, $9zTQv.getClient)() !== client || (0, $2NPnx.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $b459a2388533521e$var$_enhanceEventWithInitialFrame((0, $eLy2b.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $i38Fr.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $b459a2388533521e$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $9Gtyb.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $b459a2388533521e$var$getOptions();
        if ((0, $9zTQv.getClient)() !== client || (0, $2NPnx.shouldIgnoreOnError)()) return;
        const error = $b459a2388533521e$var$_getUnhandledRejectionError(e);
        const event = (0, $5hnoa.isPrimitive)(error) ? $b459a2388533521e$var$_eventFromRejectionWithPrimitive(error) : (0, $eLy2b.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $i38Fr.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $b459a2388533521e$var$_getUnhandledRejectionError(error) {
    if ((0, $5hnoa.isPrimitive)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $b459a2388533521e$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $b459a2388533521e$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $5hnoa.isString)(url) && url.length > 0 ? url : (0, $68KEs.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $9QP64.UNKNOWN_FUNCTION),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $b459a2388533521e$var$globalHandlerLog(type) {
    (0, $d70tI.DEBUG_BUILD) && (0, $aieBB.logger).log(`Global Handler attached: ${type}`);
}
function $b459a2388533521e$var$getOptions() {
    const client = (0, $9zTQv.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});
parcelRegister("jfzEt", function(module, exports) {
$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", () => $e03b12ba5c3f4dac$export$55b5c3ba2194f0c6);

var $gflYe = parcelRequire("gflYe");

var $b9xCt = parcelRequire("b9xCt");
let $e03b12ba5c3f4dac$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $e03b12ba5c3f4dac$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $b9xCt.addHandler)(type, handler);
    (0, $b9xCt.maybeInstrument)(type, $e03b12ba5c3f4dac$var$instrumentError);
}
function $e03b12ba5c3f4dac$var$instrumentError() {
    $e03b12ba5c3f4dac$var$_oldOnErrorHandler = (0, $gflYe.GLOBAL_OBJ).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $gflYe.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $b9xCt.triggerHandlers)('error', handlerData);
        if ($e03b12ba5c3f4dac$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $e03b12ba5c3f4dac$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $gflYe.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("9Gtyb", function(module, exports) {
$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", () => $70cef566e29f615f$export$8bf4fc6858821a4e);

var $gflYe = parcelRequire("gflYe");

var $b9xCt = parcelRequire("b9xCt");
let $70cef566e29f615f$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $70cef566e29f615f$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $b9xCt.addHandler)(type, handler);
    (0, $b9xCt.maybeInstrument)(type, $70cef566e29f615f$var$instrumentUnhandledRejection);
}
function $70cef566e29f615f$var$instrumentUnhandledRejection() {
    $70cef566e29f615f$var$_oldOnUnhandledRejectionHandler = (0, $gflYe.GLOBAL_OBJ).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $gflYe.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $b9xCt.triggerHandlers)('unhandledrejection', handlerData);
        if ($70cef566e29f615f$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $70cef566e29f615f$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $gflYe.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});


parcelRegister("8ioiY", function(module, exports) {
$parcel$export(module.exports, "httpContextIntegration", () => $60a2dba93f0e0a16$export$1378794447170364);

var $568f3 = parcelRequire("568f3");

var $2NPnx = parcelRequire("2NPnx");
/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $60a2dba93f0e0a16$export$1378794447170364 = (0, $568f3.defineIntegration)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $2NPnx.WINDOW).navigator && !(0, $2NPnx.WINDOW).location && !(0, $2NPnx.WINDOW).document) return;
            const reqData = (0, $2NPnx.getHttpRequestData)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        }
    };
});

});

parcelRegister("2hDZ1", function(module, exports) {
$parcel$export(module.exports, "linkedErrorsIntegration", () => $1a9c2f28c7847ad7$export$ebabb00eb7f3a395);

var $jnCDI = parcelRequire("jnCDI");
var $568f3 = parcelRequire("568f3");

var $eLy2b = parcelRequire("eLy2b");
const $1a9c2f28c7847ad7$var$DEFAULT_KEY = 'cause';
const $1a9c2f28c7847ad7$var$DEFAULT_LIMIT = 5;
const $1a9c2f28c7847ad7$var$INTEGRATION_NAME = 'LinkedErrors';
const $1a9c2f28c7847ad7$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $1a9c2f28c7847ad7$var$DEFAULT_LIMIT;
    const key = options.key || $1a9c2f28c7847ad7$var$DEFAULT_KEY;
    return {
        name: $1a9c2f28c7847ad7$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $jnCDI.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $eLy2b.exceptionFromError), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $1a9c2f28c7847ad7$export$ebabb00eb7f3a395 = (0, $568f3.defineIntegration)($1a9c2f28c7847ad7$var$_linkedErrorsIntegration);

});
parcelRegister("jnCDI", function(module, exports) {
$parcel$export(module.exports, "applyAggregateErrorsToEvent", () => $e1be234cbef2f302$export$b91c38ed7d8ae9b2);

var $5hnoa = parcelRequire("5hnoa");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $e1be234cbef2f302$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $5hnoa.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $e1be234cbef2f302$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $e1be234cbef2f302$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $5hnoa.isInstanceOf)(error[key], Error)) {
        $e1be234cbef2f302$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $e1be234cbef2f302$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $e1be234cbef2f302$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $5hnoa.isInstanceOf)(childError, Error)) {
            $e1be234cbef2f302$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $e1be234cbef2f302$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $e1be234cbef2f302$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $e1be234cbef2f302$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $e1be234cbef2f302$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}

});


parcelRegister("1XvQL", function(module, exports) {
$parcel$export(module.exports, "defaultStackParser", () => $16d401e0ccd060ed$export$2b2b997d81bf3907);

var $9QP64 = parcelRequire("9QP64");
const $16d401e0ccd060ed$var$OPERA10_PRIORITY = 10;
const $16d401e0ccd060ed$var$OPERA11_PRIORITY = 20;
const $16d401e0ccd060ed$var$CHROME_PRIORITY = 30;
const $16d401e0ccd060ed$var$WINJS_PRIORITY = 40;
const $16d401e0ccd060ed$var$GECKO_PRIORITY = 50;
function $16d401e0ccd060ed$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $9QP64.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $16d401e0ccd060ed$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $16d401e0ccd060ed$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $16d401e0ccd060ed$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $16d401e0ccd060ed$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $16d401e0ccd060ed$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $16d401e0ccd060ed$var$createFrame(filename, (0, $9QP64.UNKNOWN_FUNCTION), +line, +col);
    }
    const parts = $16d401e0ccd060ed$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $16d401e0ccd060ed$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $16d401e0ccd060ed$var$extractSafariExtensionDetails(parts[1] || (0, $9QP64.UNKNOWN_FUNCTION), parts[2]);
        return $16d401e0ccd060ed$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $16d401e0ccd060ed$export$263a749fff749872 = [
    $16d401e0ccd060ed$var$CHROME_PRIORITY,
    $16d401e0ccd060ed$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $16d401e0ccd060ed$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $16d401e0ccd060ed$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $16d401e0ccd060ed$var$gecko = (line)=>{
    const parts = $16d401e0ccd060ed$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $16d401e0ccd060ed$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $9QP64.UNKNOWN_FUNCTION);
        [func, filename] = $16d401e0ccd060ed$var$extractSafariExtensionDetails(func, filename);
        return $16d401e0ccd060ed$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $16d401e0ccd060ed$export$cdba47a5dd2804d = [
    $16d401e0ccd060ed$var$GECKO_PRIORITY,
    $16d401e0ccd060ed$var$gecko
];
const $16d401e0ccd060ed$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $16d401e0ccd060ed$var$winjs = (line)=>{
    const parts = $16d401e0ccd060ed$var$winjsRegex.exec(line);
    return parts ? $16d401e0ccd060ed$var$createFrame(parts[2], parts[1] || (0, $9QP64.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $16d401e0ccd060ed$export$179460296da408e8 = [
    $16d401e0ccd060ed$var$WINJS_PRIORITY,
    $16d401e0ccd060ed$var$winjs
];
const $16d401e0ccd060ed$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $16d401e0ccd060ed$var$opera10 = (line)=>{
    const parts = $16d401e0ccd060ed$var$opera10Regex.exec(line);
    return parts ? $16d401e0ccd060ed$var$createFrame(parts[2], parts[3] || (0, $9QP64.UNKNOWN_FUNCTION), +parts[1]) : undefined;
};
const $16d401e0ccd060ed$export$f892b52c880ffc7a = [
    $16d401e0ccd060ed$var$OPERA10_PRIORITY,
    $16d401e0ccd060ed$var$opera10
];
const $16d401e0ccd060ed$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $16d401e0ccd060ed$var$opera11 = (line)=>{
    const parts = $16d401e0ccd060ed$var$opera11Regex.exec(line);
    return parts ? $16d401e0ccd060ed$var$createFrame(parts[5], parts[3] || parts[4] || (0, $9QP64.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : undefined;
};
const $16d401e0ccd060ed$export$af11af13f09fb0dc = [
    $16d401e0ccd060ed$var$OPERA11_PRIORITY,
    $16d401e0ccd060ed$var$opera11
];
const $16d401e0ccd060ed$export$7197c0fe6554c079 = [
    $16d401e0ccd060ed$export$263a749fff749872,
    $16d401e0ccd060ed$export$cdba47a5dd2804d
];
const $16d401e0ccd060ed$export$2b2b997d81bf3907 = (0, $9QP64.createStackParser)(...$16d401e0ccd060ed$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $16d401e0ccd060ed$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $9QP64.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("6fKHd", function(module, exports) {
$parcel$export(module.exports, "makeFetchTransport", () => $48d85da1743b81eb$export$b2311068c46d7cc8);

var $7TC98 = parcelRequire("7TC98");
var $lHcvp = parcelRequire("lHcvp");

var $hJjV7 = parcelRequire("hJjV7");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $48d85da1743b81eb$export$b2311068c46d7cc8(options, nativeFetch = (0, $hJjV7.getNativeImplementation)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $hJjV7.clearCachedImplementation)('fetch');
            return (0, $lHcvp.rejectedSyncPromise)('No fetch implementation available');
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $hJjV7.clearCachedImplementation)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $lHcvp.rejectedSyncPromise)(e);
        }
    }
    return (0, $7TC98.createTransport)(options, makeRequest);
}

});
parcelRegister("7TC98", function(module, exports) {
$parcel$export(module.exports, "createTransport", () => $5bfb42887babe5d2$export$d09f50d9ab7f7b69);

var $dYTLo = parcelRequire("dYTLo");

var $2YWrS = parcelRequire("2YWrS");

var $aieBB = parcelRequire("aieBB");

var $aGwTQ = parcelRequire("aGwTQ");

var $3Ak4W = parcelRequire("3Ak4W");

var $lHcvp = parcelRequire("lHcvp");
const $5bfb42887babe5d2$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $5bfb42887babe5d2$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $aGwTQ.makePromiseBuffer)(options.bufferSize || $5bfb42887babe5d2$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $2YWrS.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $2YWrS.envelopeItemTypeToDataCategory)(type);
            if ((0, $3Ak4W.isRateLimited)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $lHcvp.resolvedSyncPromise)({});
        const filteredEnvelope = (0, $2YWrS.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $2YWrS.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $2YWrS.envelopeItemTypeToDataCategory)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $2YWrS.serializeEnvelope)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $3Ak4W.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $aGwTQ.SENTRY_BUFFER_FULL_ERROR)) {
                (0, $dYTLo.DEBUG_BUILD) && (0, $aieBB.logger).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $lHcvp.resolvedSyncPromise)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}

});
parcelRegister("aGwTQ", function(module, exports) {
$parcel$export(module.exports, "SENTRY_BUFFER_FULL_ERROR", () => $7c7758cffb95c360$export$c8667f1887a128dc);
$parcel$export(module.exports, "makePromiseBuffer", () => $7c7758cffb95c360$export$85a4f67f852183e6);

var $lHcvp = parcelRequire("lHcvp");
const $7c7758cffb95c360$export$c8667f1887a128dc = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $7c7758cffb95c360$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $lHcvp.rejectedSyncPromise)($7c7758cffb95c360$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $lHcvp.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $lHcvp.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});

parcelRegister("3Ak4W", function(module, exports) {
$parcel$export(module.exports, "isRateLimited", () => $29c44f1488db69bd$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $29c44f1488db69bd$export$699aff705e0d49d4);
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $29c44f1488db69bd$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $29c44f1488db69bd$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $29c44f1488db69bd$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $29c44f1488db69bd$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $29c44f1488db69bd$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $29c44f1488db69bd$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $29c44f1488db69bd$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.['x-sentry-rate-limits'];
    const retryAfterHeader = headers?.['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $29c44f1488db69bd$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});


parcelRegister("hJjV7", function(module, exports) {
$parcel$export(module.exports, "getNativeImplementation", () => $ce86175ff83054df$export$e464f4a514ac28a8);
$parcel$export(module.exports, "clearCachedImplementation", () => $ce86175ff83054df$export$8aa36702e8c8978);

var $gmBzB = parcelRequire("gmBzB");
var $aieBB = parcelRequire("aieBB");

var $c773k = parcelRequire("c773k");

var $lATnS = parcelRequire("lATnS");
/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $ce86175ff83054df$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $ce86175ff83054df$export$e464f4a514ac28a8(name) {
    const cached = $ce86175ff83054df$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $lATnS.WINDOW)[name];
    // Fast path to avoid DOM I/O
    if ((0, $gmBzB.isNativeFunction)(impl)) return $ce86175ff83054df$var$cachedImplementations[name] = impl.bind((0, $lATnS.WINDOW));
    const document = (0, $lATnS.WINDOW).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $c773k.DEBUG_BUILD) && (0, $aieBB.logger).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $ce86175ff83054df$var$cachedImplementations[name] = impl.bind((0, $lATnS.WINDOW));
}
/** Clear a cached implementation. */ function $ce86175ff83054df$export$8aa36702e8c8978(name) {
    $ce86175ff83054df$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $ce86175ff83054df$export$e7aa7bc5c1b3cfb3(...rest) {
    return $ce86175ff83054df$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $ce86175ff83054df$export$831dc9f2ab0a617b(...rest) {
    return $ce86175ff83054df$export$e464f4a514ac28a8('setTimeout')(...rest);
}

});
parcelRegister("c773k", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $8d1b9c0362d33c41$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $8d1b9c0362d33c41$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});



parcelRegister("k3ocW", function(module, exports) {
$parcel$export(module.exports, "checkAndWarnIfIsEmbeddedBrowserExtension", () => $e996dda323e1993d$export$dc236a86065879fc);

var $aieBB = parcelRequire("aieBB");
var $68KEs = parcelRequire("68KEs");

var $d70tI = parcelRequire("d70tI");

var $2NPnx = parcelRequire("2NPnx");
/**
 * Returns true if the SDK is running in an embedded browser extension.
 * Stand-alone browser extensions (which do not share the same data as the main browser page) are fine.
 */ function $e996dda323e1993d$export$dc236a86065879fc() {
    if ($e996dda323e1993d$var$_isEmbeddedBrowserExtension()) {
        if (0, $d70tI.DEBUG_BUILD) (0, $aieBB.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return true;
    }
    return false;
}
function $e996dda323e1993d$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $2NPnx.WINDOW).window === 'undefined') // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const _window = (0, $2NPnx.WINDOW);
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    if (_window.nw) return false;
    const extensionObject = _window['chrome'] || _window['browser'];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $68KEs.getLocationHref)();
    const extensionProtocols = [
        'chrome-extension',
        'moz-extension',
        'ms-browser-extension',
        'safari-web-extension'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = (0, $2NPnx.WINDOW) === (0, $2NPnx.WINDOW).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}://`));
    return !isDedicatedExtensionPage;
}

});



parcelRegister("VveMF", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => (parcelRequire("gHBr3")).ELEMENTS_CONTEXT);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => (parcelRequire("gHBr3")).FabricElementsAnalyticsContext);
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => (parcelRequire("gIXYd")).NAVIGATION_CONTEXT);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("gIXYd")).NavigationAnalyticsContext);
$parcel$export(module.exports, "EDITOR_CONTEXT", () => (parcelRequire("eZjzU")).EDITOR_CONTEXT);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => (parcelRequire("eZjzU")).FabricEditorAnalyticsContext);
$parcel$export(module.exports, "MEDIA_CONTEXT", () => (parcelRequire("5eNit")).MEDIA_CONTEXT);
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => (parcelRequire("bnOHp")).PEOPLE_TEAMS_CONTEXT);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => (parcelRequire("bnOHp")).PeopleTeamsAnalyticsContext);
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => (parcelRequire("dWnHN")).NOTIFICATIONS_CONTEXT);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => (parcelRequire("dWnHN")).NotificationsAnalyticsContext);
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => (parcelRequire("gfdKg")).RECENT_WORK_CONTEXT);
$parcel$export(module.exports, "RecentWorkAnalyticsContext", () => (parcelRequire("gfdKg")).RecentWorkAnalyticsContext);
$parcel$export(module.exports, "ATLAS_CONTEXT", () => (parcelRequire("4wPly")).ATLAS_CONTEXT);
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => (parcelRequire("6aBiE")).TOWNSQUARE_HOME_CONTEXT);
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => (parcelRequire("lJEbl")).LINKING_PLATFORM_CONTEXT);
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => (parcelRequire("8qT9I")).POST_OFFICE_CONTEXT);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => (parcelRequire("8qT9I")).PostOfficeAnalyticsContext);
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => (parcelRequire("gXVee")).AI_MATE_CONTEXT);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => (parcelRequire("gXVee")).AIMateAnalyticsContext);
$parcel$export(module.exports, "AVP_CONTEXT", () => (parcelRequire("6QWke")).AVP_CONTEXT);
$parcel$export(module.exports, "GROWTH_CONTEXT", () => (parcelRequire("empL0")).GROWTH_CONTEXT);
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => (parcelRequire("fffmi")).OMNI_CHANNEL_CONTEXT);
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => (parcelRequire("2cKxF")).ROVO_EXTENSION_CONTEXT);

var $gHBr3 = parcelRequire("gHBr3");

var $gIXYd = parcelRequire("gIXYd");

var $eZjzU = parcelRequire("eZjzU");

var $5eNit = parcelRequire("5eNit");

var $bnOHp = parcelRequire("bnOHp");

var $dWnHN = parcelRequire("dWnHN");

var $gfdKg = parcelRequire("gfdKg");

var $4wPly = parcelRequire("4wPly");

var $6aBiE = parcelRequire("6aBiE");

var $lJEbl = parcelRequire("lJEbl");

var $8qT9I = parcelRequire("8qT9I");

var $gXVee = parcelRequire("gXVee");

var $6QWke = parcelRequire("6QWke");

var $empL0 = parcelRequire("empL0");

var $fffmi = parcelRequire("fffmi");

var $2cKxF = parcelRequire("2cKxF");

});
parcelRegister("gHBr3", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => $6f6de3b982a36eb5$export$80450e0a84a5ede9);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => $6f6de3b982a36eb5$export$3fe25500478a635c);

var $7q4NT = parcelRequire("7q4NT");
const $6f6de3b982a36eb5$export$80450e0a84a5ede9 = 'fabricElementsCtx';
const $6f6de3b982a36eb5$export$3fe25500478a635c = (0, $7q4NT.default)($6f6de3b982a36eb5$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');

});
parcelRegister("7q4NT", function(module, exports) {
$parcel$export(module.exports, "default", () => $97e075b2f566a9df$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $iOTGy = parcelRequire("iOTGy");
const $97e075b2f566a9df$var$createNamespaceContext = (namespace, displayName = 'NamespacedContext')=>{
    const Component = (props)=>{
        const newData = {
            [namespace]: props.data
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $iOTGy.default), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $97e075b2f566a9df$export$2e2bcd8739ae039 = $97e075b2f566a9df$var$createNamespaceContext;

});


parcelRegister("gIXYd", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => $59c9cda187775203$export$1fd3aad76a7c6788);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => $59c9cda187775203$export$d0a82da1a0b94929);

var $7q4NT = parcelRequire("7q4NT");
const $59c9cda187775203$export$1fd3aad76a7c6788 = 'navigationCtx';
const $59c9cda187775203$export$d0a82da1a0b94929 = (0, $7q4NT.default)($59c9cda187775203$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');

});

parcelRegister("eZjzU", function(module, exports) {
$parcel$export(module.exports, "EDITOR_CONTEXT", () => $f51edbce9c86e16b$export$8c8f6d8f1fa796f0);
$parcel$export(module.exports, "EDITOR_APPEARANCE_CONTEXT", () => $f51edbce9c86e16b$export$9eb2b47430ed3f7c);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => $f51edbce9c86e16b$export$629cada6c5e621e1);

var $7q4NT = parcelRequire("7q4NT");
const $f51edbce9c86e16b$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $f51edbce9c86e16b$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    EDITOR_APPEARANCE_CONTEXT["MAX"] = "max";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
const $f51edbce9c86e16b$export$629cada6c5e621e1 = (0, $7q4NT.default)($f51edbce9c86e16b$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');

});

parcelRegister("5eNit", function(module, exports) {
$parcel$export(module.exports, "MEDIA_CONTEXT", () => $6b8dd8e8b79a01d6$export$70df29c238ba7306);
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $6b8dd8e8b79a01d6$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

});

parcelRegister("bnOHp", function(module, exports) {
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => $8efa2812946343f5$export$b326383bee6cb993);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => $8efa2812946343f5$export$4119ddb38ccbfb87);

var $7q4NT = parcelRequire("7q4NT");
const $8efa2812946343f5$export$b326383bee6cb993 = 'peopleTeamsCtx';
const $8efa2812946343f5$export$4119ddb38ccbfb87 = (0, $7q4NT.default)($8efa2812946343f5$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');

});

parcelRegister("dWnHN", function(module, exports) {
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => $266d73b0e84f0a4d$export$da1befb791e93c7e);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => $266d73b0e84f0a4d$export$6f8e7ff1e3feafd7);

var $7q4NT = parcelRequire("7q4NT");
const $266d73b0e84f0a4d$export$da1befb791e93c7e = 'NotificationsCtx';
const $266d73b0e84f0a4d$export$6f8e7ff1e3feafd7 = (0, $7q4NT.default)($266d73b0e84f0a4d$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');

});

parcelRegister("gfdKg", function(module, exports) {
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => $a3b7f69f1da341d6$export$fc7a65795610cb71);
$parcel$export(module.exports, "RecentWorkAnalyticsContext", () => $a3b7f69f1da341d6$export$745926731087ebe2);

var $7q4NT = parcelRequire("7q4NT");
const $a3b7f69f1da341d6$export$fc7a65795610cb71 = 'RecentWorkCtx';
const $a3b7f69f1da341d6$export$745926731087ebe2 = (0, $7q4NT.default)($a3b7f69f1da341d6$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');

});

parcelRegister("4wPly", function(module, exports) {
$parcel$export(module.exports, "ATLAS_CONTEXT", () => $bed1c33b0ffe3e98$export$4906017439f33fc0);

var $7q4NT = parcelRequire("7q4NT");
const $bed1c33b0ffe3e98$export$4906017439f33fc0 = 'atlasCtx';
const $bed1c33b0ffe3e98$export$43ebbe41370d4543 = (0, $7q4NT.default)($bed1c33b0ffe3e98$export$4906017439f33fc0, 'AtlasAnalyticsContext');

});

parcelRegister("6aBiE", function(module, exports) {
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => $ba5f822a0f61e208$export$aa18ab4fff926c9e);

var $7q4NT = parcelRequire("7q4NT");
const $ba5f822a0f61e208$export$aa18ab4fff926c9e = 'townsquareHomeCtx';
const $ba5f822a0f61e208$export$d283110f5d85c8f2 = (0, $7q4NT.default)($ba5f822a0f61e208$export$aa18ab4fff926c9e, 'TownsquareHomeAnalyticsContext');

});

parcelRegister("lJEbl", function(module, exports) {
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => $c46bc5078d043ff3$export$3240443bf2b83834);

var $7q4NT = parcelRequire("7q4NT");
const $c46bc5078d043ff3$export$3240443bf2b83834 = 'linkingPlatformCtx';
const $c46bc5078d043ff3$export$6d568da622ce0a08 = (0, $7q4NT.default)($c46bc5078d043ff3$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');

});

parcelRegister("8qT9I", function(module, exports) {
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => $2a525fd39c14f970$export$ef0c05448f0f8f9);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => $2a525fd39c14f970$export$dcd232f3be312f94);

var $7q4NT = parcelRequire("7q4NT");
const $2a525fd39c14f970$export$ef0c05448f0f8f9 = 'postOfficeCtx';
const $2a525fd39c14f970$export$dcd232f3be312f94 = (0, $7q4NT.default)($2a525fd39c14f970$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');

});

parcelRegister("gXVee", function(module, exports) {
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => $4a730b334a048006$export$5c3a6fd8b96e8b66);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => $4a730b334a048006$export$de3826c30468da26);

var $7q4NT = parcelRequire("7q4NT");
const $4a730b334a048006$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
const $4a730b334a048006$export$de3826c30468da26 = (0, $7q4NT.default)($4a730b334a048006$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');

});

parcelRegister("6QWke", function(module, exports) {
$parcel$export(module.exports, "AVP_CONTEXT", () => $38399eac03211db4$export$c2a811a4e42f4af5);

var $7q4NT = parcelRequire("7q4NT");
const $38399eac03211db4$export$c2a811a4e42f4af5 = 'avpCtx';
const $38399eac03211db4$export$da383e8879a25b03 = (0, $7q4NT.default)($38399eac03211db4$export$c2a811a4e42f4af5, 'AVPAnalyticsContext');

});

parcelRegister("empL0", function(module, exports) {
$parcel$export(module.exports, "GROWTH_CONTEXT", () => $70c7f8d100921eea$export$82023f2f4bfb06c1);

var $7q4NT = parcelRequire("7q4NT");
const $70c7f8d100921eea$export$82023f2f4bfb06c1 = 'editionAwarenessCtx';
const $70c7f8d100921eea$export$84980182680018f = (0, $7q4NT.default)($70c7f8d100921eea$export$82023f2f4bfb06c1, 'GrowthAnalyticsContext');

});

parcelRegister("fffmi", function(module, exports) {
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => $072dbd0bc49ab7c5$export$6d3c48fd1b3e4f3b);

var $7q4NT = parcelRequire("7q4NT");
const $072dbd0bc49ab7c5$export$6d3c48fd1b3e4f3b = 'omniChannelCtx';
const $072dbd0bc49ab7c5$export$e4e6df99270bbbb1 = (0, $7q4NT.default)($072dbd0bc49ab7c5$export$6d3c48fd1b3e4f3b, 'OmniChannelAnalyticsContext');

});

parcelRegister("2cKxF", function(module, exports) {
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => $30ecd2f3ba9a761d$export$fae437eb1dd9520c);

var $7q4NT = parcelRequire("7q4NT");
const $30ecd2f3ba9a761d$export$fae437eb1dd9520c = 'rovoExtensionCtx';
const $30ecd2f3ba9a761d$export$7fcecc25ee38fbef = (0, $7q4NT.default)($30ecd2f3ba9a761d$export$fae437eb1dd9520c, 'RovoExtensionAnalyticsContext');

});


parcelRegister("9hVBA", function(module, exports) {
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $e579863d15fd4810$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $e579863d15fd4810$export$947dac6c72b26f81);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $e579863d15fd4810$export$f1d537d508d2945a);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $e579863d15fd4810$export$12346a674644c156);
$parcel$export(module.exports, "DEFAULT_SOURCE", () => $e579863d15fd4810$export$b055de0e665cb20c);
// same types defined in analytics-web-client but avoid creating dependency with that
const $e579863d15fd4810$export$a1562d08625f5d7e = 'ui';
const $e579863d15fd4810$export$947dac6c72b26f81 = 'track';
const $e579863d15fd4810$export$f1d537d508d2945a = 'screen';
const $e579863d15fd4810$export$12346a674644c156 = 'operational';
const $e579863d15fd4810$export$b055de0e665cb20c = 'unknown';

});

parcelRegister("dQWmt", function(module, exports) {
$parcel$export(module.exports, "default", () => $003556a3594d0f98$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $cc5qg = parcelRequire("cc5qg");

var $dmmsG = parcelRequire("dmmsG");

var $40Sn3 = parcelRequire("40Sn3");

var $2aEiL = parcelRequire("2aEiL");

var $6V50t = parcelRequire("6V50t");

var $5mPNA = parcelRequire("5mPNA");

var $koGM0 = parcelRequire("koGM0");
// Decides whether the hook should be active for the current runtime.
function $003556a3594d0f98$var$computeIsEnabled() {
    const shouldDisable = (0, $2aEiL.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $cc5qg.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $40Sn3.isFedrampModerate)();
    return !shouldDisable;
}
// Module-level identity wrapper used when the hook is disabled. Stable
// identity avoids causing unnecessary re-renders / effect re-runs in
// downstream consumers.
const $003556a3594d0f98$var$identityUrlWrapper = (url)=>url;
/**
 * This React hook is called with the correct bridge, product and sub-product parameters.
 * It returns a function that can be used to generate URLs with cross-product interaction parameters.
 *
 * - Lazy-initialises the session id from the client on the very first render,
 *   eliminating the post-mount re-render that re-generated the `xpis` query
 *   param.
 * - Returns a stable, memoised wrapper so consumer effects keyed on it do not
 *   re-run on unrelated re-renders.
 *
 * See PIRA-3829.
 *
 * @param options - Properties object that contains the following parameters:
 *
 * @returns A function that appends interaction session ID and other cross-product interaction parameters to a given URL.
 */ function $003556a3594d0f98$var$useCrossProductUrl(options) {
    const { bridge: bridge, product: product, subProduct: subProduct } = options;
    const isEnabled = $003556a3594d0f98$var$computeIsEnabled();
    const interactionSessionClient = (0, $1v5pe.useMemo)(()=>{
        if (isEnabled) return new (0, $6V50t.default)();
        else return null;
    }, [
        isEnabled
    ]);
    const [interactionSessionId, setInteractionSessionId] = (0, $1v5pe.useState)(()=>{
        if (isEnabled && interactionSessionClient) return interactionSessionClient.getCurrentInteractionSessionId() ?? '';
        return '';
    });
    (0, $1v5pe.useEffect)(()=>{
        if (interactionSessionClient && isEnabled) {
            // The lazy useState initializer above already read the session id on the
            // very first render, so we do NOT re-read here — that would cause the
            // avoidable post-mount re-render this fix is removing.
            const unbind = (0, $dmmsG.bind)(document, {
                type: (0, $koGM0.INTERACTION_SESSION_ID_UPDATED_EVENT),
                listener: ()=>{
                    const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
                    if (currentSessionId) setInteractionSessionId((prev)=>prev === currentSessionId ? prev : currentSessionId);
                }
            });
            return unbind;
        }
        return ()=>{};
    }, [
        interactionSessionClient,
        isEnabled
    ]);
    const wrapUrl = (0, $1v5pe.useCallback)((url)=>(0, $5mPNA.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct), [
        bridge,
        interactionSessionId,
        product,
        subProduct
    ]);
    if (!isEnabled) return $003556a3594d0f98$var$identityUrlWrapper;
    return wrapUrl;
}
var $003556a3594d0f98$export$2e2bcd8739ae039 = $003556a3594d0f98$var$useCrossProductUrl;

});

parcelRegister("jRW1x", function(module, exports) {
$parcel$export(module.exports, "fireCustomCrossAppAnalytic", () => $7a5f3561eb1f7db2$export$f182130953438e47);
const $7a5f3561eb1f7db2$export$f182130953438e47 = ({ tags: tags, destinationApp: destinationApp, createAnalyticsEvent: createAnalyticsEvent, analyticsEventFireName: analyticsEventFireName, bridge: bridge, source: source, actionSubjectId: actionSubjectId })=>{
    const analyticsEvent = createAnalyticsEvent({
        action: 'customCrossAppExperience',
        actionSubject: 'viewed',
        actionSubjectId: actionSubjectId,
        eventType: 'ui',
        tags: tags,
        attributes: {
            bridge: bridge,
            source: source,
            destinationApp: destinationApp
        }
    });
    analyticsEvent.fire(analyticsEventFireName);
};

});


//# sourceMappingURL=ConversationAssistant.88eb5f9e.js.map
